webpackJsonp([191],{

/***/ "+1yJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 5,
  path: '/hiddenCheck',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/hiddenCheck/hidenList/majorHideen',
  name: 'hiddenCheck',
  isHead: true,
  meta: {
    title: '隐患排查',
    icon: 'el-icon-connection'
  },
  children: [{
    path: 'hidenList',
    component: function component() {
      return __webpack_require__.e/* import() */(178).then(__webpack_require__.bind(null, "B2Mc"));
    },
    name: 'HiddenCheck',
    meta: { title: '隐患排查', close: false },
    children: [
    //检查清单维护
    {
      path: 'hideenMaintain',
      name: 'hideenMaintain',
      component: function component() {
        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "SFNC"));
      },
      meta: { title: '行业领域检查清单', next: '/hiddenCheck/hidenList/meshWelding', close: true }
    }, {
      path: 'meshWelding',
      name: 'meshWelding',
      component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "i7IS"));
      },
      meta: { title: '网格员检查导则', next: '/hiddenCheck/hidenList/specialList', close: true }
    }, {
      path: 'specialList',
      name: 'specialList',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "HmMP"));
      },
      meta: { title: '专项检查清单', next: '/hiddenCheck/hidenList/dangerList', close: true }
    }, {
      path: 'dangerList',
      name: 'dangerList',
      component: function component() {
        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "Nt/Y"));
      },
      meta: { title: '重大隐患检查清单', next: '/hiddenCheck/hidenList/mainCheckList', close: true }
    }, {
      path: 'mainCheckList',
      name: 'mainCheckList',
      component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "JQvs"));
      },
      meta: { title: '主体责任检查清单', next: '/hiddenCheck/hidenList/checkList', close: true }
    },
    //企业自查整改
    {
      path: 'checkList',
      component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "m/m8"));
      },
      name: 'checkList',
      meta: { title: '检查清单', next: '/hiddenCheck/hidenList/hidenList', close: false }
    }, {
      path: 'hidenList',
      name: 'hidenList',
      component: function component() {
        return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "gIhO"));
      },
      meta: { title: '隐患清单', next: '/hiddenCheck/hidenList/securityCheck', close: true }
    }, {
      path: 'securityCheck',
      component: function component() {
        return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, "jceM"));
      },
      name: 'securityCheck',
      meta: { title: '整改清单', next: '/hiddenCheck/hidenList/majorHideen', close: false }
    },
    //重大隐患管理
    {
      path: 'majorHideen',
      name: 'majorHideen',
      component: function component() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "pzbv"));
      },
      meta: { title: '重大隐患管理', next: '/hiddenCheck/hidenList/supervision', close: true }
    }, {
      path: 'supervision',
      name: 'supervision',
      component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "QWr/"));
      },
      meta: { title: '监督检查管理', close: true }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "+5CF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__("6AZ4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c125646_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__("QETk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c125646_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+5qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"title":_vm.formTitle,"visible":_vm.dialogFormVisible,"width":"40%"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.ruleForm,"label-width":"120px","status-icon":""}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"20px"}},[_c('div',{staticStyle:{"width":"4px","height":"20px","background-color":"#409EFF","margin-right":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v("基本信息")])]),_vm._v(" "),(_vm.userInfo.department_id == 0 && _vm.userInfo.town_id == 0)?[_c('el-form-item',{attrs:{"label":"名称：","prop":"nick_name"}},[_vm._v("\n        "+_vm._s(_vm.userInfo.nick_name)+"\n      ")]),_vm._v(" "),_c('el-form-item',[_c('span',{staticStyle:{"margin-left":"-50px"}},[_vm._v("管理员账号")])])]:_vm._e(),_vm._v(" "),(_vm.userInfo.department_id != 0)?_c('el-form-item',{attrs:{"label":"名称：","prop":"nick_name"}},[_vm._v("\n      "+_vm._s(_vm.userInfo.department ? _vm.userInfo.department.name ? _vm.userInfo.department.name : '' : '')+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.userInfo.department_id != 0)?_c('el-form-item',{attrs:{"label":"部门：","prop":"tree_name"}},[_vm._v("\n      "+_vm._s(_vm.userInfo.department ? _vm.userInfo.department.tree_name : '')+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.userInfo.department_id != 0)?_c('el-form-item',{attrs:{"label":"监管对象：","prop":"control_name"}},[_vm._v("\n      "+_vm._s(_vm.userInfo.department ? _vm.userInfo.department.control_name : '')+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.userInfo.town_id != 0)?_c('el-form-item',{attrs:{"label":"乡镇：","prop":"name"}},[_vm._v("\n      "+_vm._s(_vm.userInfo.town ? _vm.userInfo.town.name ? _vm.userInfo.town.name : '' : '')+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.userInfo.town_id)?_c('el-form-item',{attrs:{"label":"监管对象：","prop":"name"}},[_c('span',[_vm._v("全部行业企业")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"20px"}},[_c('div',{staticStyle:{"width":"4px","height":"20px","background-color":"#409EFF","margin-right":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v("联系信息")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系姓名","prop":"contact_name"}},[_c('label',{attrs:{"slot":"label"},slot:"label"},[_vm._v("联系姓名：")]),_vm._v(" "),_c('el-input',{model:{value:(_vm.ruleForm.contact_name),callback:function ($$v) {_vm.$set(_vm.ruleForm, "contact_name", $$v)},expression:"ruleForm.contact_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系电话","prop":"contact"}},[_c('label',{attrs:{"slot":"label"},slot:"label"},[_vm._v("联系电话：")]),_vm._v(" "),_c('el-input',{model:{value:(_vm.ruleForm.contact),callback:function ($$v) {_vm.$set(_vm.ruleForm, "contact", $$v)},expression:"ruleForm.contact"}})],1)],2),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submitForm}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Ij5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABOFJREFUaEPtmHvIn2MYxz9fhszEWA4tNEQhaVpJLRJDshzGYhOykpwPc8xKU5tTEQ2RHIZSEyZkcqixFEMaqyGkmUOIOcel79v90/P+/J7nvp/f+/7SW7v+fJ7ruu7re1+H+3vfYoyLxnj8bALwf2dwYBmIiEuBy4CtgPslXTsIsAMBEBFXAjd1Bfy0pBNGG8SgAPwNPftrnKS/RhPEqAGIiC2BA4CjgMU1Qd4OPA6slfTjaAAZMYCI2AOYDVwC7FoY1PfAvcDDkj4stOmp1jeAiLCtG3NhTbmUxrUEuE7SD6UGVb2+AESES2UZsE8/i/aw+RY4TdJLbf21BhARhwOvtF2oUH+upEcLdYfUWgGIiEOB19ss0IfuHEmPldoVA4iIvYB1bUGXBtKld4Skoiy3AfAFMLlFQF8Dru0AdgR2aWHrc2S8pN9zNkUAImIBcEPOGfAL4Bp+EHi7E0BEbAHs60YF5gE7Ffh6StKJOb0sgIjYHvDczsnzwFmSvPO1EhHjgbuAs3MOgf0lfdCkVwKgF6/p9rlE0vndHyNiN2AzYL2kP6v/I+Jy4NYMiOWSZvYNIKX+O2BCg5MVkmZ0/kfEOMBM9Fxgz9T0XyYKsUiS+2JIIuIO4KIG3+ZN7oU/6nQaMxARU4BPGhZws02Q9GsKaBKwCti7xsal6AnzbgWEv7lM62SmpOWtAaTdd5oXNTh/QNI5lWAM1qCbxLs5SdJPCfSZqenrbJ5Np/TGXgo9MxARVwMXF4y+qZLeSYFcAdySCb7ze5mkWcnOE+mrjJ150kOSTBiHyX8ARIRr0rWZk28kDY3DlC1Pn6ZSqPpzbW9TGbOfAbvnFkzs1Rn7V3oB+C1dA3P+1kgyqTMAU+pPcwZd/w+S9F6yfw44tsRe0rCYewHwyVki70s6MAXgafNxiVFFZ5qkt5L9M8DxJfYlAHybuqrA2QZJQxeYiNg60QYfUiXiEppYaWRzrLrJVfX3oqSjG0soBWSuf1JBJFMkDZVORPi66MYvkVWSzGxttx1Qcpl5A5gh6ecsgOTY7PPCTFCLJV1TCcTTxM8oOdmvc5WMiOMAj8o6MX2fJ2ltL4XcQea0Or11slHStp2fETEV8K1qYoPNbElPVGzcO+6hOjldkh8CekoOgCmEXw+a9JZKOqMSkE9jkzXf3HZO310iq00bJK2p6LrX6l4wOmruldoSKyFzNwPzMzUxX9IwYpaeWUyhzY3WSRp2kkaEqfKTGb8rJU1v0ikB4EmzPlfUiVleL8nnSKNEhJvdTZ+T6ZJWjgiAjSPivnQRyS1ooL78vCbpo6pyRPikdY/caJ6fcwS8KemQnF42AwmAOb1vWyUTprPm54AfrXwwehh4qhWtlxxMlpTNfLHDiDgMeDW3I6P0/zxJ95T4KgaQMjEHWFrieAQ6CyW5DIukFYAEYi7wSJH39koLJPmpslhaA0ggzEd8uDQdWMVBAL7ZXSDp7jZG1u0LQAKxA+AFT227aJf+y74/d0+tUp99A+gsEBHTEns9EjAxKxE/WHkg3CZpRYlBnc6IAVSAOPhjgFOAk2sW9G67f16QtGEkgXdsRw1ANZiIqLsUNfKafgANCsCdbsqugFZLOrifIJtsBgIgNbnfR831NwfMZ2Y1PVD1C2xgAPoNqK3dJgBtd2y09cd8Bv4BNzSPQB2y9lUAAAAASUVORK5CYII="

/***/ }),

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+pgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$getChanges = function (params, type, module, dataClass, oldForm) {
      var changedata = {};
      for (var key in oldForm) {
        if (oldForm[key] !== params[key]) {
          changedata[key] = params[key];
        }
      }
      // let module = 'security'
      var obj = {
        'id': params.id,
        'type': type,
        'data': changedata
        // let data_class = 'SafetyEngineer'
      };
    };
  }
});

/***/ }),

/***/ "//7k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return controlMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return safeMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showUnitMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return principleMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return controlNameMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return controlComplianceMap; });
// 风险评估页面映射
var controlMap = {
        '101': 'Chemical',
        '102': 'Chemical',
        '103': 'Chemical',
        '104': 'Chemical',
        '105': 'Chemical',
        '106': 'Chemical',
        '107': 'Industrial',
        '108': 'Industrial',
        '109': 'Boom',
        '110': 'Industrial',
        '111': 'Industrial',
        '112': 'Industrial',
        '113': 'Chemical',
        '114': 'SurfaceMine',
        '115': 'UndergroundMine',
        '116': 'TailingsPond',
        '117': 'Fireworks',
        '118': 'Port',
        '119': 'RailFreight',
        '120': 'Construction',
        '121': 'Industrial',
        '122': 'Chemical',
        '123': 'Industrial',
        '124': 'Industrial',
        '126': 'Industrial',
        '127': 'Industrial',
        '128': 'Industrial',
        '129': 'Industrial',
        '132': 'Construction',
        '133': 'Construction',
        '134': 'Construction',
        '135': 'Construction',
        '136': 'Boom',
        '137': 'Industrial',
        '138': 'Port',
        '141': 'Chemical',
        '201': 'Restaurant',
        '202': 'Hospital',
        '203': 'Tower',
        '204': 'Religion',
        '205': 'Stadium',
        '206': 'TouristPlaces',
        '207': 'School',
        '208': 'Hotel',
        '209': 'ElderlyInstitution',
        '210': 'Cultural',
        '211': 'Market',
        '212': 'VillageInCity',
        '213': 'School',
        '214': 'Cultural',
        '215': 'Cultural',
        '216': 'Hotel',
        '217': 'Market',
        '229': 'DrivingSchool',
        '301': 'Bridge',
        '302': 'Tunnel',
        '303': 'Dam',
        '304': 'Station',
        '305': 'RoadTransport',
        '306': 'GasAndChemicals',
        '307': 'Pipeline',
        '308': 'DangerRoadTransport',
        '309': 'ConstructionWaste',
        '310': 'Fishery',
        '312': 'CityLitter',
        '313': 'BulkMaterial',
        '314': 'Highway',
        '315': 'Highway',
        '316': 'Industrial',
        '317': 'Industrial',
        '318': 'RiskHydropowerStation',
        '319': 'RoadTransport',
        '320': 'WaterwayPassenger',
        '335': 'WaterwayFreightage'
        // 安全基本信息页面映射
};var safeMap = {
        '101': 'Chemical',
        '102': 'Chemical',
        '103': 'Chemical',
        '104': 'GasStation',
        '105': 'NaturalGas',
        '106': 'NaturalGas',
        '107': 'Metallurgy',
        '108': 'Metallurgy',
        '109': 'Explosion',
        '110': 'Weave',
        '111': 'Weave',
        '112': 'Weave',
        '113': 'Electricity',
        '114': 'SurfaceMine',
        '115': 'SurfaceMine',
        '116': 'SurfaceMine',
        '117': 'FireWork',
        '118': 'Port',
        '119': 'RailFreightBase',
        '120': 'ConstructionBase',
        '121': 'Weave',
        '122': 'Chemical',
        '123': 'Weave',
        '124': 'Weave',
        '126': 'Weave',
        '127': 'Weave',
        '128': 'Weave',
        '129': 'Weave',
        '132': 'ConstructionBase',
        '133': 'ConstructionBase',
        '134': 'ConstructionBase',
        '135': 'ConstructionBase',
        '136': 'Explosion',
        '137': 'Weave',
        '138': 'Port',
        '141': 'GasStation',
        '201': 'Restaurant',
        '202': 'Hospital',
        '203': 'Tower',
        '204': 'Religion',
        '205': 'CrowdedPlace',
        '206': 'TouristPlace',
        '207': 'School',
        '208': 'Hotel',
        '209': 'CrowdedPlace',
        '210': 'CrowdedPlace',
        '211': 'Market',
        '212': 'VillageInCity',
        '213': 'School',
        '214': 'CrowdedPlace',
        '215': 'CrowdedPlace',
        '216': 'Hotel',
        '217': 'Trade',
        '229': 'DrivingSchool',
        '301': 'Bridge',
        '302': 'Tunnel',
        '303': 'Dam',
        '304': 'Station',
        '305': 'RoadTransport',
        '306': 'GasAndChemicals',
        '307': 'Pipeline',
        '308': 'DangerRoadTransport',
        '309': 'ConstructionWaste',
        '310': 'Fishery',
        '312': 'Electricity',
        '313': 'BulkMaterial',
        '314': 'Highway',
        '315': 'Highway',
        '316': 'Weave',
        '317': 'Weave',
        '318': 'Electricity',
        '319': 'RoadTransport',
        '320': 'WaterwayPassenger',
        '335': 'WaterwayFreightage'
        // 是否划分单元
};var showUnitMap = {
        '101': true,
        '102': true,
        '103': true,
        '104': true,
        '105': true,
        '106': true,
        '107': true,
        '108': true,
        '109': true,
        '110': true,
        '111': true,
        '112': true,
        '113': true,
        '114': true,
        '115': true,
        '116': true,
        '117': true,
        '118': true,
        '119': true,
        '120': true,
        '121': true,
        '122': true,
        '123': true,
        '124': true,
        '126': true,
        '127': true,
        '128': true,
        '129': true,
        '132': true,
        '133': true,
        '134': true,
        '135': true,
        '136': true,
        '137': true,
        '138': true,
        '141': true,
        '201': true,
        '202': true,
        '203': true,
        '204': true,
        '205': true,
        '206': true,
        '207': true,
        '208': true,
        '209': true,
        '210': false,
        '211': true,
        '212': false,
        '213': true,
        '214': false,
        '215': false,
        '216': true,
        '217': true,
        '229': true,
        '301': true,
        '302': true,
        '303': true,
        '304': false,
        '305': true,
        '306': false,
        '307': false,
        '308': true,
        '309': false,
        '310': false,
        '312': true,
        '313': true,
        '314': true,
        '315': true,
        '316': true,
        '317': true,
        '318': true,
        '319': true,
        '320': false,
        '335': false
        // 单元划分原则
};var IndustrialPrinciple = '\uFF081\uFF09\u9488\u5BF9\u4F01\u4E1A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u751F\u4EA7\u5DE5\u827A\u3001\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n                              \uFF082\uFF09\u5371\u9669\u5316\u5B66\u54C1\u50A8\u7F50\u4EE5\u7F50\u7EC4\u9632\u706B\u5824\u4E3A\u5355\u5143\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n                              \uFF083\uFF09\u751F\u4EA7\u88C5\u7F6E\u4EE5\u9632\u706B\u5206\u533A\u4E3A\u72EC\u7ACB\u5355\u5143\u8FDB\u884C\u5212\u5206\uFF0C\u4E0E\u751F\u4EA7\u88C5\u7F6E\u6BD7\u90BB\u5E03\u7F6E\u3001\u7D27\u5BC6\u76F8\u8054\u7684\u8F85\u52A9\u4E2D\u95F4\u50A8\u7F50\u3001\u8BBE\u5907\u8BBE\u65BD\u7B49\u4E0E\u751F\u4EA7\u88C5\u7F6E\u5212\u5206\u4E3A\u540C\u4E00\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n                              \uFF084\uFF09\u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n                              \uFF085\uFF09\u751F\u4EA7\u5382\u623F\u4EE5\u6709\u660E\u663E\u9632\u706B\u5212\u5206\u7684\u72EC\u7ACB\u5EFA\u7B51\u4E3A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n                              \uFF086\uFF09\u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n                              \uFF087\uFF09\u975E\u751F\u4EA7\u3001\u50A8\u5B58\u6027\u7684\u4F01\u4E1A\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002';
var commonPrinciple = '\uFF081\uFF09\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n                          \uFF082\uFF09\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002';
var principleMap = {
        '101': IndustrialPrinciple,
        '102': IndustrialPrinciple,
        '103': IndustrialPrinciple,
        '104': IndustrialPrinciple,
        '105': IndustrialPrinciple,
        '106': IndustrialPrinciple,
        '107': IndustrialPrinciple,
        '108': IndustrialPrinciple,
        '109': '\uFF081\uFF09\u9488\u5BF9\u4F01\u4E1A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u751F\u4EA7\u5DE5\u827A\u3001\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u5371\u9669\u5316\u5B66\u54C1\u50A8\u7F50\u4EE5\u7F50\u7EC4\u9632\u706B\u5824\u4E3A\u5355\u5143\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u751F\u4EA7\u88C5\u7F6E\u4EE5\u9632\u706B\u5206\u533A\u4E3A\u72EC\u7ACB\u5355\u5143\u8FDB\u884C\u5212\u5206\uFF0C\u4E0E\u751F\u4EA7\u88C5\u7F6E\u6BD7\u90BB\u5E03\u7F6E\u3001\u7D27\u5BC6\u76F8\u8054\u7684\u8F85\u52A9\u4E2D\u95F4\u50A8\u7F50\u3001\u8BBE\u5907\u8BBE\u65BD\u7B49\u4E0E\u751F\u4EA7\u88C5\u7F6E\u5212\u5206\u4E3A\u540C\u4E00\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF084\uFF09\u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF085\uFF09\u751F\u4EA7\u5382\u623F\u4EE5\u6709\u660E\u663E\u9632\u706B\u5212\u5206\u7684\u72EC\u7ACB\u5EFA\u7B51\u4E3A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF086\uFF09\u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002',
        '110': IndustrialPrinciple,
        '111': IndustrialPrinciple,
        '112': IndustrialPrinciple,
        '113': IndustrialPrinciple,
        '114': '\uFF081\uFF09\u4F9D\u636E\u4F01\u4E1A\u5404\u533A\u57DF\u3001\u573A\u6240\u529F\u80FD\u7528\u9014\u7684\u4E0D\u540C\u5212\u5206\u4E3A\u77FF\u5916\u5355\u5143\u548C\u77FF\u5C71\uFF08\u5E93\uFF09\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u77FF\u5916\u5355\u5143\u5305\u62EC\u8FD0\u8F93\u3001\u52A0\u5DE5\u533A\u57DF\uFF0C\u662F\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\uFF0C\u5176\u4E2D\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002\n        <div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u77FF\u5C71\uFF08\u5E93\uFF09\u5185\u53EF\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u98CE\u9669\u5355\u5143\u3002',
        '115': '\uFF081\uFF09\u4F9D\u636E\u4F01\u4E1A\u5404\u533A\u57DF\u3001\u573A\u6240\u529F\u80FD\u7528\u9014\u7684\u4E0D\u540C\u5212\u5206\u4E3A\u77FF\u5916\u5355\u5143\u548C\u77FF\u5C71\uFF08\u5E93\uFF09\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u77FF\u5916\u5355\u5143\u5305\u62EC\u8FD0\u8F93\u3001\u52A0\u5DE5\u533A\u57DF\uFF0C\u662F\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\uFF0C\u5176\u4E2D\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002\n        <div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u77FF\u5C71\uFF08\u5E93\uFF09\u5185\u53EF\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u98CE\u9669\u5355\u5143\u3002',
        '116': '',
        '117': '\uFF081\uFF09\u9488\u5BF9\u4F01\u4E1A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002',
        '118': '\uFF081\uFF09\u9488\u5BF9\u6E2F\u53E3\u7ECF\u8425\u4F01\u4E1A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u4E3B\u8981\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7801\u5934\uFF08\u542B\u6CCA\u4F4D\uFF09\u3001\u5806\u573A\u3001\u7F50\u533A\u3001\u4ED3\u5E93\u3001\u529E\u516C\u697C\u53CA\u751F\u4EA7\u9644\u5C5E\u8BBE\u65BD\u7B49\u3002\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u751F\u4EA7\u5DE5\u827A\u3001\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u50A8\u7F50\u533A\u4EE5\u7F50\u7EC4\u9632\u706B\u5824\u4E3A\u5355\u5143\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u7801\u5934\uFF08\u542B\u6CCA\u4F4D\uFF09\u4EE5\u7A7A\u95F4\u76F8\u5BF9\u72EC\u7ACB\u6027\uFF0C\u5212\u5206\u4E3A\u4E0D\u540C\u7684\u7801\u5934\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF084\uFF09\u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF085\uFF09\u96C6\u88C5\u7BB1\u5806\u573A\u548C\u6563\u8D27\u5806\u573A\u4EE5\u5177\u6709\u6D88\u9632\u529F\u80FD\u7684\u652F\u9053\u4E3A\u754C\u9650\u8FDB\u884C\u5355\u5143\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \uFF086\uFF09\u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002',
        '119': '\u2460 \u9488\u5BF9\u94C1\u8DEF\u8D27\u8FD0\u7AD9\u573A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u4E3B\u8981\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u88C5\u5378\u7AD9\u53F0\u3001\u7F50\u533A\u3001\u4ED3\u5E93\u3001\u529E\u516C\u697C\u53CA\u9644\u5C5E\u8BBE\u65BD\u7B49\u3002\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u751F\u4EA7\u5DE5\u827A\u3001\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n          \u2461 \u88C5\u5378\u4E13\u7528\u4F5C\u4E1A\u533A\u57DF\u53EF\u5212\u5206\u4E3A\u72EC\u7ACB\u7684\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \u2462 \u50A8\u7F50\u533A\u4EE5\u7F50\u7EC4\u9632\u706B\u5824\u4E3A\u5355\u5143\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \u2464 \u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \u2465 \u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002',
        '120': '\uFF081\uFF09\u4F9D\u636E\u5EFA\u8BBE\u9879\u76EE\u65BD\u5DE5\u603B\u5E73\u9762\u56FE\u5212\u5206\u4E3A\u529E\u516C\u751F\u6D3B\u533A\u548C\u65BD\u5DE5\u4F5C\u4E1A\u533A\u4E24\u7C7B\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u529E\u516C\u751F\u6D3B\u533A\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u65BD\u5DE5\u4F5C\u4E1A\u533A\u53EF\u6574\u4F53\u4F5C\u4E3A\u65BD\u5DE5\u4F5C\u4E1A\u533A\u98CE\u9669\u5355\u5143\u3002',
        '121': IndustrialPrinciple,
        '122': IndustrialPrinciple,
        '123': IndustrialPrinciple,
        '124': IndustrialPrinciple,
        '126': IndustrialPrinciple,
        '127': IndustrialPrinciple,
        '128': IndustrialPrinciple,
        '129': IndustrialPrinciple,
        '132': '\uFF081\uFF09\u4F9D\u636E\u5EFA\u8BBE\u9879\u76EE\u65BD\u5DE5\u603B\u5E73\u9762\u56FE\u5212\u5206\u4E3A\u529E\u516C\u751F\u6D3B\u533A\u548C\u65BD\u5DE5\u4F5C\u4E1A\u533A\u4E24\u7C7B\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u529E\u516C\u751F\u6D3B\u533A\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u65BD\u5DE5\u4F5C\u4E1A\u533A\u53EF\u6574\u4F53\u4F5C\u4E3A\u65BD\u5DE5\u4F5C\u4E1A\u533A\u98CE\u9669\u5355\u5143\u3002',
        '133': '\uFF081\uFF09\u4F9D\u636E\u5EFA\u8BBE\u9879\u76EE\u65BD\u5DE5\u603B\u5E73\u9762\u56FE\u5212\u5206\u4E3A\u529E\u516C\u751F\u6D3B\u533A\u548C\u65BD\u5DE5\u4F5C\u4E1A\u533A\u4E24\u7C7B\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u529E\u516C\u751F\u6D3B\u533A\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u65BD\u5DE5\u4F5C\u4E1A\u533A\u53EF\u6574\u4F53\u4F5C\u4E3A\u65BD\u5DE5\u4F5C\u4E1A\u533A\u98CE\u9669\u5355\u5143\u3002',
        '134': '\uFF081\uFF09\u4F9D\u636E\u5EFA\u8BBE\u9879\u76EE\u65BD\u5DE5\u603B\u5E73\u9762\u56FE\u5212\u5206\u4E3A\u529E\u516C\u751F\u6D3B\u533A\u548C\u65BD\u5DE5\u4F5C\u4E1A\u533A\u4E24\u7C7B\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u529E\u516C\u751F\u6D3B\u533A\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u65BD\u5DE5\u4F5C\u4E1A\u533A\u53EF\u6574\u4F53\u4F5C\u4E3A\u65BD\u5DE5\u4F5C\u4E1A\u533A\u98CE\u9669\u5355\u5143\u3002',
        '135': '\uFF081\uFF09\u4F9D\u636E\u5EFA\u8BBE\u9879\u76EE\u65BD\u5DE5\u603B\u5E73\u9762\u56FE\u5212\u5206\u4E3A\u529E\u516C\u751F\u6D3B\u533A\u548C\u65BD\u5DE5\u4F5C\u4E1A\u533A\u4E24\u7C7B\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u529E\u516C\u751F\u6D3B\u533A\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u65BD\u5DE5\u4F5C\u4E1A\u533A\u53EF\u6574\u4F53\u4F5C\u4E3A\u65BD\u5DE5\u4F5C\u4E1A\u533A\u98CE\u9669\u5355\u5143\u3002',
        '136': '\uFF081\uFF09\u9488\u5BF9\u4F01\u4E1A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u751F\u4EA7\u5DE5\u827A\u3001\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u5371\u9669\u5316\u5B66\u54C1\u50A8\u7F50\u4EE5\u7F50\u7EC4\u9632\u706B\u5824\u4E3A\u5355\u5143\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u751F\u4EA7\u88C5\u7F6E\u4EE5\u9632\u706B\u5206\u533A\u4E3A\u72EC\u7ACB\u5355\u5143\u8FDB\u884C\u5212\u5206\uFF0C\u4E0E\u751F\u4EA7\u88C5\u7F6E\u6BD7\u90BB\u5E03\u7F6E\u3001\u7D27\u5BC6\u76F8\u8054\u7684\u8F85\u52A9\u4E2D\u95F4\u50A8\u7F50\u3001\u8BBE\u5907\u8BBE\u65BD\u7B49\u4E0E\u751F\u4EA7\u88C5\u7F6E\u5212\u5206\u4E3A\u540C\u4E00\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF084\uFF09\u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF085\uFF09\u751F\u4EA7\u5382\u623F\u4EE5\u6709\u660E\u663E\u9632\u706B\u5212\u5206\u7684\u72EC\u7ACB\u5EFA\u7B51\u4E3A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF086\uFF09\u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002',
        '137': IndustrialPrinciple,
        '138': '\uFF081\uFF09\u9488\u5BF9\u6E2F\u53E3\u7ECF\u8425\u4F01\u4E1A\u7684\u529F\u80FD\u5206\u533A\u548C\u603B\u5E73\u9762\u5E03\u7F6E\uFF0C\u4ECE\u7A7A\u95F4\u4E0A\u5C06\u4F01\u4E1A\u5212\u5206\u4E3A\u82E5\u5E72\u5355\u5143\uFF0C\u4E3B\u8981\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7801\u5934\uFF08\u542B\u6CCA\u4F4D\uFF09\u3001\u5806\u573A\u3001\u7F50\u533A\u3001\u4ED3\u5E93\u3001\u529E\u516C\u697C\u53CA\u751F\u4EA7\u9644\u5C5E\u8BBE\u65BD\u7B49\u3002\u5355\u5143\u5212\u5206\u5E94\u6DB5\u76D6\u4F01\u4E1A\u603B\u5E73\u9762\u5E03\u7F6E\u5185\u6D89\u53CA\u751F\u4EA7\u5DE5\u827A\u3001\u8BBE\u5907\u8BBE\u65BD\u3001\u4F5C\u4E1A\u73AF\u8282\u7684\u5168\u90E8\u8303\u56F4\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u50A8\u7F50\u533A\u4EE5\u7F50\u7EC4\u9632\u706B\u5824\u4E3A\u5355\u5143\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u7801\u5934\uFF08\u542B\u6CCA\u4F4D\uFF09\u4EE5\u7A7A\u95F4\u76F8\u5BF9\u72EC\u7ACB\u6027\uFF0C\u5212\u5206\u4E3A\u4E0D\u540C\u7684\u7801\u5934\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF084\uFF09\u4ED3\u5E93\u4EE5\u72EC\u7ACB\u5E93\u623F\uFF08\u72EC\u7ACB\u5EFA\u7B51\u7269\uFF09\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF085\uFF09\u96C6\u88C5\u7BB1\u5806\u573A\u548C\u6563\u8D27\u5806\u573A\u4EE5\u5177\u6709\u6D88\u9632\u529F\u80FD\u7684\u652F\u9053\u4E3A\u754C\u9650\u8FDB\u884C\u5355\u5143\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n          \uFF086\uFF09\u5176\u4ED6\u529E\u516C\u697C\u3001\u6D88\u9632\u6CF5\u623F\u3001\u914D\u7535\u5BA4\u7B49\u8F85\u52A9\u6027\u8BBE\u65BD\u4EE5\u72EC\u7ACB\u7684\u5EFA\u7B51\u8FDB\u884C\u5212\u5206\u3002',
        '141': IndustrialPrinciple,
        '201': commonPrinciple,
        '202': commonPrinciple,
        '203': '\uFF081\uFF09\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002',
        '204': commonPrinciple,
        '205': commonPrinciple,
        '206': '\uFF081\uFF09\u4F9D\u636E\u56ED\uFF08\u666F\uFF09\u533A\u5404\u533A\u57DF\u3001\u573A\u6240\u529F\u80FD\u7528\u9014\u7684\u4E0D\u540C\u8FDB\u884C\u5212\u5206\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u9664\u72EC\u7ACB\u5EFA\u7B51\u7269\u9700\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u5916\u3002\u56ED\uFF08\u666F\uFF09\u533A\u5176\u4ED6\u533A\u57DF\u53EF\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u98CE\u9669\u5355\u5143\u3002',
        '207': commonPrinciple,
        '208': commonPrinciple,
        '209': '\uFF081\uFF09\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143',
        '210': '',
        '211': commonPrinciple,
        '212': '',
        '213': commonPrinciple,
        '214': '',
        '215': '',
        '216': commonPrinciple,
        '217': commonPrinciple,
        '229': '',
        '301': '',
        '302': '',
        '303': '',
        '304': '',
        '305': '\uFF081\uFF09\u98CE\u9669\u5355\u5143\u5206\u4E3A\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u548C\u8FD0\u8F93\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u8FD0\u8F93\u5355\u5143\u6307\u4F01\u4E1A\u8F66\u8F86\u7BA1\u7406\uFF0C\u9700\u5EFA\u7ACB\u98CE\u9669\u5355\u5143\uFF0C\u586B\u62A5\u5355\u5143\u53C2\u6570\u4FE1\u606F\uFF0C\u4F46\u65E0\u9700\u7ED8\u5236\u5355\u5143\u8303\u56F4\u3002\n        ',
        '306': '',
        '307': '',
        '308': '\uFF081\uFF09\u98CE\u9669\u5355\u5143\u5206\u4E3A\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u548C\u8FD0\u8F93\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u8FD0\u8F93\u5355\u5143\u6307\u4F01\u4E1A\u8F66\u8F86\u7BA1\u7406\uFF0C\u9700\u5EFA\u7ACB\u98CE\u9669\u5355\u5143\uFF0C\u586B\u62A5\u5355\u5143\u53C2\u6570\u4FE1\u606F\uFF0C\u4F46\u65E0\u9700\u7ED8\u5236\u5355\u5143\u8303\u56F4\u3002',
        '309': '',
        '310': '',
        '312': IndustrialPrinciple,
        '313': '\uFF081\uFF09\u98CE\u9669\u5355\u5143\u5206\u4E3A\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u548C\u8FD0\u8F93\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n        \uFF082\uFF09\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n        \uFF083\uFF09\u8FD0\u8F93\u5355\u5143\u6307\u4F01\u4E1A\u8F66\u8F86\u7BA1\u7406\uFF0C\u9700\u5EFA\u7ACB\u98CE\u9669\u5355\u5143\uFF0C\u586B\u62A5\u5355\u5143\u53C2\u6570\u4FE1\u606F\uFF0C\u4F46\u65E0\u9700\u7ED8\u5236\u5355\u5143\u8303\u56F4\u3002',
        '314': '\uFF081\uFF09\u98CE\u9669\u5355\u5143\u5206\u4E3A\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u548C\u8FD0\u8F93\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u8FD0\u8F93\u5355\u5143\u6307\u4F01\u4E1A\u8F66\u8F86\u7BA1\u7406\uFF0C\u9700\u5EFA\u7ACB\u98CE\u9669\u5355\u5143\uFF0C\u586B\u62A5\u5355\u5143\u53C2\u6570\u4FE1\u606F\uFF0C\u4F46\u65E0\u9700\u7ED8\u5236\u5355\u5143\u8303\u56F4',
        '315': '\uFF081\uFF09\u98CE\u9669\u5355\u5143\u5206\u4E3A\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u548C\u8FD0\u8F93\u5355\u5143\u4E24\u79CD\u7C7B\u578B\u3002<div style="margin-bottom: 10px"></div>\n          \uFF082\uFF09\u4EA4\u901A\u573A\u7AD9\u5355\u5143\u4EE5\u72EC\u7ACB\u5EFA\u7B51\u7269\u4E3A\u754C\u9650\u5212\u5206\u4E3A\u72EC\u7ACB\u5355\u5143\u3002\u82E5\u6240\u6709\u573A\u6240\u5747\u5728\u4E00\u4E2A\u5355\u4F53\u5EFA\u7B51\u7269\u5185\u5219\u6574\u4F53\u4F5C\u4E3A\u4E00\u4E2A\u5355\u5143\u3002<div style="margin-bottom: 10px"></div>\n          \uFF083\uFF09\u8FD0\u8F93\u5355\u5143\u6307\u4F01\u4E1A\u8F66\u8F86\u7BA1\u7406\uFF0C\u9700\u5EFA\u7ACB\u98CE\u9669\u5355\u5143\uFF0C\u586B\u62A5\u5355\u5143\u53C2\u6570\u4FE1\u606F\uFF0C\u4F46\u65E0\u9700\u7ED8\u5236\u5355\u5143\u8303\u56F4',
        '316': IndustrialPrinciple,
        '317': IndustrialPrinciple,
        '318': IndustrialPrinciple,
        '319': '',
        '320': '',
        '335': ''
};
var controlNameMap = {
        '101': '危险化学品生产企业',
        '102': '带储存的危险化学品经营企业',
        '103': '危险化学品使用企业',
        '104': '加油站',
        '105': '天然气站场',
        '106': '液化气储配站（含供应站）',
        '107': '冶金企业',
        '108': '有色企业',
        '109': '民用爆炸物品企业',
        '110': '建材企业',
        '121': '轻工企业',
        '111': '机械企业',
        '112': '纺织企业',
        '113': '电力企业',
        '114': '露天矿山',
        '115': '地下矿山',
        '116': '尾矿库',
        '117': '烟花爆竹企业',
        '118': '港口经营企业（泉州港口）',
        '119': '铁路货运站场',
        '120': '建筑业',
        '122': '农业与农机(农药、兽药)',
        '123': '农机(含农机作业)',
        '124': '农业与农机(农产品初加工、饲料及饲料添加剂生产)',
        '126': '机动车维修企业',
        '127': '粮食和物资储备行业',
        '128': '烟草',
        '129': '林业',
        '132': '农田水利建设',
        '133': '公路、水运工程',
        '134': '房地产业(含房地产开发、房屋征收拆迁等)',
        '135': '水利工程',
        '136': '民爆物品(爆破)',
        '137': '特种设备生产企业',
        '138': '港口经营企业（湄洲湾港口）',
        '141': '加气站',
        '201': '餐饮场所',
        '202': '医疗机构',
        '203': '房地产业（物业服务）',
        '204': '宗教场所',
        '205': '体育场馆',
        '206': '城市公园',
        '207': '学校',
        '208': '宾馆酒店（非星级）',
        '209': '养老机构和福利机构',
        '210': '文化行业',
        '211': '商贸',
        '213': '技工院校和职业培训机构',
        '214': '新闻出版',
        '215': '文物和博物馆',
        '216': '星级饭店（酒店）',
        '217': '商贸（医药及医疗器材）',
        '229': '驾校',
        '301': '城市桥梁',
        '302': '城市隧道',
        '303': '水库大坝',
        '304': '客运车站',
        '305': '旅行社',
        '306': '陆上油气长输管道企业',
        '307': '城镇燃气管道企业',
        '308': '危险货物道路运输企业',
        '309': '建筑垃圾受纳场',
        '310': '渔业船舶',
        '311': '船舶运输',
        '312': '城市垃圾处理企业',
        '313': '散装物料运输企业',
        '314': '普通货物运输企业',
        '315': '邮政(含快递)',
        '316': '城市供水企业',
        '317': '污水处理企业',
        '318': '农村水电站',
        '319': '公路客运企业',
        '320': '水路旅客运输企业',
        '335': '水路货物运输企业'
        // // 企业是单单元还是多单元
        // export const controlUnitTypeMap = {
        //   '207': 'Single',
        //   '109': 'Multi'
        // }
        // 隐患排查治理情况页面映射
};var controlComplianceMap = {
        '112': 'Weave',
        '110': 'BuildingMaterials',
        '121': 'LightIndustry',
        '111': 'MechanicalEngineering',
        '108': 'Nonferrous',
        '107': 'Metallurgy',
        '118': 'Port',
        // '202': 'Common',
        '101': 'Chemical',
        '102': 'Chemical',
        // '103': 'Common',
        // '105': 'Common',
        // '106': 'Common',
        // '104': 'Common',
        // '113': 'Common',
        // '109': 'Common',
        '114': 'SurfaceMine',
        '115': 'UndergroundMine',
        '116': 'TailingsPond',
        '117': 'Fireworks',
        '119': 'RailFreight'
        // '120': 'Common',
        // '201': 'Common',
        // '206': 'Common',
        // '207': 'Common',
        // '208': 'Common',
        // '211': 'Common'
};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "09T9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 11,
  path: '/insurance',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/insurance/insurance/insuranceHome',
  name: 'insurance',
  isHead: true,
  meta: {
    title: '安责险管理',
    img: __webpack_require__("nqDt")
  },
  children: [{
    path: 'insurance',
    component: function component() {
      return __webpack_require__.e/* import() */(168).then(__webpack_require__.bind(null, "Bh2b"));
    },
    name: 'insuranceManager',
    meta: { title: '保险管理', close: false },
    children: [{
      path: 'insuranceHome',
      component: function component() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "Cdgx"));
      },
      name: 'insuranceHome',
      meta: { title: '工作台', next: '/insurance/insurance/service', close: false }
    },
    // 机构管理
    {
      path: 'institution',
      component: function component() {
        return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "M77g"));
      },
      name: 'institution',
      meta: { title: '保险机构管理', next: '/insurance/insurance/service', close: false }
    }, {
      path: 'service',
      component: function component() {
        return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "YHUK"));
      },
      name: 'service',
      meta: { title: '服务机构管理', next: '/insurance/insurance/specialist', close: true }
    }, {
      path: 'specialist',
      component: function component() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "Suea"));
      },
      name: 'specialist',
      meta: { title: '专家库', next: '/insurance/insurance/manager', close: true }
    },

    // 投保管理
    {
      path: 'manager',
      component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "ZM2T"));
      },
      name: 'manager',
      meta: { title: '保险管理', next: '/insurance/insurance/project', close: true }
    },

    // 事故预防服务管理
    // {
    //   path: 'project',
    //   component: () => import('@/views/insuranceManager/project'),
    //   name: 'project',
    //   meta: { title: '项目管理', next: '/insurance/insurance/set_manager', close: true}
    // },

    // 理赔管理
    {
      path: 'set_manager',
      name: 'set_manager',
      component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "Aecx"));
      },
      meta: { title: '理赔管理', next: '/insurance/insurance/complain', close: true }
    },

    // 事故预防
    {
      path: 'accidents',
      name: 'accidents',
      component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "97LT"));
      },
      meta: { title: '事故预防', next: '/insurance/insurance/estimate', close: true }
    },

    // 监督管理
    {
      path: 'complain',
      name: 'complain',
      component: function component() {
        return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "goYN"));
      },
      meta: { title: '投诉管理', next: '/insurance/insurance/estimate', close: true }
    }, {
      path: 'estimate',
      name: 'estimate',
      component: function component() {
        return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, "K7Lh"));
      },
      meta: { title: '服务评估', next: '/insurance/insurance/ins_satisfaction', close: true }
    }, {
      path: 'ins_satisfaction',
      name: 'ins_satisfaction',
      component: function component() {
        return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, "WHF5"));
      },
      meta: { title: '保险机构满意度', next: '/insurance/insurance/ser_satisfaction', close: true }
    }, {
      path: 'ser_satisfaction',
      name: 'ser_satisfaction',
      component: function component() {
        return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, "m8Iz"));
      },
      meta: { title: '服务机构满意度', next: '/insurance/insurance/situation', close: true }
    },

    // 统计分析
    {
      path: 'situation',
      name: 'situation',
      component: function component() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "hipi"));
      },
      meta: { title: '投保企业统计查询', next: '/insurance/insurance/settlement', close: true }
    }, {
      path: 'settlement',
      name: 'settlement',
      component: function component() {
        return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, "kfGQ"));
      },
      meta: { title: '理赔统计查询', next: '/insurance/insurance/accident', close: true }
    }, {
      path: 'accident',
      name: 'accident',
      component: function component() {
        return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, "dnY1"));
      },
      meta: { title: '事故预防服务费用查询', next: '/insurance/insurance/quality', close: true }
    }, {
      path: 'performance',
      name: 'performance',
      component: function component() {
        return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "a65l"));
      },
      meta: { title: '保险公司业绩查询', next: '/insurance/insurance/cost', close: true }
    }, {
      path: 'cost',
      name: 'cost',
      component: function component() {
        return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, "VanD"));
      },
      meta: { title: '服务费用统计', next: '/insurance/insurance/quality', close: true }
    }, {
      path: 'quality',
      name: 'quality',
      component: function component() {
        return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, "ZFjS"));
      },
      meta: { title: '抽查评分统计', close: true }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "0zyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);










// 这个函数是将要传的参数对象转化成字符串，同时加上阿杰的神奇校验机制
// 请求安全校验机制如下：
// ---------------------------------------
// 先对请求参数各个字段的值进行字符串拼接，然后再加上 check_key 的值拼 接。
// 对拼接好的字符串进行 md5 取值，将得到的值放入请求参数中，key 为 url_check
// 例子:
// post 的参数有 :
// param1 = 10,
// param2 =15,
// check_key = 29419eae77550b039c0e56c007e27076
// 拼接后的字符串为: 101529419eae77550b039c0e56c007e27076,
// md5 值: md5(101529419eae77550b039c0e56c007e27076)
// =763c991e6721abe95aebbb95fd45e808
// -----------------------------------------
// 把 url_check=763c991e6721abe95aebbb95fd45e808 加入请求参数中。
// 最终的 post 参数为:
// param1 = 10,
// param2 =15,
// url_check=763c991e6721abe95aebbb95fd45e808-
// -----------------------------------------
function transformRequest() {
  var paramsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // 按键值排序
  var data = {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(paramsObj).sort().forEach(function (key) {
    data[key] = paramsObj[key];
  });
  var urlCheck = '';
  var ret = '';
  for (var it in data) {
    if (data[it] === null || typeof data[it] === 'undefined') {
      continue;
    }
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
    urlCheck += data[it];
  }
  urlCheck += __WEBPACK_IMPORTED_MODULE_4__config__["a" /* CHECK_KEY */];
  urlCheck = __WEBPACK_IMPORTED_MODULE_3_blueimp_md5___default()(urlCheck);
  ret += 'sign=' + urlCheck;
  return ret;
}

// axios全局超时设置
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.timeout = 60 * 1000 * 5;

// http request 拦截器
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
  // header加sid
  var sessionId = __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].state.sessionId;
  if (sessionId) {
    config.headers['sid'] = sessionId;
  }
  // header设置表单提交
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8;';
  config.headers['role'] = 3;
  config.transformRequest = transformRequest;
  return config;
}, function (err) {
  __WEBPACK_IMPORTED_MODULE_8_element_ui__["Message"].error({
    message: '请求超时，请检查您的网络环境是否正常',
    showClose: true
  });
  console.log(err);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
  var data = response.data;
  if (data && data.code) {
    var code = data.code;
    // 如果返回数据结构中code为10004、10005、10006，就跳转微信授权URL
    if (code === 10004 || code === 10005 || code === 10006) {
      __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_6__vuex_types__["LOGOUT"]);
      __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].replace({ name: 'login' });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }
  }
  return response;
}, function (error) {
  // 返回业务catch块处理
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "28ji":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[(_vm.showHead)?_c('el-header',{staticStyle:{"height":"70px"}},[_c('Headbar')],1):_vm._e(),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[(_vm.showHead)?_c('div',{staticClass:"toggle-button",on:{"click":_vm.back}},[_c('div',{staticClass:"bg",staticStyle:{"width":"100%","height":"26px"}})]):_vm._e(),_vm._v(" "),_c('Sidebar')],1),_vm._v(" "),_c('el-main',[_c('div',{staticClass:"view"},[_c('div',[_c('router-view',{ref:"view"})],1)]),_vm._v(" "),(_vm.showHead)?[_c('div',{staticClass:"circle1",on:{"click":_vm.addRecheck}},[_c('i',{staticClass:"el-icon-edit icon"})]),_vm._v(" "),_c('div',{staticClass:"circle",on:{"click":_vm.showRecheckTable}},[_c('i',{staticClass:"el-icon-s-grid icon"})]),_vm._v(" "),_c('div',{staticClass:"circle2",on:{"click":_vm.send}},[_c('i',{staticClass:"el-icon-chat-dot-square icon"})])]:_vm._e()],2)],1),_vm._v(" "),_c('el-dialog',{attrs:{"close-on-click-modal":false,"title":"复核意见","visible":_vm.dialogVisible,"width":"1200px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('recheck-table',{ref:"recheckTable"})],1),_vm._v(" "),_c('addOrUpdateForm',{ref:"addOrUpdateForm",attrs:{"data_class":"Recheck"},on:{"refreshTable":_vm.refreshTable}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Pvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeadBar__ = __webpack_require__("cWbZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_vue__ = __webpack_require__("G1N0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb_Breadcrumb_vue__ = __webpack_require__("+5CF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_frame_ScreenAdapter__ = __webpack_require__("Zji8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_types__ = __webpack_require__("meMj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Headbar: __WEBPACK_IMPORTED_MODULE_1__HeadBar__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__Sidebar_vue__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__Breadcrumb_Breadcrumb_vue__["a" /* default */],
    ScreenAdapter: __WEBPACK_IMPORTED_MODULE_4__components_frame_ScreenAdapter__["a" /* default */]
  },
  data: function data() {
    return {
      iscollapse: false,
      levelList: [],
      pageCurrent: '',
      exclude: null,
      condition: true
    };
  },

  watch: {
    $route: {
      handler: function handler(to) {
        var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var adminType = 1;
        var userInfo = this.$store.getters.userInfo;
        if (userInfo.department_id == 0 && userInfo.town_id == 0) {
          // 判断是否为超级管理员
          adminType = 0;
        }
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__vuex_types__["FIXTAB"], adminType);
        var pageList = this.$store.state.tab.pageList;
        // 当路由改变时，检测该路由是否已经在打开的页面之中，如果不在，就添加进去
        // if (pageList.length === 0) {
        //   pageList.meta = {}
        // }
        // 如果当前路由路径已经存在pagelist中就不再往pagelist里添加新的路径而是跳到响应的pageCurrent上
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(pageList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.name === to.name) {
              this.pageCurrent = to.name;
              return;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__vuex_types__["GETPAGELIST"], to);
        this.pageCurrent = to.name;
      },

      immediate: true
    }
  },
  mounted: function mounted() {
    // this.refreshModule()
    this.$http.post('/apps/admin/checkLogin');
  },

  methods: {
    removeTab: function removeTab(targetName) {
      var _this = this;

      var tabs = this.$store.state.tab.pageList;
      var activeName = this.pageCurrent;
      if (activeName === targetName) {
        tabs.forEach(function (tab, index) {
          if (tab.name === targetName) {
            var nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.pageCurrent = activeName;
      // this.pageList = tabs.filter(tab => tab.name !== targetName)
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__vuex_types__["REMOVETAB"], { tabs: tabs, targetName: targetName });
      if (activeName === 'company') {
        var projectid = localStorage.getItem('storage_project_id');
        this.$router.push('/project/company?id=' + projectid);
      } else if (activeName === 'companyInfo') {
        var companytype = localStorage.getItem('company_type');
        var _projectid = localStorage.getItem('storage_project_id');
        var companyid = localStorage.getItem('company_id');
        if (companytype === 'add') {
          this.$router.push('/project/companyInfo?project_id=' + _projectid);
        } else {
          this.$router.push('/project/companyInfo?project_id=' + _projectid + '&company_id=' + companyid);
        }
      } else {
        this.$router.push({ name: activeName });
      }
      // 刷新页面
      this.exclude = this.$refs.view.$options.name; // 排除缓存名单
      // this.condition = !this.condition
      this.$nextTick(function (_) {
        // 视图刷新后再让改组件页面进入缓存
        _this.exclude = null;
        // this.condition = !this.condition
      });
    },
    tabChange: function tabChange(tab) {
      if (tab.name === 'company') {
        var projectid = localStorage.getItem('storage_project_id');
        this.$router.push('/project/company?id=' + projectid);
      } else if (tab.name === 'companyInfo') {
        var companytype = localStorage.getItem('company_type');
        var _projectid2 = localStorage.getItem('storage_project_id');
        var companyid = localStorage.getItem('company_id');
        if (companytype === 'add') {
          this.$router.push('/project/companyInfo?project_id=' + _projectid2);
        } else {
          this.$router.push('/project/companyInfo?project_id=' + _projectid2 + '&company_id=' + companyid);
        }
      } else {
        this.$router.push({ name: tab.name });
      }
    },
    refreshModule: function refreshModule() {
      var _this2 = this;

      this.exclude = this.$refs.view.$options.name;
      this.condition = !this.condition;
      this.$nextTick(function (_) {
        _this2.exclude = null;
        _this2.condition = !_this2.condition;
      });
    }
  }
});

/***/ }),

/***/ "2VZq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selectArea_selectArea__ = __webpack_require__("w2XR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Util_commonOptions__ = __webpack_require__("oQse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util_Search__ = __webpack_require__("JJCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_4__Util_Search__["a" /* default */],
    selectArea: __WEBPACK_IMPORTED_MODULE_2__components_selectArea_selectArea__["a" /* default */]
  },
  data: function data() {
    return {
      searchForm: {
        area_id: null,
        town: null,
        village: null,
        name: null,
        control_id: null,
        path: null,

        company_level_one: null, //存在一般隐患单位
        company_level_two: null, //存在重大隐患单位
        is_supervision_check: null, //加入监督检查库单位
        risk_level: null, // 重大安全风险等级（红色）企业
        is_metal_company: null, // 金属冶炼企业
        is_deep_well_process: null, // 铝加工（深井铸造）企业
        is_has_metal_dust: null, // 涉粉30人以上和铝镁等金属粉尘涉爆企业
        is_has_ammonia: null, // 涉氨制冷企业
        is_has_chlorine: null, // 涉氯企业
        is_has_limited_space_task: null, // 是否涉及有限空间作业
        is_major_hazard_source: null, // 是否构成重大危险源
        development_area_name: null, // 企业园区
        is_no_safety_standard: null, // 未创建安全标准化
        is_overdue_safety_standard: null, // 安全标准化过期
        is_three_ts_unfinished: null, //  三同时未完成
        is_manager_no_train: null, // 主要管理或负责人没有培训
        is_has_dust: null, //涉及涉爆粉尘
        is_fire_safety_focus: null, // 属于消防重点单位
        is_fire_danger: null, //属于火灾高危单位
        is_safety_insurance: null // 购买安责险
      },
      industryOptions: __WEBPACK_IMPORTED_MODULE_3__Util_commonOptions__["k" /* industryOptions */], // 企业类型
      search_control_id: '',
      dialogVisible: true,
      staff: null,
      loading: false,
      jobOptions: [],
      tableData: [],
      checkedData: null, // 选中的节点
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      parent_node_id: 0, // 父级ID
      parent_node_label: null, // 父级名称
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      callback: null,
      SelectionAll: {},
      SelectionTable: [],
      responsible_person: null,
      advancedSearch: false

    };
  },
  mounted: function mounted() {
    this.getCompanyList();
    this.getDepartmentTreeList();
  },

  methods: {
    heightSearch: function heightSearch() {
      this.advancedSearch = !this.advancedSearch;
      this.searchForm = {
        area_id: null,
        town: null,
        village: null,
        name: null,
        control_id: null,
        path: null,

        company_level_one: null, //存在一般隐患单位
        company_level_two: null, //存在重大隐患单位
        is_supervision_check: null, //加入监督检查库单位
        risk_level: null, // 重大安全风险等级（红色）企业
        is_metal_company: null, // 金属冶炼企业
        is_deep_well_process: null, // 铝加工（深井铸造）企业
        is_has_metal_dust: null, // 涉粉30人以上和铝镁等金属粉尘涉爆企业
        is_has_ammonia: null, // 涉氨制冷企业
        is_has_chlorine: null, // 涉氯企业
        is_has_limited_space_task: null, // 是否涉及有限空间作业
        is_major_hazard_source: null, // 是否构成重大危险源
        development_area_name: null, // 企业园区
        is_no_safety_standard: null, // 未创建安全标准化
        is_overdue_safety_standard: null, // 安全标准化过期
        is_three_ts_unfinished: null, //  三同时未完成
        is_manager_no_train: null, // 主要管理或负责人没有培训
        is_has_dust: null, //涉及涉爆粉尘
        is_fire_safety_focus: null, // 属于消防重点单位
        is_fire_danger: null, //属于火灾高危单位
        is_safety_insurance: null // 购买安责险
      };
    },
    change: function change(val) {
      var data = this.$refs.departmentTree.getCheckedNodes(true);
      if (data && data.length > 0) {
        this.searchForm.department_area_id = data[0].data.area_id;
        this.searchForm.department_type_id = data[0].data.department_type_id;
        this.searchForm.tree_id = data[0].data.id;
      }
    },
    getDepartmentTreeList: function getDepartmentTreeList() {
      var _this = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* api */].getDepartmentTreeList, {}).then(function (res) {
        if (res.data.code == 0) {
          _this.departmentData = res.data.data;
          _this.departmentData.forEach(function (v) {
            v.name = v.name + '(' + v.area_name + ')';
          });
        }
      });
    },
    selectControlId: function selectControlId(val) {
      this.search_control_id = val.map(function (v) {
        return v[1];
      });
      this.build_industry = val.map(function (v) {
        return v[0];
      });
    },
    reset: function reset() {
      for (var key in this.searchForm) {
        this.searchForm[key] = null;
      }
      this.search();
    },
    search: function search() {
      this.currentPage = 1;
      if (this.searchForm.path != null && this.searchForm.path.length == 0) {
        this.searchForm.path = null;
      }
      this.getCompanyList();
    },
    deleteStaff: function deleteStaff(row, index) {
      var _this2 = this;

      this.select({}, row);
      this.$nextTick(function () {
        _this2.getCompanyList();
      });
    },
    closeForm: function closeForm() {
      this.staff = null;
      this.checkedData = null;
      // this.$refs['table'].setCurrentRow()
      this.$el.parentNode.removeChild(this.$el);
    },
    save: function save() {
      if (this.SelectionTable.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请选择企业'
        });
      }
      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.SelectionTable);
      }
      // this.$emit('getStaff', staff)
      this.dialogVisible = false;
    },
    currentChange: function currentChange(currentRow) {
      if (currentRow) {
        this.staff = currentRow;
      }
    },

    // // 获取员工账号列表
    getCompanyList: function getCompanyList() {
      var _this3 = this;

      var params = {
        page_index: this.currentPage,
        page_size: this.pageSize
      };
      for (var key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          params[key] = this.searchForm[key];
        }
      }
      if (params.control_id) {
        params.control_id = params.control_id.map(function (v) {
          return v[1];
        });
      }
      this.loading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* api */]['getCompanyList'], params).then(function (response) {
        _this3.tableData = response.data.data;
        _this3.$nextTick(function () {
          _this3.checkSelect();
        });
        _this3.totalCount = response.data.page_info.total_num;
        _this3.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getCompanyList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getCompanyList();
    },
    select: function select(selection, row) {
      for (var key in this.SelectionAll) {
        if (key == row.id) {
          delete this.SelectionAll[key];
          this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
          return;
        }
      }
      this.SelectionAll[row.id] = row;
      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
    },
    selectAll: function selectAll(select) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          if (select.length === 0) {
            delete this.SelectionAll[row.id];
          } else {
            this.SelectionAll[row.id] = row;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
    },

    // 每次刷新时检查是否有选项，并设置已选中
    checkSelect: function checkSelect() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var row = _step2.value;

          if (this.SelectionAll.hasOwnProperty(row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "2a9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[_c('div',{staticClass:"ruleform"},[_c('div',{staticClass:"table",staticStyle:{"margin-top":"20px"}},[_c('div'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.review_status != 2),expression:"review_status != 2"}],staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"success"},on:{"click":function($event){return _vm.handleReview()}}},[_vm._v("复核通过")]),_vm._v(" "),_c('el-button',{staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.showForm()}}},[_vm._v("新增复核意见")])],1)]),_vm._v(" "),_c('el-table',{staticStyle:{"color":"#303133","width":"100%","margin-bottom":"10px"},attrs:{"data":_vm.tableData,"header-cell-style":{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'},"cell-style":_vm.cellStyle,"border":"","stripe":""}},[_c('el-table-column',{attrs:{"label":"序号","type":"index","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"handle_status","show-overflow-tooltip":"","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.handle_status == 1)?_c('span',{staticStyle:{"color":"#67C23A"}},[_vm._v("已处理")]):_c('span',{staticStyle:{"color":"#F56C6C"}},[_vm._v("待处理")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"module","show-overflow-tooltip":"","label":"模块/单元","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\r\n            "+_vm._s(row.module ? row.module : '-')+"\r\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"field_name","show-overflow-tooltip":"","label":"字段名","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","show-overflow-tooltip":"","label":"问题描述","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"image_list","label":"截图","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(!row.image_list)?_c('span',{staticStyle:{"margin-left":"15px","color":"#909399"}},[_vm._v("-")]):_c('div',{staticStyle:{"display":"flex"}},_vm._l((row.image_list.split(',')),function(item,index){return _c('div',{key:index,staticStyle:{"margin-right":"15px"}},[(index < 3)?_c('el-image',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":item,"preview-src-list":row.image_list.split(',')}}):_vm._e()],1)}),0)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"file","show-overflow-tooltip":"","label":"附件","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.file)?[_c('el-link',{attrs:{"underline":false,"target":"_blank","type":"primary"},on:{"click":function($event){return _vm.$showFile({ url: row.file })}}},[_vm._v("预览")]),_vm._v(" "),_c('el-link',{attrs:{"underline":false,"href":row.file,"target":"_blank","type":"primary"}},[_vm._v("下载")])]:_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supporting_materials_file","show-overflow-tooltip":"","label":"佐证附件","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [(row.supporting_materials_file)?[_c('el-link',{attrs:{"underline":false,"target":"_blank","type":"primary"},on:{"click":function($event){return _vm.$showFile({ url: row.supporting_materials_file })}}},[_vm._v("预览")]),_vm._v(" "),_c('el-link',{attrs:{"underline":false,"href":row.supporting_materials_file,"target":"_blank","type":"primary"}},[_vm._v("下载")])]:_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"create_time","show-overflow-tooltip":"","label":"生成时间","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"deadline_time","show-overflow-tooltip":"","label":"整改到期时间","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"handle_time","show-overflow-tooltip":"","label":"处理时间","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\r\n            "+_vm._s(row.handle_time ? row.handle_time : '-')+"\r\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"operator","show-overflow-tooltip":"","label":"操作人","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","type":"text"},on:{"click":function($event){return _vm.showEditForm(scope.row,'credentials')}}},[_vm._v("编辑")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"text"},on:{"click":function($event){return _vm.handleDelete(scope.row,'credentials')}}},[_vm._v("删除")])]}}])})],1),_vm._v(" "),_c('el-row',{staticStyle:{"width":"100%"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"float":"right","padding":"10px"}},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-size":10,"layout":"total, prev, pager, next, jumper","total":_vm.totalCount},on:{"current-change":_vm.handleCurrentChange}})],1)])],1)],1),_vm._v(" "),_c('addOrUpdateForm',{ref:"addOrUpdateForm",attrs:{"tableData":_vm.tableData,"data_class":_vm.data_class,"modules":_vm.modules,"tab":_vm.tab},on:{"refreshTable":_vm.refreshTable}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3pfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":_vm.mouseUp,"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3uqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dialog_",attrs:{"title":"检查人员列表","visible":_vm.dialogVisible,"append-to-body":"","width":"1000px"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.closeForm}},[_c('div',{staticClass:"container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"fl-wrap mg-tp-sm"},[_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("检查人员名称")]),_vm._v(" "),_c('el-input',{staticClass:"item",staticStyle:{"width":"200px","margin-right":"15px"},attrs:{"clearable":"","size":"mini","placeholder":"请输入检查人员名称"},model:{value:(_vm.searchForm.name),callback:function ($$v) {_vm.$set(_vm.searchForm, "name", $$v)},expression:"searchForm.name"}})],1),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("联系电话")]),_vm._v(" "),_c('el-input',{staticClass:"item",staticStyle:{"width":"200px","margin-right":"15px"},attrs:{"clearable":"","size":"mini","placeholder":"请输入联系电话"},model:{value:(_vm.searchForm.phone),callback:function ($$v) {_vm.$set(_vm.searchForm, "phone", $$v)},expression:"searchForm.phone"}})],1),_vm._v(" "),_c('el-button',{staticClass:"mg-lf-sm",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.reset}},[_vm._v("重置")]),_vm._v(" "),_c('el-button',{staticClass:"mg-lf-sm",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{staticClass:"mg-lf-sm",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.save}},[_vm._v("确定")])],1),_vm._v(" "),_c('div',{staticClass:"mg-tp-sm"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"highlight-current-row":"","data":_vm.tableData,"header-cell-style":{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'},"cell-style":{padding: '5px 0',color: '#303133'},"border":"","stripe":""},on:{"select":_vm.select,"select-all":_vm.selectAll}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"检查人员姓名","show-overflow-tooltip":"","min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unit_name","show-overflow-tooltip":"","label":"所在单位","min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":"联系电话","show-overflow-tooltip":"","min-width":"140"}})],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"float":"right","padding":"10px"}},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-size":10,"layout":"total, prev, pager, next, jumper","total":_vm.totalCount},on:{"current-change":_vm.handleCurrentChange}})],1)])],1)],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3yK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_systemData_vue__ = __webpack_require__("pS/e");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6572ab06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_systemData_vue__ = __webpack_require__("yd2P");
function injectStyle (ssrContext) {
  __webpack_require__("rjUQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6572ab06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_systemData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6572ab06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_systemData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4ivE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4pOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__("YtJ0");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: "village"
    },
    area: [Number, String],
    town: [Number, String],
    village: [Number, String],
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      townOptions: [],
      villageOptions: []
    };
  },

  computed: {
    baseOptions: function baseOptions() {
      var cityArr = JSON.parse(localStorage.getItem("baseArea"));
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(cityArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.id == __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].state.cityId) {
            return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(item.children));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  watch: {
    area: {
      immediate: true,
      handler: function handler(val) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.baseOptions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (val === item.id) {
              this.townOptions = item.children;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    changeArea: function changeArea(id) {
      this.townOptions = [];
      if (id) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.baseOptions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            if (id === item.id) {
              this.townOptions = item.children;
              break;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        this.$emit("update:area", id);
        this.$emit("update:town", "");
        this.$emit("update:village", "");
      } else {
        this.$emit("update:area", "");
        this.$emit("update:town", "");
        this.$emit("update:village", "");
      }
    },
    changeTown: function changeTown(id) {
      var _this = this;

      if (id) {
        this.$emit("update:town", id);
        this.$emit("update:village", "");
        this.villageOptions = [];
        this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */]["getVillageByTown"], { town_id: id }).then(function (res) {
          if (res.data.code === 0) {
            _this.villageOptions = res.data.data;
          } else {
            console.log(res.data.msg);
          }
        });
      } else {
        this.$emit("update:town", "");
        this.$emit("update:village", "");
      }
    },
    changeVillage: function changeVillage(id) {
      if (id) {
        this.$emit("update:village", id);
      } else {
        this.$emit("update:village", "");
      }
    }
  }
});

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5A0K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5LIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5NEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataCard_vue__ = __webpack_require__("wQab");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5292c64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataCard_vue__ = __webpack_require__("JaJX");
function injectStyle (ssrContext) {
  __webpack_require__("5A0K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5292c64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5292c64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5qJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUid;
function getUid() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  return s.join('');
}

/***/ }),

/***/ "5u8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PasswordForm__ = __webpack_require__("k2Yx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfoForm__ = __webpack_require__("llpM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_systemData_systemData_vue__ = __webpack_require__("3yK/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PasswordForm: __WEBPACK_IMPORTED_MODULE_0__PasswordForm__["a" /* default */],
    InfoForm: __WEBPACK_IMPORTED_MODULE_1__InfoForm__["a" /* default */],
    Echart: __WEBPACK_IMPORTED_MODULE_3__views_systemData_systemData_vue__["default"]
  },
  data: function data() {
    return {
      userInfo: { company: {} },
      currentIndex: '',
      name: '泉州市安全生产标准化智慧管理平台',
      name_Int: 'Quanzhou safety standardization intelligent management platform',
      showEchartDialog: false
    };
  },

  computed: {
    routesArr: function routesArr() {
      var routes = this.$store.getters['permission/routers'];
      this.currentIndex = this.$route.path;
      return routes.filter(function (item) {
        return item.isHead;
      }).sort(function (a, b) {
        return b.index - a.index;
      });
    }
  },
  mounted: function mounted() {
    var hostname = window.location.hostname;
    var port = window.location.port;
    this.name = '泉州市安全生产标准化智慧管理平台';
    this.name_Int = 'Quanzhou safety standardization intelligent management platform';
    // if(hostname == 'localhost' || hostname == '222.77.0.146'){
    //   if(port == 9010){
    //     this.name = '丰泽区安全生产标准化智慧管理平台'
    //     this.name_Int = 'Fengze safety standardization intelligent management platform'
    //   }else if(port == 9014) {
    //     this.name = '南安市九小场所安全生产标准化管理平台'
    //     this.name_Int = "Nan'an nine small place safety standardization management platform"
    //   }else{
    //     this.name = '泉州市安全生产标准化智慧管理平台'
    //     this.name_Int = 'Quanzhou safety standardization intelligent management platform'
    //   }
    // }else{
    //   this.name = '安全生产标准化智慧管理平台'
    //   this.name_Int = 'Safety standardization intelligent management platform'
    // }

    var userInfo = this.$store.getters.userInfo;
    this.userInfo = userInfo;
  },

  methods: {
    itemClick: function itemClick(index, item) {
      if (item.name == 'dataV') {
        this.goEchart();
      } else {
        this.$router.push(item.path);
      }
    },

    // 右上角菜单点击响应
    handleUserDropdownCommand: function handleUserDropdownCommand(command) {
      switch (command) {
        case 'ChangePassword':
          // 修改密码
          this.$refs['passwordForm'].showForm();
          break;
        case 'AccountInfo':
          // 账号信息
          this.$refs['InfoForm'].showForm();
          break;
        case 'Logout':
          // 退出登录
          this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_types__["LOGOUT"]);
          this.$router.replace({ name: 'login' });
          break;
        case 'OperationManual':
          // 操作文档
          this.showEchartDialog = true;
          break;
      }
    },
    goCompanyGraph: function goCompanyGraph() {
      window.open(this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL + '/companyUnit.html?id=' + this.$store.getters.companyId);
    },
    goEchart: function goEchart() {
      window.open(this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL + '/#/dvOne?port=admin&sid=' + this.$store.state.sessionId + '&v=a87ff679a2f3e71d9181a67b7542122c');
      // window.open(`http://dev-risk-qz-datav.zyrcsoft.com/#/dvOne?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`)
    }
  }
});

/***/ }),

/***/ "6AZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      levelList: []
    };
  },

  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  },
  created: function created() {
    this.getBreadcrumb();
  },

  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var matched = this.$route.matched.filter(function (item) {
        return item.meta && item.meta.title;
      });
      this.levelList = matched;
    }
  }
});

/***/ }),

/***/ "7PdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectExpertDialog_vue__ = __webpack_require__("RhYn");



var selectExpertConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__selectExpertDialog_vue__["a" /* default */]);
var instance = void 0;

var selectTip = function selectTip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  instance = new selectExpertConstructor({
    data: options
  });
  document.body.appendChild(instance.$mount().$el);
};

// export default importTip
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$selectExpert = selectTip;
  }
});

/***/ }),

/***/ "7zo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 14,
  path: '/examine',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/examine/examineAll/city',
  name: 'examine',
  isHead: true,
  meta: {
    title: '绩效考核',
    img: __webpack_require__("mEhX")
  },
  children: [{
    path: 'examineAll',
    component: function component() {
      return __webpack_require__.e/* import() */(182).then(__webpack_require__.bind(null, "aLnP"));
    },
    name: 'examineAll',
    meta: { title: '绩效考核', close: false },
    children: [{
      path: 'city',
      component: function component() {
        return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, "n2gZ"));
      },
      name: 'city',
      meta: { title: '市直', next: '/examine/examineAll/county', close: false }
    }, {
      path: 'county',
      component: function component() {
        return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, "i0pH"));
      },
      name: 'county',
      meta: { title: '区县', next: '/examine/examineAll/cityTable1', close: false }
    }, {
      path: 'numberOfTasksCity',
      component: function component() {
        return __webpack_require__.e/* import() */(181).then(__webpack_require__.bind(null, "5uwn"));
      },
      name: 'numberOfTasksCity',
      meta: { title: '市直', close: false }
    }, {
      path: 'numberOfTasksCounty',
      component: function component() {
        return __webpack_require__.e/* import() */(180).then(__webpack_require__.bind(null, "Tdhz"));
      },
      name: 'numberOfTasksCounty',
      meta: { title: '区县', close: false }
    }, {
      path: 'cityTable1',
      component: function component() {
        return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, "+XUc"));
      },
      name: 'cityTable1',
      meta: { title: '报表(一)', close: false }
    }, {
      path: 'cityTable2',
      component: function component() {
        return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, "ITSO"));
      },
      name: 'cityTable2',
      meta: { title: '报表(二)', close: false }
    }, {
      path: 'cityTable3',
      component: function component() {
        return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, "zdyA"));
      },
      name: 'cityTable3',
      meta: { title: '报表(三)', close: false }
    }, {
      path: 'cityTable4',
      component: function component() {
        return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, "YOwu"));
      },
      name: 'cityTable4',
      meta: { title: '报表(四)', close: false }
    }, {
      path: 'citySummaryFilling',
      component: function component() {
        return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, "co5V"));
      },
      name: 'citySummaryFilling',
      meta: { title: '每月小结填报', close: false }
    }, {
      path: 'scoringCity',
      component: function component() {
        return __webpack_require__.e/* import() */(151).then(__webpack_require__.bind(null, "u5si"));
      },
      name: 'scoringCity',
      meta: { title: '市直', close: false }
    }, {
      path: 'scoringCounty',
      component: function component() {
        return __webpack_require__.e/* import() */(150).then(__webpack_require__.bind(null, "J1wz"));
      },
      name: 'scoringCounty',
      meta: { title: '区县', close: false }
    }, {
      path: 'countyTable1',
      component: function component() {
        return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, "2N+E"));
      },
      name: 'countyTable1',
      meta: { title: '报表(一)', close: false }
    }, {
      path: 'countyTable2',
      component: function component() {
        return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, "ZFZF"));
      },
      name: 'countyTable2',
      meta: { title: '报表(二)', close: false }
    }, {
      path: 'countyTable3',
      component: function component() {
        return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, "T+up"));
      },
      name: 'countyTable3',
      meta: { title: '报表(三)', close: false }
    }, {
      path: 'countyTable4',
      component: function component() {
        return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, "+S4U"));
      },
      name: 'countyTable4',
      meta: { title: '报表(四)', close: false }
    }, {
      path: 'countySummaryFilling',
      component: function component() {
        return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, "9Wgg"));
      },
      name: 'countySummaryFilling',
      meta: { title: '每月小结填报', close: false }
    }, {
      path: 'manualCity',
      component: function component() {
        return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, "3QEL"));
      },
      name: 'manualCity',
      meta: { title: '市直(手工数据)', close: false }
    }, {
      path: 'manualCounty',
      component: function component() {
        return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, "33QK"));
      },
      name: 'manualCounty',
      meta: { title: '区县(手工数据)', close: false }
    }, {
      path: 'monthlySummaryCollect',
      component: function component() {
        return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, "j/wP"));
      },
      name: 'monthlySummaryCollect',
      meta: { title: '每月小结汇总', close: false }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "8LMS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9jSJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectCompanyDialog_vue__ = __webpack_require__("2VZq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fdec190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectCompanyDialog_vue__ = __webpack_require__("KoSI");
function injectStyle (ssrContext) {
  __webpack_require__("jOSF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fdec190"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectCompanyDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fdec190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectCompanyDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AaAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      title: '',
      dialogVisible: true,
      url: ''
    }, 'title', '预览');
  },

  computed: {
    platformUrl: function platformUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].getters.sysUrl.ADMIN_PLATFORM_URL;
    },
    urlType: function urlType() {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = this.url.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return '-1';
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix;
      });
      if (result) {
        result = 'image';
        return result;
      }
      var videolist = ['mp4', 'm2v', 'mkv'];
      result = videolist.some(function (item) {
        return item == suffix;
      });
      if (result) {
        result = 'video';
        return result;
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    downloadFile: function downloadFile() {
      window.open(this.url);
    },
    close: function close() {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});

/***/ }),

/***/ "AdUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mysearch"},[_c('div',{staticClass:"search"},[_c('div',{staticClass:"search-box"},[_c('div',{staticClass:"item"},[_vm._t("search")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bfn9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAam0lEQVR4Xu2dCZRcRbnHf1/3TMgKBDAKyCoyQUEEREhACCQmZnrYCQJGQISHsm9hyXSHNtNJQCIukQPy2CGKYZVMJwQB8x5I8jwgGBUT9kUICESzb9P9vVOzQLZJb3er7rrn5IRhqr7lX/VL3br3VpXgLt8UGH6NDqirZ2BMaVDYCdgaoZ9AP5R+QD+Vjr/NzyJsY4JRZRHCUmCpaMff5mc1P8MSVRYLvKPK/Hwd82eOlQ99S6LGDUuN519x+kPSWtevB3vk8jSIMlCgARio0v7f/St2UISBTqDmi7IAYb4BJwcL+jXw6v0nSa4IE65INwo4QErsGiN/oVvEljIYZYgoh6twsMAWJZoJpLjCalHmArPNn2U55s5Oy6pAnFeJEwdIgYY0QLCYQ2IwBOFw4KCoAlGoTzpgCim08e8dIJvQbGRat4zFOFqEExS+JULP0qW1osZKhcckzwPL8jw6Oy3LrIg6wCAdIJ1iJyZpf/IcJ3lOAIYh9AiwHUJ31Tm6/D4f48E1cR5+4ipZHHpQEQigpgE5Kq3b5eKcIHAiMESEugi0SeghqNIm8BTwgOR4eHpaPgo9qJACqElAGifoWaJ8V+CwkHS3ze3svDB1RrPcalvglcZbM4AMv1779FjNOQqXCuxYqXC1WF/hXVV+0taTWx4fI8trQYOqB2REWrepq+MilPO7XsTVQsP6nOPHCFPq1vLzR9LyH599hWq+agEZMUG3r1OuAM4W6BOqytXqXFmGcMtaYfKsZllYjWlWHSAjJuke9W2MVWG0QH01NlrkclLWINy9Ns51s66WVyMXXwUBVQ0g7e8u6pggyrkIsQo0cVXLVyCnMGV5G6lqeadSFYA0jddTVfiJCJ8rv21dTc8UUN5T4eJsUu73zGZIhqwGJDFJdyfHHe5xbUi9p5Bb5Smt4+zs1fJ6oaJR/b2VgAxJa88+cZICY2rtjXdUO1J3cXW+ob82txWTZl4oq22L3zpAmlp0uAq3COxim9i1HK/C6yL8V2uzPGmTDtYAYtZd9InzY4SLBayJ26bO4HesCopyw/IcV81OS5vf/rywb0VHa8zoLqI8KMIBXiTtbISrgCrP53McOzMt/ww3ksLeIw9IY0aPiSn3IvQtnI4rYYsCCotFObU1JTOiHHNkATELleJL+BnwgygL6GKrUAHlxtxWXBbVCXwkATGPb6WNRxG+XKH8rroNCih/1zqOjuLj4MgBksjoKFHuROhtQ9u6GD1SQFmhwhlRe7kYKUASLXqtCFd6JLkzY6ECCuOzSbkmKqFHBpBERu8UOD0qwrg4wlNAlZuyKTk3vAg+9Rw6IJ3vN34rwvFREMTFEA0FFO7vvSenhL2vV6iAtH8yUscMgSOi0SwuiogpMLNXG8fen5Y1YcUVGiBD0tq3Tx1PCnw9rOSd3+groMrT8R4kHr1SzBasgV+hADJyon4mluNJEfYJPGPn0EYF5q1t44hZaVkUdPCBAzJ0om7bM8+zAnsGnazzZ7UC81fGOPTJsfJxkFkECsigG7TXtsuZg7BvkEk6X1WigPKC5Dh0elpWBJVRYICMmqbxlS/zhNmgLajknJ8qVEB5qlcDw4N6uhUYIE0ZfQDat/V0l1OgIgXMI+BsUk6qyEiRlQMBpCmjN7mPDotsEVesOAWUG1tTcn5xhcsv5TsgTS16NcLE8kN0NZ0C3SigXNGakuv91MdXQBLj9WSJ8Rs/E3C2a16B0a1JmeqXCr4B0jhBvxlTZgJxv4J3dp0CQE6FRLZZZvmhhi+AmCWyMeUl98m6H03mbG6ogMLyXJy9H7ta3vRaHc8BMY9zV7zMcwJf9TpYZ88p0K0Cygu9GjjQ68e/ngOSyOj1Ape7pnQKBK6AMqk1JWO99OspICNb9Mi4YNW+R16K6WyFq0D7tkJ5Ds+Ok6e9isQzQMw3Vr1yzEfYzqvgnB2nQKkKqPJ+fY69vDq3xDNAmjJqPiMZWmpCrrxTwGsFFLLZpDR5YdcTQBIteoEIv/AiIGfDKeCRAj9sTcrNldqqGJCjJupAzfOPSgNx9Z0CXivQpgx8LCULKrFbMSCJjP5RYHAlQbi6TgE/FFDlj9mUHFqJ7YoAaczoKTH4dSUBuLpOAT8V0DynZMfJfeX6KBuQzjM63nCnOpUrvasXhAIKCxf15gtzLpWV5fgrG5BEi04W4bJynLo6ToEgFVCYnE3KmHJ8lgVI40TdM5bnJfchYjmSuzohKJBrU75czoS9LEBsn5jvuA0M3gv23w226gNb9oJ+vSFWlhohNHcALleshiUrYfFyeP0DmLMA5r0JuXwAzn1wUe6EveQuYevE3CR66Jdg1GDY7bM+tEANmFy2Cp6cB799BpaWdUcfrkjlTNhLAqR9s7c4r9g2Md97ZzhnBOw6INwGqhbvq9bAA3Pg4bmwxoqD1DqUL2fCXhIgTRlNAi02NfSI/eC8kSAlZWpThuHF+spCSE2F5RadXatKMpuSCcWqVnS3MY91+8ZZiLB1scbDLGcSO2MoHH9wmFFUv+93P4bkr+GjJXbkqvDv5W3sMDstq4qJuGhAmlr0IqT9SDQrrjOOhBMGWRGq9UG+/x+49HZ75iWqXJhNyZRihC8KkM5Vgu8IbF+M0bDLHL43XH5M2FHUlv+X3oGr74G8WpC38l6vBnYuZvVhUYA0tej3EG63IHUGfh4mfRfqYjZEW10xZp+Dm33ZOsEHnfKc3jpO7i5kuVhAXkb4YiFjYf/eTMR/9UPYvn/YkdSu/7H3wl/fin7+Ci9nk9JQKNKCgDRm9IQYmG1DI38N2Rsuc7dWobbTgnfh8jtDDaFo53k4dkZSfre5CgUBaWrRv9lyHPPE0bDPLkXr4wr6pMBld8DL7/lk3EOzCs9lk3Jg2YAkWnSYCL/3MCbfTPXrBVMvhYLE+xaBM9ylwLRn4J7/sUMPiTFk+ljpNtrN9qemjJrv6L9tQ6rDvwoXJGyItPpjfPNfcMF/25GnKvdlU3JKd9F2C8jw67VP/So+EqGnDakaOAwk7oqGAif+GFavjUYsBaJYuayNAbPTsmxT5boFpHGCnhFT7rAiRWD8qbDfbrZEW/1x/uBmMG/Zrbg288i3W0Bs28bn5h+C+YzdXdFQIDkV/uL5Trk+5aY83pqSEUWPIO2n0Ob5QCya8/5urFvP4VP3Kcvsz1vhib+UVTWMSrk1a9nh8R/JvzZ0vskRJNGil4kwOYxIy/U5vbncmq6eHwrc/Bhkn/fDsj82FS7JJmWjbw03DUhGX7Btd3YHiD8dp1yrFgKyyXciGwGSaNG9RNrXm1t1OUCi1Vy2AWLUyyl7zEzJa+squREgTRmdBFwVLbkLR+MAKaxRkCVsBESVlmxKxm0WkERG/y7wpSDF9MKXA8QLFb2zYSMgKH9pTcl6b9PWG0ESk7S/5FjknUzBWXKABKd1MZ6sBARY28a2s9LyCQPrA5LRUQLTihEgamUcINFqEVsBEeW46Sl5pEvNDQG5UeDcaEldXDQOkOJ0CqqUrYCg/Lw1JRd3B4iV8w+TjAMkqK5fnB+LAVlvHvLJCGLz/MMBUlynDbKUtYBsMA/5FBCL5x8OkCC7fnG+bAZk3XnIuoBYO/+IGiDmM++H5sKrC2HL3tCwQ8e2p32tWDhQHACFStkMyLrzkHUBsXb+ESVAPl7asf3Nwn+v34UMKGavrmH7WvQFaCEKNvN7ywH5ZB7SDojt848oAVJoV489d+hY+Vjt+wRbDQhQ10Z/c5R0OyAjx+sh8RjPVPAPRuhVo/AUa8kK+M5PC0thjllIfA1GHw69tyhc3sYStgNCnsGt42ROOyA2bQzXXWeJAiB/e7vj9qrYa+s+cOZQOGKfYmvYU852QBTOyCblro5brBa9VoQr7ZF/40ijAIjZMM3cYpV67fV5OD8BO29Xas3olq8CQCZmk9LcAUhGHxI4LrpyF47MZkBMdvEYNB0Iow+Dnj0K5xv1ErYDgvJAa0rMp1ftt1jWbA4X5VusckeQdXPapi+cOQwO/3LUEdh8fNYDAvNak7Jv1wiySsDq6aLtI8iG3c2cinV+I+y4rZ2g2A6IwupsUnrKUS26mwqv29kMn0ZdbYCYzMwO9cccBKd8A7aot6uFbAfEqL0GdpbEBB0hymN2yV9dk/RC2m+3JZz9TRg8sFDJ6Py+GgBBGCaNGb0wBj+PjrTlRVKNI8iGSnxl147bLhuOd6gGQFQ5V2xdg75h56kFQEzO9XE4fhCcdAj0qCvvH5MgalUJIC3S1KK/RDgvCNH89BEFQOa9Bc1lvAcpR5fPbt1x23XQnuXU9r9OVQACPzOA3IVwmv+S+euh1gDpUnP/3eG8Rhiwlb/6lmq9KgBRbpNqeEloGq9WATG5m1utEwd3/DG3YFG4qgSQaQaQxwW+GQVRK4mhlgHp0s3cdp07EsyoEvZVDYCgzDCT9DnAwWELWql/B8inCh7cAOcMB/N4OKyrGgBR5WkzB7H+M5Nav8XaFATmtst8spI4IBxEqgIQeNEA8hbCzuHI6J1XN4JsWsvTj+iYmwR9VQUgymtmDrJIwPqTxR0g3SNw90XQv2+wiFQDICj/MnMQDVY6f7w5QLrX9dKjg1+UVQ2AKCw3t1irEaxfgeAAcYB4/k+vskYSLfqxCNaf7hcJQN6E5qmeN1PFBt0tVnkSqrLITdLL026TteZFEJDvHAYnf8PDJIs0VSW3WG+ZSbrV+2F1tZcbQdbvue4xb5Ekb6aYwt/MLdZcEQ6q3Fy4Fhwgn+rvXhR61hfnmqdYTwBDPTMZkiEHCLhPTbztfAq/N7dYjwgc463p4K3VMiDtHysOghMPcR8retnzVHnIAHKvwHe8NByGrVoFxH3u7mNvU+42t1g3AT/w0U0gpmsNELP+4+zhcLBbMOVf/1JuNCPI9QKX++clGMu1Akhd55Lbb7slt0F0rGvNCHIp8JMgvPnpIwqA/OVNSPr4otBt2uBnD9rYdh4uMtv+JERpDda1996qGRCzruOsYXDIXt7r5pfFqnhRKHxLRkzSPepzvOKXUEHZrUZAzMZxxx4MJx/qNo4Lqh+t66ctzm5CWmNNdWYTOSKymrk8KaoNELf1aHn9wKtan2w9agw2ZfQfgEX79m0sQ7UAsk0/+P5QOMxtXu1VXy/LjvnMJJuUfbo2r7b+ZaHtgJjjD446EMzHhe74g7L6tNeVHmxNyontgDRm9LoYXOG1hyDt2QyIO0AnyJ5SnC+FdQ7QadHvi3BrcVWjWSoKgJR6Pog7gi2afak9qjynt46Tu9tHkKMyeqjC0xEOt2BoUQBk6Uo49YaCoeIO8SysUdglcjBoZlLmumOgPW6J826Btz/s3qg7BtpjwX0yl2tjq5lpWdIOiLlsXzgVhRHE6PjGBzB+Gny0ZP2W27I3nHEkDNsXPhHdp8aNglmbXxR2PcEyOq4LyI0C50ZB3HJiiAogJnZzXvp9z8Cb/+rI5Es7wbEHQd+e5WRmZx3LAfllNikXbAiIOdFzmp3NEY3Nq23Vzo+4bQYkDyfOSMqD6wEyIq3b1NfxsR9iBWEzSiNIEPlG3YfNgKyqY+snrpLF6wFi+zzEARItZGwFRJW/ZlPylS4115svJjJq7TzEAeIA8UIBVaZkU3Jhd4BYOw9xgHjRPbyzYesIAhzfmpSHNwmIzfMQB4h3ndsLS7YCsu78Y6M5iM3zEAeIF93aOxuWAjKvNSn7rqvCRu+sEi16rQhXeidVMJYcIMHoXKwXSwHJtCYltVlARk7UL8Xz/L1YIaJSzgESlZboiMNGQETZfXpK3tgsIOaXTS36IsJ6Q0205N84GgdItFrINkAUnssm5cANVdzkZ0FNLToG4cfRknzz0ThAotVaFgJySTYpPysKkOHX6ID6et4Xi76re+iq6Gy7Ga2uGk40U7Lw+Ivh+C7Day4XY/uZY2Wj77C7/bC0qUWfRDiyDGehVLn9fPjMVqG4dk43oUD6Pnj+NTukUZiVTcq3NhVtt4AkJuiZotxmR4ow+Qxo2NGWaKs/zgtv7fj034YrD6fNSMo9JQEyJK19+9RhTsCttyHJ5lHR3afWBv28jnH0T2HxCq+tem9PlVX5rdh65oWyuiRATOFERqcJjPI+LO8tjjoEThvivV1nsXQFzGKx700pvV4oNZRft6ak29MNNru4LdGiw0T4fSiBl+h0x23hZuv3qC8x6YgWf+T/4DZzLJMFV04ZOjMlT3UXasHVn4mM/lVgbwtyZcrZsOsAGyKt7hgvvxMWvGtFjn9uTcoBm4u0ICCNGT0hBg/YkO6he8GVx9sQafXGOP+fMOYua/Jb78vdkucgXRUSGV0gENGjWtZPy40i4XbOi2+D194PN4aivCuvtKakYJ8uOIIYZ00t+j2E24tyHHKh/XaD8aeGHESNun/mH3DdQ5Yk37kxXKFoiwJk1DSNr1zA2wg7FDIYhd+f/U04+utRiKR2YnhvEVxxlyWPdmFh7z3Z6f6TJFeohYoCpHMUuQhho29VCjkI6/cXHwVDP1lZHFYUteHXPNa97A5YtMySfJXzW1NyYzHRFg3IkLT27FPHewL9izEcdhmT2KmHwcnfCDuS6vbf3UZ5kc1a+WjhAHZ4/hxZW0yMRQNijCVaNCXC+GIMR6WMOQX28mPtO6EpKvptLo5n58PkR2BtwRuVCGWjjG1NyaRiIyoJkM7PT14W2L5YB1Eot31/MPOSA78YhWjsj2HRUrjzD/CHv9qViyrvL8+x2+y0rCo28pIAaZ+LZNS8lr+3WAdRKrfvrnDmUNj9c1GKyp5Ylq2CWS/Ab56G1UXdoEQrt3yeb88YJyXtHloyIJ23Ws+IcEi00i8+GjOiDGqA/b8A/fuA2Vja/DHHErirQ4EVq2HJSli8HF7/AOYsgHlvQi5vp0IKz2aTUnKfLatLfKtFG+qkfd261Qd/2tnULupSFVBYqzH2njFWXi61blmAdI4iN4hwSakOXXmnQNAK5OHHM5JS1k49ZQNiJux947yBsF3QCTt/ToFiFShnYr6u7bIBaR9FxutoibHJlVjFJuDKOQV8VuDk1qT8tlwfFQFSDRP2coVz9aKvQLkTc89GkE5A9hLhpejL5SKsNQXalIGPpWRBJXlXPIIY500ZNWv5bqokEFfXKeClAiqck22WWyq16Qkg7SNJRh8SOK7SgFx9p0ClCij8LpuUYyu1Y+p7BkjnZyhmee6uXgTmbDgFylFA4c3lbewzOy2efFvsGSDtt1rjdV+EPyH0KCc5V8cpUIkC5oVgTvjaY80yrxI7nk7SNwwkkdGLBX7qVYDOjlOgBAUuaE3KL0soX7CopyNIl7emFs0iNBb07go4BTxSwMt5h68jiDE+7Frdaou1/E2Ez3uUvzPjFOhWAYV3l7cx0Kt5h++AGAeJCbo3ylyBPq5tnQI+KrBU8gyaPk58OfTJl1usT261JuhQlFnuq18fu0cNm1alLa8MmTlO/uiXDL4CYoJuGq+nEcOercT8UtrZ9V4BZVRrSnzd1NB3QNohyWgSaPFeIWexVhVQ5apsSq7zO/9AAGmfk2T0ToHT/U7I2a9+BVS5LZuSs4LINDBASGusKc509/g3iGatXh+qPJZN0oiIBpFlcIAAZm+tvnWYCdX+QSTnfFSXAgp/ym/JYd0dduNHtoECYhI4Kq3baR1zgD38SMjZrE4FFF5ua2PQrLQsCjLDwAExyY1I6zb1cZ5A2C/IZJ0vOxVQeJE4R2avln8HnUEogHSOJL3zdbQKHBF00s6fPQqo8sSiPhw951JZGUbUoQFikh2S1ro+ce4R4eQwknc+o62Awv3ZNk4mLaHtxhUqIF3Nk8joFIHzo91cLrogFVDlpmxKzg3S56Z8RQIQE1hTRq8AfH/xE7bgzv/mFVAwj2+vyCZlchS0igwg7ZCM19NUuE2EuiiI42IIXIEcysl+fz5SSlaRAqQTkkEqPCSC22K6lJa0vKzZ4E2U41vHiXkFEJkrcoB0PuHaTuM8gHB4ZJRygfimgHlSFctxyvS0fOSbkzINRxKQ9lzSGkvESQs0I8TKzM9Vi7ICSl6FH2WbaQnq05FS5YguIJ2ZNE3QoZpnmgjblJqcKx9dBRQ+VDhxRlL+N7pRerjtj59JHn2N7pCr52EBd3atn0IHZNtsCRoXjn+0WT4IyGXZbiI/gnRl1v5SsY5JApeXna2rGKoC5hGuKNf2aiBVzBHMoQbb6dwaQLrEamrR4SrcJLB7FAR0MRSngMLrKOdkU/JEcTWiUco6QIxso9LaY0WcMSI0A72iIaWLYpMKKCsUJvbOcf39aVljm0pWAtIl8vCM7tRD+QWCJ/uw2tZ4UY9X4eG1cNHjSXkn6rF2F5/VgGxw2/Urty9wNLqhKq8R4+xss/whGhGVH0VVAGLSH/kL3SK+hDHAWHfbVX6HqKimuZ0SJvRuY7KNt1Obyr1qAOlK7ugJ+tlcnjEIP3Cb1lXU3YuvrCxT4ea4MNmGR7fFJ2bJe5BSEuoqa1Yt1sUxG2lfgLB1OTZcnc0roGBW+E2pb+Onj6TlP9WoV9WNIBs20tHXab+2tZwXUy5BGFCNjRhCTuYF3w1rtuDGx8fI8hD8B+ay6gHpUtLsqNInztlmrYHbVLvM/qW8jXD9sjZunZ2WVWVasapazQCybqs0TtCzYsr3gYOtaq3wgp2bF26b0Sy3hhdCOJ5rEpAuqRszuksMvosyGqEhnCaIrNf5wNQ83DMjKW9FNkqfA6tpQNbVNjFeDyDGaLOirVYXayksRLkPZWp2nDzvc9+zwrwDZMNmSmussZ6hsXz7qGJO7e1nRUuWH+RShYdUmDpjLU+GuYNI+Sn4V9MBshltD/iV1m//IfspDEYZJMIgYCf/miMAyx0T7Tkoc8zfCz/DC8+fI2sD8GylCwdIic1m1qbk6xhsoGkHRtk/qqf6KqwW5c9dQMTaePbRH8l7JaZc08UdIBU2v1mn0jPOF2LCwBg0oAwEBio0BLUKUpVFCPNFWWD+zsOCeIwFS9fw6uy0tFWYYk1Xd4D42PzDr9EB9fF2UAww5tZsa4R+YuY1Sj+E3mr+X+fPXUB1dvilwFKB/6CsAJaYnxGWqrJYY7wtORbk65g/c6x86GMaNW36/wGqDI2ah4lCygAAAABJRU5ErkJggg=="

/***/ }),

/***/ "C8CO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"检查清单","visible":_vm.dialogVisible,"append-to-body":"","width":"1200px"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.closeForm}},[_c('el-radio-group',{staticStyle:{"margin":"0 0 0px 20px"},attrs:{"size":"small"},on:{"change":_vm.changeType},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},[_c('el-radio-button',{attrs:{"label":1}},[_vm._v("行业领域检查清单")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":4}},[_vm._v("网格员检查导则")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":2}},[_vm._v("专项检查清单")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":3}},[_vm._v("重大隐患检查清单")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":5}},[_vm._v("主体责任检查清单")])],1),_vm._v(" "),_c('div',{staticClass:"table-container",staticStyle:{"padding":"0px 0px 20px 20px"}},[_c('div',{staticClass:"fl-wrap mg-tp-sm",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v(_vm._s(_vm.title)+"名称")]),_vm._v(" "),_c('el-input',{staticClass:"item",staticStyle:{"width":"300px","margin-right":"15px"},attrs:{"clearable":"","size":"mini","placeholder":("请输入" + _vm.title + "名称")},model:{value:(_vm.searchForm.name),callback:function ($$v) {_vm.$set(_vm.searchForm, "name", $$v)},expression:"searchForm.name"}})],1),_vm._v(" "),(_vm.type != 4)?_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("适用行业类型")]),_vm._v(" "),_c('el-cascader',{attrs:{"size":"mini","clearable":"","options":_vm.industryOptions},on:{"clear":function($event){_vm.searchForm.control_id=null}},model:{value:(_vm.searchForm.control_id),callback:function ($$v) {_vm.$set(_vm.searchForm, "control_id", $$v)},expression:"searchForm.control_id"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("上传部门")]),_vm._v(" "),_c('el-cascader',{ref:"departmentTree",attrs:{"size":"mini","show-all-levels":false,"options":_vm.departmentData,"props":{ checkStrictly: true, label: 'name', value: 'id' },"clearable":""},on:{"change":_vm.change},model:{value:(_vm.searchForm.create_department),callback:function ($$v) {_vm.$set(_vm.searchForm, "create_department", $$v)},expression:"searchForm.create_department"}})],1),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("上传时间")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"margin-right":"15px"},attrs:{"type":"daterange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","size":"mini","value-format":"yyyy-MM-dd","placeholder":"选择日期"},model:{value:(_vm.Daterange),callback:function ($$v) {_vm.Daterange=$$v},expression:"Daterange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"fl-wrap mg-tp-sm",staticStyle:{"width":"100%","display":"flex"}},[_c('el-button',{staticClass:"search-item",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.reset}},[_vm._v("重置")]),_vm._v(" "),_c('el-button',{staticClass:"search-item",staticStyle:{"height":"28px","margin-left":"5px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{staticClass:"search-item",staticStyle:{"height":"28px","margin-left":"5px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.save}},[_vm._v("确 定")])],1),_vm._v(" "),_c('div',{staticClass:"ruleform"},[_c('div',{staticClass:"table"},[_c('div',{staticStyle:{"font-size":"18px","margin-bottom":"10px","display":"flex","align-items":"center"}})]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"color":"#303133","width":"100%","margin-bottom":"10px"},attrs:{"data":_vm.tableData,"highlight-current-row":"","header-cell-style":{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'},"border":"","stripe":""},on:{"select":_vm.select,"select-all":_vm.selectAll,"cell-dblclick":_vm.tableDbEdit,"current-change":_vm.currentChange}},[(_vm.selectType == 'multiple')?_c('el-table-column',{attrs:{"type":"selection","width":"55"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":"","prop":"name","label":_vm.title}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"count","label":"检查项数","width":"90"}}),_vm._v(" "),(_vm.type != 4)?_c('el-table-column',{attrs:{"show-overflow-tooltip":"","prop":"control_name","label":"适用行业类型"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n            "+_vm._s(row.control_name || '-')+"\n          ")]}}],null,false,277317229)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":"","prop":"create_department","label":"上传部门"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n            "+_vm._s(row.create_department || '-')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"is_default","label":"是否在企业端展示"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n            "+_vm._s(row.is_default == 1 ? '是' : '否')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"180","formatter":function (row) { return row.create_time || '-'; },"prop":"create_time","label":"上传时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"formatter":function (row) { return row.update_date || '-'; },"prop":"update_date","label":"更新时间"}})],1),_vm._v(" "),(_vm.pagination)?_c('el-row',{staticStyle:{"width":"100%"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"float":"right","padding":"10px"}},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-size":10,"layout":"total, prev, pager, next, jumper","total":_vm.totalCount},on:{"current-change":_vm.handleCurrentChange}})],1)])],1):_vm._e()],1)]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CUIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[_c('el-header',{attrs:{"height":"70px;display:flex;align-items:center"}},[_c('Headbar')],1),_vm._v(" "),_c('el-container',[_c('el-main',{staticClass:"main"},[_c('div',{staticClass:"view"},[(_vm.condition)?_c('router-view',{ref:"view"}):_vm._e()],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Co0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("uNeA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2435887d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("Z8Y/");
function injectStyle (ssrContext) {
  __webpack_require__("gaV6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2435887d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2435887d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DOow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 2,
  path: '/enterpriseManagement',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/enterpriseManagement/index',
  name: 'enterpriseManagement',
  isHead: true,
  meta: {
    title: '一企一档',
    icon: 'el-icon-s-management'
  },
  children: [{
    path: 'index',
    component: function component() {
      return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "ZTun"));
    },
    name: 'EnterpriseManagement',
    meta: { title: '一企一档', close: true }
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "DqVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_types__ = __webpack_require__("meMj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    href: String,
    url: String,
    download: String,
    unitId: Number,
    params: Object,
    prompt: String
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      fileList: [],
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'file',
        role: 4
      },
      importloading: false
    };
  },

  methods: {
    // 显示表单对话框
    showImportUserDlg: function showImportUserDlg() {
      this.dialogFormVisible = true;
    },

    // 隐藏对话框
    hideDlg: function hideDlg() {
      this.dialogFormVisible = false;
    },

    // 打开对话框的事件响应
    handleDialogOpen: function handleDialogOpen() {
      this.fileList = [];
    },
    handleError: function handleError(err) {
      console.log(err);
      this.$alert('导入超时：' + response.data.msg, '提示', {
        confirmButtonText: '确定',
        callback: function callback(action) {}
      });
    },
    handleSuccess: function handleSuccess(res, file, fileList) {
      var _this = this;

      this.fileList = [];
      if (res.code === 0) {
        this.importloading = true;
        this.$http.post(this.url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          file: res.data['url'],
          unit_id: this.unitId ? this.unitId : null
        }, this.params)).then(function (response) {
          _this.importloading = false;
          if (response.data.code === 0) {
            // 如果成功
            _this.$alert(_this.prompt ? _this.prompt : '导入成功！', '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              callback: function callback(action) {
                // 关闭对话框
                _this.dialogFormVisible = false;
                // 触发刷新表格事件
                _this.$emit('refreshTable');
              }
            });
          } else {
            // 如果失败
            _this.$alert('导入失败！原因：' + response.data.msg, '提示', {
              confirmButtonText: '确定',
              callback: function callback(action) {}
            });
          }
        }).catch(function (error) {
          _this.$alert('导入失败！已超时：' + response.data.msg, '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {}
          });
          console.log(error);
        });
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__vuex_types__["LOGOUT"]);
        this.$router.replace({ name: 'login' });
      } else {
        this.$alert('文件上传失败！', '提示', {
          confirmButtonText: '确定',
          callback: function callback(action) {}
        });
      }
    },
    beforeUpload: function beforeUpload(file) {
      console.log(file, "文件信息！");
      var isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel' || file.type === 'application/wps-office.xlsx';
      var isLt5M = file.size / 1024 / 1024 < 200;
      if (!isXLSX) {
        this.$message.error('上传文件只能是 XLSX 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 200MB!');
      }
      return isXLSX && isLt5M;
    }
  }
});

/***/ }),

/***/ "EOjP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    iscollapse: Boolean
  },
  data: function data() {
    return {
      userInfo: {},
      permissionMap: {}
    };
  },

  computed: {
    query: function query() {
      return this.permissionMap['QueryVisited'] && this.permissionMap['NoQueryVisited'] && this.permissionMap['QuestionableRecords'] && this.permissionMap['RevenueAlert'];
    },
    showAdmin: function showAdmin() {
      var userInfo = this.$store.getters.userInfo;
      if (userInfo.department_id === 0 && userInfo.town_id === 0) {
        return true;
      } else {
        return false;
      }
    },
    showDepartment: function showDepartment() {
      var userInfo = this.$store.getters.userInfo;
      if (userInfo.department_id === 0) {
        return false;
      } else {
        return true;
      }
    },
    showTown: function showTown() {
      var userInfo = this.$store.getters.userInfo;
      if (userInfo.town_id === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted: function mounted() {
    var userInfo = this.$store.getters.userInfo;
    this.userInfo = userInfo;
    // 权限表
    var permissionMap = {};
    var permissionList = JSON.parse(this.$store.state.permissionList);
    for (var i in permissionList) {
      permissionMap[permissionList[i]] = true;
    }
    this.permissionMap = permissionMap;
  }
});

/***/ }),

/***/ "EpLh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FHe3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-item"},[(_vm.showTitle)?_c('span',{staticClass:"span"},[_vm._v("区域")]):_vm._e(),_vm._v(" "),(_vm.type == 'area' || _vm.type == 'town' || _vm.type == 'village')?_c('el-select',{staticStyle:{"width":"140px"},attrs:{"size":"mini","clearable":"","value":_vm.area,"placeholder":"请选择区/县"},on:{"change":_vm.changeArea}},_vm._l((_vm.baseOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.type == 'town' || _vm.type == 'village')?_c('el-select',{staticStyle:{"margin-left":"10px","width":"140px"},attrs:{"size":"mini","clearable":"","value":_vm.town,"placeholder":"请选择乡镇/街道"},on:{"change":_vm.changeTown}},_vm._l((_vm.townOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.type == 'village')?_c('el-select',{staticStyle:{"margin-left":"10px","width":"140px","margin-right":"15px"},attrs:{"size":"mini","clearable":"","value":_vm.village,"placeholder":"请选择村/社区"},on:{"change":_vm.changeVillage}},_vm._l((_vm.villageOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G0Jh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScreenAdapter',
  props: {
    w: { // 设计图尺寸宽
      type: [Number, String],
      default: 1920
    },
    h: { // 设计图尺寸高
      type: [Number, String],
      default: 1080
    }
  },
  data: function data() {
    return {
      style: {
        width: this.w + 'px',
        height: this.h + 'px',
        transform: 'scale(1)' // 默认不缩放
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.setScale();
    this.onresize = this.debounce(function () {
      return _this.setScale();
    }, 100);
    window.addEventListener('resize', this.onresize);
  },

  methods: {
    // 防抖
    debounce: function debounce(fn, t) {
      var delay = t || 500;
      var timer = void 0;
      // eslint-disable-next-line func-names
      return function () {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        var context = this;
        timer = setTimeout(function () {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },

    // 获取缩放比例
    getScale: function getScale() {
      var w = window.innerWidth / this.w;
      var h = window.innerHeight / this.h;
      return w < h ? w : h;
    },

    // 设置缩放比例
    setScale: function setScale() {
      var scale = window.innerWidth / this.w;
      this.style.transform = 'scale(' + scale + ')';
      var h = this.h * scale;
      this.style.height = h + 'px';
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onresize);
  }
});

/***/ }),

/***/ "G1N0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("EOjP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ddaa4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("mcCj");
function injectStyle (ssrContext) {
  __webpack_require__("TMsn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24ddaa4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ddaa4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GBvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container",staticStyle:{"padding":"0px 0px 20px 20px"}},[_c('div',{staticClass:"fl-wrap mg-tp-sm",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('el-input',{staticClass:"item",staticStyle:{"width":"300px","margin-right":"15px"},attrs:{"clearable":"","size":"mini","placeholder":("请输入" + _vm.title)},model:{value:(_vm.searchForm.name),callback:function ($$v) {_vm.$set(_vm.searchForm, "name", $$v)},expression:"searchForm.name"}})],1),_vm._v(" "),(_vm.type != 4)?_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("适用行业类型")]),_vm._v(" "),_c('el-cascader',{attrs:{"size":"mini","clearable":"","options":_vm.industryOptions},model:{value:(_vm.searchForm.control_id),callback:function ($$v) {_vm.$set(_vm.searchForm, "control_id", $$v)},expression:"searchForm.control_id"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("上传部门")]),_vm._v(" "),_c('el-cascader',{ref:"departmentTree",attrs:{"size":"mini","show-all-levels":false,"options":_vm.departmentData,"props":{ checkStrictly: true, label: 'name', value: 'id' },"clearable":""},on:{"change":_vm.change},model:{value:(_vm.searchForm.create_department),callback:function ($$v) {_vm.$set(_vm.searchForm, "create_department", $$v)},expression:"searchForm.create_department"}})],1),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("上传时间")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"margin-right":"15px"},attrs:{"type":"daterange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","size":"mini","value-format":"yyyy-MM-dd","placeholder":"选择日期"},model:{value:(_vm.Daterange),callback:function ($$v) {_vm.Daterange=$$v},expression:"Daterange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"fl-wrap mg-tp-sm",staticStyle:{"width":"100%","display":"flex"}},[_c('el-button',{staticClass:"search-item",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.reset}},[_vm._v("重置")]),_vm._v(" "),_c('el-button',{staticClass:"search-item",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.refreshTable}},[_vm._v("查询")])],1),_vm._v(" "),_c('div',{staticClass:"ruleform"},[_vm._m(0),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"color":"#303133","width":"100%","margin-bottom":"10px"},attrs:{"data":_vm.tableData,"highlight-current-row":"","header-cell-style":{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'},"border":"","stripe":""},on:{"select":_vm.select,"select-all":_vm.selectAll,"cell-dblclick":_vm.tableDbEdit,"current-change":_vm.currentChange}},[(_vm.selectType == 'multiple')?_c('el-table-column',{attrs:{"type":"selection","width":"55"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":"","prop":"name","label":_vm.title}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"count","label":"检查项数","width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":"","prop":"control_name","label":"适用行业类型"}}),_vm._v(" "),_c('el-table-column',{attrs:{"show-overflow-tooltip":"","prop":"create_department","label":"上传部门"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(row.create_department || '-')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","prop":"is_default","label":"是否在企业端展示"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\n          "+_vm._s(row.is_default == 1 ? '是' : '否')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"180","formatter":function (row) { return row.create_time || '-'; },"prop":"create_time","label":"上传时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"formatter":function (row) { return row.update_date || '-'; },"prop":"update_date","label":"更新时间"}})],1),_vm._v(" "),_c('el-row',{staticStyle:{"width":"100%"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"float":"right","padding":"10px"}},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-size":10,"layout":"total, prev, pager, next, jumper","total":_vm.totalCount},on:{"current-change":_vm.handleCurrentChange}})],1)])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table"},[_c('div',{staticStyle:{"font-size":"18px","margin-bottom":"10px","display":"flex","align-items":"center"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J8Un":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addOrUpdateForm__ = __webpack_require__("pCDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_qiboMixins__ = __webpack_require__("pBm9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    addOrUpdateForm: __WEBPACK_IMPORTED_MODULE_1__addOrUpdateForm__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_qiboMixins__["e" /* tableMixins */]],
  data: function data() {
    return {
      data_class: 'Recheck',
      pagination: true,
      review_status: null
    };
  },
  mounted: function mounted() {},

  methods: {
    initTableData: function initTableData(res) {
      this.review_status = res.data.page_info.review_status;
    },
    handleReview: function handleReview() {
      var _this = this;

      this.$confirm('确认复核通过?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_0__api_api__["a" /* api */]['handleReviewPass'], { company_id: _this.$store.state.companyId }).then(function (response) {
          if (response.data.code === 0) {
            _this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            _this.$message({
              type: 'warning',
              message: '操作失败 ' + response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "JJCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("R6Np");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02168cb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("AdUb");
function injectStyle (ssrContext) {
  __webpack_require__("lgZ+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02168cb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02168cb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JaJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"body-style":{ padding: '10px', fontSize: '14px' }}},[_c('div',{staticClass:"fl"},[_c('div',{staticClass:"fl-center",staticStyle:{"flex":"1","margin-right":"8px"}},[(_vm.type == 'doc')?_c('img',{staticClass:"doc",attrs:{"src":__webpack_require__("UR5A")}}):_vm._e(),_vm._v(" "),(_vm.type == 'video')?_c('img',{staticClass:"video",attrs:{"src":__webpack_require__("Bfn9")}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contain",staticStyle:{"flex":"2"}},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"i",staticStyle:{"margin-top":"20px"}},[(_vm.type == 'doc')?_c('el-link',{attrs:{"href":_vm.download,"target":"_blank","type":"primary"}},[_c('i',{staticClass:"el-icon-download"}),_vm._v("下载")]):_vm._e(),_vm._v(" "),(_vm.type == 'video')?_c('el-link',{attrs:{"href":_vm.download,"target":"_blank","type":"primary"}},[_c('i',{staticClass:"el-icon-video-play"}),_vm._v("播放")]):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNaa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KoSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dialog_",attrs:{"title":"企业列表","visible":_vm.dialogVisible,"append-to-body":"","width":"1000px"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.closeForm}},[_c('div',{staticClass:"container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"fl-wrap mg-tp-sm"},[_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("行业监管部门")]),_vm._v(" "),_c('el-cascader',{ref:"departmentTree",attrs:{"size":"mini","show-all-levels":false,"options":_vm.departmentData,"props":{ checkStrictly: true, label: 'name', value: 'id' },"clearable":""},on:{"change":_vm.change,"clear":function($event){_vm.searchForm.path=null}},model:{value:(_vm.searchForm.path),callback:function ($$v) {_vm.$set(_vm.searchForm, "path", $$v)},expression:"searchForm.path"}})],1),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("企业名称")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"160px","margin-right":"15px"},attrs:{"clearable":"","size":"mini","placeholder":"请输入企业名称"},model:{value:(_vm.searchForm.name),callback:function ($$v) {_vm.$set(_vm.searchForm, "name", $$v)},expression:"searchForm.name"}})],1),_vm._v(" "),_c('div',{staticClass:"search-item"},[_c('span',{staticClass:"span"},[_vm._v("行业类型")]),_vm._v(" "),_c('el-cascader',{attrs:{"filterable":"","collapse-tags":"","size":"mini","clearable":"","show-all-levels":false,"props":{ multiple: true },"options":_vm.industryOptions},on:{"change":_vm.selectControlId},model:{value:(_vm.searchForm.control_id),callback:function ($$v) {_vm.$set(_vm.searchForm, "control_id", $$v)},expression:"searchForm.control_id"}})],1),_vm._v(" "),_c('selectArea',{attrs:{"area":_vm.searchForm.area_id,"town":_vm.searchForm.town,"village":_vm.searchForm.village},on:{"update:area":function($event){return _vm.$set(_vm.searchForm, "area_id", $event)},"update:town":function($event){return _vm.$set(_vm.searchForm, "town", $event)},"update:village":function($event){return _vm.$set(_vm.searchForm, "village", $event)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-bottom":"10px"}},[_c('el-button',{staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.reset}},[_vm._v("重置")]),_vm._v(" "),_c('el-button',{staticClass:"mg-lf-sm",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.search}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{staticClass:"mg-lf-sm",staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.heightSearch}},[_vm._v("高级查询")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.advancedSearch),expression:"advancedSearch"}]},[_c('div',{staticClass:"fl-wrap mg-tp-sm"},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"2"},model:{value:(_vm.searchForm.company_level_two),callback:function ($$v) {_vm.$set(_vm.searchForm, "company_level_two", $$v)},expression:"searchForm.company_level_two"}},[_vm._v("存在重大隐患单位")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.company_level_one),callback:function ($$v) {_vm.$set(_vm.searchForm, "company_level_one", $$v)},expression:"searchForm.company_level_one"}},[_vm._v("存在一般隐患单位")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_supervision_check),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_supervision_check", $$v)},expression:"searchForm.is_supervision_check"}},[_vm._v("加入监督检查库单位")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_fire_safety_focus),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_fire_safety_focus", $$v)},expression:"searchForm.is_fire_safety_focus"}},[_vm._v("属于消防重点单位")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_fire_danger),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_fire_danger", $$v)},expression:"searchForm.is_fire_danger"}},[_vm._v("属于火灾高危单位")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_safety_insurance),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_safety_insurance", $$v)},expression:"searchForm.is_safety_insurance"}},[_vm._v("购买安责险")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_has_limited_space_task),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_has_limited_space_task", $$v)},expression:"searchForm.is_has_limited_space_task"}},[_vm._v("是否涉及有限空间作业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_overdue_safety_standard),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_overdue_safety_standard", $$v)},expression:"searchForm.is_overdue_safety_standard"}},[_vm._v("安全标准化证书过期")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_metal_company),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_metal_company", $$v)},expression:"searchForm.is_metal_company"}},[_vm._v("金属冶炼企业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_deep_well_process),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_deep_well_process", $$v)},expression:"searchForm.is_deep_well_process"}},[_vm._v("铝加工（深井铸造）企业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_has_metal_dust),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_has_metal_dust", $$v)},expression:"searchForm.is_has_metal_dust"}},[_vm._v("涉粉30人以上和铝镁等金属粉尘涉爆企业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_has_ammonia),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_has_ammonia", $$v)},expression:"searchForm.is_has_ammonia"}},[_vm._v("涉氨制冷企业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_major_hazard_source),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_major_hazard_source", $$v)},expression:"searchForm.is_major_hazard_source"}},[_vm._v("构成重大危险源")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_has_chlorine),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_has_chlorine", $$v)},expression:"searchForm.is_has_chlorine"}},[_vm._v("涉氯企业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.risk_level),callback:function ($$v) {_vm.$set(_vm.searchForm, "risk_level", $$v)},expression:"searchForm.risk_level"}},[_vm._v("重大安全风险等级（红色）企业")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_no_safety_standard),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_no_safety_standard", $$v)},expression:"searchForm.is_no_safety_standard"}},[_vm._v("未创建安全标准化")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_three_ts_unfinished),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_three_ts_unfinished", $$v)},expression:"searchForm.is_three_ts_unfinished"}},[_vm._v("三同时未完成")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"true-label":"1"},model:{value:(_vm.searchForm.is_has_dust),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_has_dust", $$v)},expression:"searchForm.is_has_dust"}},[_vm._v("涉及涉爆粉尘")])],1)]),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"highlight-current-row":"","data":_vm.tableData,"header-cell-style":{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'},"cell-style":{padding: '5px 0',color: '#303133'},"border":"","stripe":""},on:{"select":_vm.select,"select-all":_vm.selectAll}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"index","label":"序号","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"企业名称","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"credit_code","label":"统一信用代码","show-overflow-tooltip":"","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"area.name","formatter":function (row) { return row.area && row.area ? row.area: '--'; },"show-overflow-tooltip":"","label":"区域","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_vm._v("\r\n              "+_vm._s(row.area)+"-"+_vm._s(row.town)+_vm._s(row.village ? '-' + row.village : '')+"\r\n            ")]}}])})],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"float":"right","padding":"10px"}},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[10, 100, 500, 1000, 5000, 10000],"page-size":10,"layout":"sizes, total, prev, pager, next, jumper","total":_vm.totalCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event},"update:current-page":function($event){_vm.currentPage=$event}}})],1)])],1)],1)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.save}},[_vm._v("确 定")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LBnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 8,
  path: '/supervisionCheck',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/supervisionCheck/supervision/supervisionTasks',
  name: 'supervisionCheck',
  isHead: true,
  meta: {
    title: '监督检查',
    img: __webpack_require__("+Ij5")
  },
  children: [{
    path: 'supervision',
    component: function component() {
      return __webpack_require__.e/* import() */(163).then(__webpack_require__.bind(null, "wKId"));
    },
    name: 'supervisionCheck',
    meta: { title: '监督检查', close: false },
    children: [{
      path: 'supervisionTasks',
      name: 'supervisionTasks',
      component: function component() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "w0CW"));
      },
      meta: { title: '监督检查管理', next: '/supervisionCheck/supervision/supervisionTasks', close: true }
    }, {
      path: 'supervision',
      component: function component() {
        return __webpack_require__.e/* import() */(143).then(__webpack_require__.bind(null, "Ia34"));
      },
      name: 'supervision',
      meta: { title: '临时检查对象', next: '/supervisionCheck/supervision/supervision', close: false }
    }, {
      path: 'checkTasks',
      name: 'checkTasks',
      component: function component() {
        return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "EOL0"));
      },
      meta: { title: '检查任务部署', next: '/supervisionCheck/supervision/checkTasks', close: true }
    }, {
      path: 'notcheckTasks',
      name: 'notcheckTasks',
      component: function component() {
        return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, "E28L"));
      },
      meta: { title: '待检查任务', next: '/supervisionCheck/supervision/notcheckTasks', close: true }
    }, {
      path: 'deliverTracks',
      name: 'deliverTracks',
      component: function component() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "eH0f"));
      },
      meta: { title: '隐患移交跟踪', next: '/supervisionCheck/supervision/deliverTracks', close: true }
    },
    //隐患跟踪统计
    {
      path: 'track',
      component: function component() {
        return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, "2erK"));
      },
      name: 'track',
      meta: { title: '任务隐患跟踪表', close: true }
    }, {
      path: 'statistics',
      component: function component() {
        return __webpack_require__.e/* import() */(156).then(__webpack_require__.bind(null, "RDeW"));
      },
      name: 'statistics',
      meta: { title: '层级隐患数统计', close: true }
    }, {
      path: 'regulate',
      component: function component() {
        return __webpack_require__.e/* import() */(188).then(__webpack_require__.bind(null, "lWSF"));
      },
      name: 'regulate',
      meta: { title: '隐患动态管理', close: true }
    },
    //定期检查计划
    {
      path: 'schedule1',
      name: 'schedule1',
      component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "VE1I"));
      },
      meta: { title: '企业专项检查部署', next: '/supervisionCheck/supervision/schedule2', close: true }
    }, {
      path: 'schedule2',
      name: 'schedule2',
      component: function component() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "JXK8"));
      },
      meta: { title: '政府检查计划部署', next: '/supervisionCheck/supervision/schedule4', close: true }
    },
    // {
    //   path: 'schedule3',
    //   name: 'schedule3',
    //   component: () => import('@/views/hiddenCheck/supervision/components/supervisionTable'),
    //   meta: { title: '新建检查部署', next: '/supervisionCheck/supervision/schedule3', close: true}
    // },
    {
      path: 'schedule4',
      name: 'schedule4',
      component: function component() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "+UDS"));
      },
      meta: { title: '检查人员账号管理', next: '/supervisionCheck/supervision/hideenMaintain', close: true }
    },
    //检查清单维护
    {
      path: 'hideenMaintain',
      name: 'hideenMaintain',
      component: function component() {
        return __webpack_require__.e/* import() */(3/* duplicate */).then(__webpack_require__.bind(null, "SFNC"));
      },
      meta: { title: '行业领域检查清单', next: '/supervisionCheck/supervision/meshWelding', close: true }
    }, {
      path: 'meshWelding',
      name: 'meshWelding',
      component: function component() {
        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, "i7IS"));
      },
      meta: { title: '网格员检查导则', next: '/supervisionCheck/supervision/specialList', close: true }
    }, {
      path: 'specialList',
      name: 'specialList',
      component: function component() {
        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "HmMP"));
      },
      meta: { title: '专项检查清单', next: '/supervisionCheck/supervision/dangerList', close: true }
    }, {
      path: 'dangerList',
      name: 'dangerList',
      component: function component() {
        return __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, "Nt/Y"));
      },
      meta: { title: '重大隐患检查清单', next: '/supervisionCheck/supervision/mainCheckList', close: true }
    }, {
      path: 'mainCheckList',
      name: 'mainCheckList',
      component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, "JQvs"));
      },
      meta: { title: '主体责任检查清单', close: true }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "Ldr4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_selectArea_selectArea__ = __webpack_require__("w2XR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Util_Search__ = __webpack_require__("JJCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_3__Util_Search__["a" /* default */],
    selectArea: __WEBPACK_IMPORTED_MODULE_2__components_selectArea_selectArea__["a" /* default */]
  },
  data: function data() {
    return {
      searchForm: {
        name: '',
        phone: ''
      },
      dialogVisible: true,
      staff: null,
      loading: false,
      jobOptions: [],
      tableData: [],
      checkedData: null, // 选中的节点
      currentPage: 1,
      totalCount: 0,
      parent_node_id: 0, // 父级ID
      parent_node_label: null, // 父级名称
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      callback: null,
      SelectionAll: {},
      SelectionTable: [],
      responsible_person: null
    };
  },
  mounted: function mounted() {
    this.getGovCheckExpertList();
  },

  methods: {
    search: function search() {
      this.currentPage = 1;
      this.getGovCheckExpertList();
    },
    reset: function reset() {
      for (var key in this.searchForm) {
        this.searchForm[key] = null;
      }
      this.search();
    },
    deleteStaff: function deleteStaff(row, index) {
      var _this = this;

      this.select({}, row);
      this.$nextTick(function () {
        _this.getGovCheckExpertList();
      });
    },
    closeForm: function closeForm() {
      this.staff = null;
      this.checkedData = null;
      // this.$refs['table'].setCurrentRow()
      this.$el.parentNode.removeChild(this.$el);
    },
    save: function save() {
      if (this.SelectionTable.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请选择检查人员'
        });
      }
      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.SelectionTable);
      }
      // this.$emit('getStaff', staff)
      this.dialogVisible = false;
    },
    currentChange: function currentChange(currentRow) {
      if (currentRow) {
        this.staff = currentRow;
      }
    },
    getGovCheckExpertList: function getGovCheckExpertList() {
      var _this2 = this;

      var params = {
        page_index: this.currentPage,
        page_size: 10
      };
      for (var key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          params[key] = this.searchForm[key];
        }
      }
      this.loading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* api */]['getGovCheckExpertList'], params).then(function (response) {
        _this2.tableData = response.data.data;
        _this2.$nextTick(function () {
          _this2.checkSelect();
        });
        _this2.totalCount = response.data.page_info.total_num;
        _this2.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.getGovCheckExpertList();
    },
    select: function select(selection, row) {
      for (var key in this.SelectionAll) {
        if (key == row.id) {
          delete this.SelectionAll[key];
          this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
          return;
        }
      }
      this.SelectionAll[row.id] = row;
      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
    },
    selectAll: function selectAll(select) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          if (select.length === 0) {
            delete this.SelectionAll[row.id];
          } else {
            this.SelectionAll[row.id] = row;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
    },

    // 每次刷新时检查是否有选项，并设置已选中
    checkSelect: function checkSelect() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var row = _step2.value;

          if (this.SelectionAll.hasOwnProperty(row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "LmM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__permission__ = __webpack_require__("jgnN");


//批量注册指令(现在就一个permission)
var directives = {
    permission: __WEBPACK_IMPORTED_MODULE_1__permission__["a" /* default */]
    //注册的一般写法，循环遍历directives，通过vue.directive注册
};/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(directives).forEach(function (key) {
            Vue.directive(key, directives[key]);
        });
    }
});

/***/ }),

/***/ "M4wK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v("✔提交成功")]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("您得更改申请已成功提交，请等待上级审核")]),_vm._v(" "),_c('div',[_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":_vm.goon}},[_vm._v("继续留在该企业")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"warning"},on:{"click":_vm.back}},[_vm._v("返回企业管理")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c772b728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ngqr");
function injectStyle (ssrContext) {
  __webpack_require__("b14p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c772b728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDOG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectCompanyDialog_vue__ = __webpack_require__("9jSJ");



var selectCompanyConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__selectCompanyDialog_vue__["a" /* default */]);
var instance = void 0;

var selectTip = function selectTip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  instance = new selectCompanyConstructor({
    data: options
  });
  document.body.appendChild(instance.$mount().$el);
};

// export default importTip
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$selectCompany = selectTip;
  }
});

/***/ }),

/***/ "MN1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc052070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__("ZoXT");
function injectStyle (ssrContext) {
  __webpack_require__("zTUO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc052070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc052070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MvGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);



var common = {
  install: function install($Vue) {
    var Vue = $Vue.prototype;
    var common = {
      // 导出excel表格
      // data：导出参数，name：表格名称，cols： 每列宽度
      exportExcel: function exportExcel(data, name) {
        var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var sheet = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.aoa_to_sheet(data);
        sheet['!cols'] = cols;
        this.downExcel(this.sheetBlob(sheet), name);
      },
      downExcel: function downExcel(url, saveName) {
        if ((typeof url === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(url)) === 'object' && url instanceof Blob) {
          url = URL.createObjectURL(url); // 创建blob地址
        }
        var aLink = document.createElement('a');
        aLink.href = url;
        aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
        var event = void 0;
        if (window.MouseEvent) event = new MouseEvent('click');else {
          event = document.createEvent('MouseEvents');
          event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        }
        aLink.dispatchEvent(event);
      },

      // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
      sheetBlob: function sheetBlob(sheet, sheetName) {
        sheetName = sheetName || 'sheet1';
        var workbook = {
          SheetNames: [sheetName],
          Sheets: {}
        };
        workbook.Sheets[sheetName] = sheet;
        // 生成excel的配置项
        var wopts = {
          bookType: 'xlsx', // 要生成的文件类型
          bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
          type: 'binary'
        };
        var wbout = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.write(workbook, wopts);
        var blob = new Blob([s2ab(wbout)], {
          type: 'application/octet-stream'
        });
        // 字符串转ArrayBuffer
        function s2ab(s) {
          if (typeof ArrayBuffer !== 'undefined') {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) {
              view[i] = s.charCodeAt(i) & 0xFF;
            }return buf;
          } else {
            var buf = new Array(s.length);
            for (var i = 0; i != s.length; ++i) {
              buf[i] = s.charCodeAt(i) & 0xFF;
            }return buf;
          }
        }
        return blob;
      }
    };
    // 将公共方法复制到原型上
    Vue.$common = common;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),

/***/ "Mwe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("meMj");


var _mutations;

// tab页的状态

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    pageList: []
  },
  getters: {},
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["RESETPAGELIST"], function (state, data) {
    state.pageList = [{
      name: 'Home',
      meta: {
        title: '工作台',
        close: false
      }
    }];
    // if(data == 1) {
    //   state.pageList = [{
    //     name: 'home/index',
    //     meta: {
    //       title: '整体数据概况',
    //       close: false
    //     }
    //   }]
    // } else {
    //   state.pageList = [{
    //     name: 'enterpriseManagement/index',
    //     meta: {
    //       title: '企业信息查询',
    //       close: false
    //     }
    //   }]
    // }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["GETPAGELIST"], function (state, data) {
    var newdata = {};
    newdata.name = data.name;
    newdata.meta = data.meta;
    state.pageList.push(newdata);
    // localStorage.setItem(LOCAL_STORAGE_KEY_PAGELIST, JSON.stringify(state.pageList))
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["REMOVETAB"], function (state, data) {
    state.pageList = data.tabs.filter(function (tab) {
      return tab.name !== data.targetName;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["FIXTAB"], function (state, data) {
    state.pageList[0] = {
      name: 'Home',
      meta: {
        title: '工作台',
        close: false
      }
    };
  }), _mutations)
});

/***/ }),

/***/ "Mwfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Util_commonOptions__ = __webpack_require__("oQse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_control__ = __webpack_require__("//7k");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import {tableMixins} from '@/mixins/qiboMixins'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tableData: Array,
    totalCount: Number,
    title: String,
    selectType: String
  },
  components: {},
  // mixins: [tableMixins],
  data: function data() {
    return {
      industryOptions: __WEBPACK_IMPORTED_MODULE_3__Util_commonOptions__["k" /* industryOptions */],
      loading: false,
      Daterange: '',
      searchForm: {
        name: null,
        control_id: null,
        create_department: null
      },
      row: null,
      dialogVisible: false,
      pagination: true,
      currentPage: 1,
      departmentData: [],
      SelectionAll: {},
      SelectionTable: [],
      list: null
    };
  },

  computed: {},
  mounted: function mounted() {
    this.getDepartmentTreeList();
  },

  watch: {},
  methods: {
    handleNewParams: function handleNewParams() {
      var params = {
        control_ids: this.treeId || null,
        type: this.type
      };
      for (var key in this.searchForm) {
        if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      if (this.create_department === '') {
        this.create_department = null;
      }
      if (this.Daterange) {
        params.begin_time = this.Daterange[0];
        params.end_time = this.Daterange[1];
      }
      if (params.control_id) {
        params.control_id = params.control_id[1];
      }
      return params;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.getCheckStandardList(val);
    },
    getCheckStandardList: function getCheckStandardList(currentPage) {
      var _this = this;

      var params = {
        page_index: 1,
        page_size: 10,
        control_ids: this.treeId,
        type: this.type
      };
      if (currentPage) {
        params.page_index = currentPage;
      }
      this.loading = true;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */]['getCheckTableDBList'], params).then(function (response) {
        _this.tableData = response.data.data;
        if (_this.selectType == 'multiple') {
          _this.$nextTick(function () {
            _this.checkSelect();
          });
        }
        _this.totalCount = response.data.page_info.total_num;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    select: function select(selection, row) {
      for (var key in this.SelectionAll) {
        if (key == row.id) {
          delete this.SelectionAll[key];
          this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
          return;
        }
      }
      this.SelectionAll[row.id] = row;
      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
      this.$emit('addSelectionTable', this.SelectionTable);
    },
    selectAll: function selectAll(select) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          if (select.length === 0) {
            delete this.SelectionAll[row.id];
          } else {
            this.SelectionAll[row.id] = row;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
      this.$emit('addSelectionTable', this.SelectionTable);
    },
    currentChange: function currentChange(currentRow) {
      if (currentRow) {
        this.list = currentRow;
      }
    },

    //双击事件
    tableDbEdit: function tableDbEdit(row, col) {
      if (this.selectType == 'select') {
        this.$emit('addList', this.list);
      }
    },
    refreshTable: function refreshTable() {},
    reset: function reset() {
      for (var i in this.searchForm) {
        this.searchForm[i] = null;
      }
      this.Daterange = [];
    },
    getDepartmentTreeList: function getDepartmentTreeList() {
      var _this2 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* api */].getDepartmentTreeList, {}).then(function (res) {
        if (res.data.code == 0) {
          _this2.departmentData = res.data.data;
          _this2.departmentData.forEach(function (v) {
            v.name = '' + v.name;
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_global_scss__ = __webpack_require__("S2ic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_global_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_core_css__ = __webpack_require__("3f40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_quill_dist_quill_snow_css__ = __webpack_require__("4qOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_quill_dist_quill_bubble_css__ = __webpack_require__("+cgv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_quill_dist_quill_bubble_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugin_getChages__ = __webpack_require__("+pgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_video_player__ = __webpack_require__("iqGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_showFile_showFile_js__ = __webpack_require__("Q5zC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__permission__ = __webpack_require__("kTXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_selectCompany_selectCompany_js__ = __webpack_require__("MDOG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_selectCheckList_selectCheckList_js__ = __webpack_require__("YHT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__directives_index__ = __webpack_require__("LmM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common__ = __webpack_require__("MvGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_selectExpert_selectExpert__ = __webpack_require__("7PdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_esign__ = __webpack_require__("hilY");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









//






// 引入全局方法（变更管理）
 // 引入
// 全局引入视频插件






// 调用公共方法


__webpack_require__("g3Gj");
__webpack_require__("5LIk");

//电子签名


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23__components_selectExpert_selectExpert__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__directives_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_video_player___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__components_selectCompany_selectCompany_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20__components_selectCheckList_selectCheckList_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__components_showFile_showFile_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__plugin_getChages__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_quill_editor___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_5__http__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22__common__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_14_echarts___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_esign__["a" /* default */]);

// 当进入相同路径的路由时会报错，该代码修复此bug
var routerPush = __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */].prototype.push = function push(location) {
  return routerPush.call(this, location).catch(function (error) {
    return error;
  });
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_6__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */] }
});

/***/ }),

/***/ "O5EB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showCompany_vue__ = __webpack_require__("z2xV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04aff33d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showCompany_vue__ = __webpack_require__("T0sv");
function injectStyle (ssrContext) {
  __webpack_require__("jqZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showCompany_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04aff33d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showCompany_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OO9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"append-to-body":"","title":_vm.title,"visible":_vm.dialogFormVisible,"width":"40%"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"open":_vm.handleDialogOpen}},[_c('div',[_c('span',[_vm._v("想要通过excel批量"+_vm._s(_vm.title)+"数据，请按以下步骤依次执行：")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"17px"}},[_c('span',[_vm._v("步骤1：点击 ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.href,"download":_vm.download}},[_vm._v("这里")]),_vm._v(" "),_c('span',[_vm._v(" 下载excel模板。")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"17px"}},[_c('span',[_vm._v("步骤2：按照模板要求填写数据。")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"17px"}},[_c('span',[_vm._v("步骤3：选取并导入模板文件")]),_vm._v(" "),_c('el-upload',{staticClass:"upload-demo",attrs:{"action":"/apps/res/uploadFile","name":"file","headers":_vm.uploadHeaders,"data":_vm.uploadParams,"on-error":_vm.handleError,"on-success":_vm.handleSuccess,"before-upload":_vm.beforeUpload,"file-list":_vm.fileList}},[_c('el-button',{attrs:{"loading":_vm.importloading,"size":"small","type":"primary"}},[_vm._v("导入文件")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传xlsx文件，且不超过200MB")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"color":"#F56C6C","margin-top":"10px"}},[_c('div',{staticStyle:{"color":"#F56C6C"}},[_vm._v("注意事项：")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px","font-size":"12px"}},[_vm._v("1. 每个字段的汉字名称不要修改，系统需要根据这些字段名字来对应")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("2. 不要修改模板中有约束值的约束，比如下拉选项，只能填数字等")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("3. 不要留有空行")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("4. 如果需要增加下拉选项，请先联系管理员")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("5. 第一次导入成功后，再次导入将在原有内容上“追加”")]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v("6. 导入表格中每行每列段前去掉序号（序号系统会自动产生，否则会和表格内序号叠加显示）")])]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.hideDlg}},[_vm._v("关 闭")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OVV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"append-to-body":"","title":"复核意见","visible":_vm.dialogFormVisible,"width":"1200px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"open":_vm.handleDialogOpen}},[_c('div',{staticClass:"table",staticStyle:{"margin-top":"20px"}},[_c('div'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('el-button',{staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"success"},on:{"click":function($event){return _vm.storage()}}},[_vm._v("暂存")]),_vm._v(" "),_c('el-button',{staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.clear()}}},[_vm._v("清空")])],1)]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"dialog",attrs:{"model":_vm.ruleForm,"rules":_vm.rules,"label-width":"120px","status-icon":""}},[_c('el-form-item',{attrs:{"label":"模块/单元","prop":"module"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"请选择模块/单元"},model:{value:(_vm.ruleForm.module),callback:function ($$v) {_vm.$set(_vm.ruleForm, "module", $$v)},expression:"ruleForm.module"}},[_c('el-option',{attrs:{"label":"基础信息","value":"基础信息"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"风险单元","value":"风险单元"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"字段名","prop":"field_name"}},[_c('el-input',{attrs:{"placeholder":"字段名"},model:{value:(_vm.ruleForm.field_name),callback:function ($$v) {_vm.$set(_vm.ruleForm, "field_name", $$v)},expression:"ruleForm.field_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"问题描述","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","rows":5,"placeholder":"问题描述"},model:{value:(_vm.ruleForm.remark),callback:function ($$v) {_vm.$set(_vm.ruleForm, "remark", $$v)},expression:"ruleForm.remark"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"问题整改期限","prop":"deadline_time"}},[_c('el-date-picker',{attrs:{"clearable":"","type":"date","value-format":"yyyy-MM-dd","placeholder":"选择日期"},model:{value:(_vm.ruleForm.deadline_time),callback:function ($$v) {_vm.$set(_vm.ruleForm, "deadline_time", $$v)},expression:"ruleForm.deadline_time"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"截图(可多张)","prop":"image_list"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('span',[_vm._v("截图")])]),_vm._v(" "),_c('el-upload',{staticClass:"upload-demo",attrs:{"name":"image","data":_vm.uploadParams,"headers":_vm.uploadHeaders,"action":"/apps/res/uploadImage","before-upload":_vm.beforeAvatarUpload,"before-remove":function (file, fileList) { return _vm.beforeRemove(file, fileList, 'image_list'); },"multiple":"","limit":10,"file-list":_vm.images,"on-success":function (res, file, fileList) { return _vm.handlepictureSuccess(res, file, fileList, 'image_list'); },"on-exceed":_vm.handleExceed,"list-type":"picture-card"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传jpg/png文件，且不超过5M")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"附件","prop":"file"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('el-upload',{attrs:{"on-change":function () { return _vm.checkRules('file'); },"action":"/apps/res/uploadFile","name":"file","headers":_vm.uploadHeaders,"data":_vm.uploadParams,"show-file-list":false,"on-success":function (res, file) { return _vm.handleAvatarSuccess(res, file, 'file'); },"before-upload":_vm.beforeAvatarUpload}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("上传附件")])],1),_vm._v(" "),(_vm.ruleForm.file)?_c('div',[_c('el-link',{staticStyle:{"margin-left":"15px"},attrs:{"underline":false,"target":"_blank","type":"primary"},on:{"click":function($event){return _vm.$showFile({url: _vm.ruleForm.file})}}},[_vm._v("预览")]),_vm._v(" "),_c('el-link',{staticStyle:{"margin-left":"15px"},attrs:{"underline":false,"href":_vm.ruleForm.file,"target":"_blank","type":"primary"}},[_vm._v("下载")])],1):_vm._e()],1)])],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.hideForm}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.submitForm}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OqaL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyHome_vue__ = __webpack_require__("nwRc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6115a69c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyHome_vue__ = __webpack_require__("28ji");
function injectStyle (ssrContext) {
  __webpack_require__("aG9v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6115a69c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanyHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6115a69c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanyHome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _api;

var api = (_api = {
  checkCreditCode: '/apps/company/checkCreditCode', // 检查是否有重复信用代码
  calcEnterpriseScale: '/apps/company/calcEnterpriseScale', // 计算企业规模
  getVillageByTown: '/apps/common/getVillageByTown', // 获取村列表
  getProvinceList: '/apps/common/getProvinceList', // 获取省份
  getSubCityList: '/apps/common/getSubCityList', // 获取市
  getSubConutyList: '/apps/common/getSubConutyList', // 获取县
  getSubTownList: '/apps/common/getSubTownList', // 获取乡镇
  getAreaAndTown: '/apps/dictionary/getAreaAndTown', // 获取账号区域和乡镇
  resetPassword: '/apps/company/resetPassword', // 重置企业密码
  deleteCompany: '/apps/company/delete', // 关闭账号
  getCompanyList: '/apps/company/getList', // 查询企业列表
  getNoticeCompanyList: '/apps/company/getNoticeCompanyList', // 通知公告-查询企业列表
  getCompaniesList: '/apps/company/getCompaniesList', // 查询企业列表
  getNewCompanyList: '/apps/company/getCompanyList', // 查询企业列表
  companyDeletePasswordCache: '/apps/company/deletePasswordCache', // 一企一档-解除锁定
  getRiskCompanyList: '/apps/company/getRiskCompanyList', // 大屏企业清单
  getStandardList: '/apps/company/getStandardList', // 查询评审标准化
  getStandardListByselfList: '/apps/company/getStandardListByself', // 查询自评标准化
  getDepartmentListByAdmin: '/apps/department/getList', // 查询部门列表
  getDepartmentInfo: '/apps/department/getInfo', // 查询部门信息
  deleteDepartmentByAdmin: '/apps/department/delete', // 删除部门信息
  departmentAccountDeletePasswordCache: '/apps/department/deletePasswordCache', // 部门账号配置-解除锁定
  getDepartmentList: '/apps/organization/getOrganizationTree', // 获取部门列表
  addOrUpdateDepartment: '/apps/organization/addOrUpdateOrganization',
  deleteDepartment: '/apps/organization/deleteOrganization',
  getTownList: '/apps/town/getList', // 查询乡镇列表
  getTownInfo: '/apps/town/getInfo', // 查询乡镇信息
  addOrUpdateTownInfo: '/apps/town/addOrUpdate', // 乡镇信息增或改
  deleteTown: '/apps/town/delete', // 删除乡镇信息
  townDeletePasswordCache: '/apps/town/deletePasswordCache', // 街镇账号配置-解除锁定
  getVillageList: '/apps/village/getList', // 查询村列表
  deleteVillage: '/apps/village/delete', // 删除乡镇信息
  villageDeletePasswordCache: '/apps/village/deletePasswordCache', // 街镇账号配置-解除锁定
  addOrUpdateVillageInfo: '/apps/village/addOrUpdate', // 乡镇信息增或改
  departmentAddOrUpdate: '/apps/department/addOrUpdate', // 部门基本信息增或改
  getDepartmentSpecialInfo: '/apps/department/getDepartmentSpecialInfo', // 查询部门特殊信息
  updateDepartmentSpecialInfo: '/apps/department/updateDepartmentSpecialInfo', // 部门特殊信息修改
  getBaseDepartmentTypeList: '/apps/dictionary/getBaseDepartmentTypeList', // 获取部门列表
  addOrUpdateBaseDepartmentType: '/apps/dictionary/addOrUpdateBaseDepartmentType', // 增改部门
  deleteBaseDepartmentType: '/apps/dictionary/deleteBaseDepartmentType', // 删除部门
  getCurrentChangeBatchList: '/apps/change/getCurrentChangeBatchList', // 获取变更列表
  applyConfirm: '/apps/change/applyConfirm', // 通过审核
  applyRefuse: '/apps/change/applyRefuse', // 拒绝审核
  getDepartmentStaffList: '/apps/department/getDepartmentStaffList', // 部门人员列表(查)
  addOrUpdateDepartmentStaff: '/apps/department/addOrUpdateDepartmentStaff', // 部门人员列表(增,改)
  deleteDepartmentStaff: '/apps/department/deleteDepartmentStaff', // 部门人员列表(删除)
  getTownStaffList: '/apps/town/getTownStaffList', // 乡镇人员列表(查)
  addOrUpdateTownStaff: '/apps/town/addOrUpdateTownStaff', // 乡镇人员列表(增,改)
  deleteTownStaff: '/apps/town/deleteTownStaff', // 乡镇人员列表(删除)
  getDepartmentExerciseList: '/apps/department/getDepartmentExerciseList', // 部门演练列表(查)
  addOrUpdateDepartmentExercise: '/apps/department/addOrUpdateDepartmentExercise', // 部门演练列表(增,改)
  deleteDepartmentExercise: '/apps/department/deleteDepartmentExercise', // 部门演练列表(删除)
  getDepartmentAccidentList: '/apps/department/getDepartmentAccidentList', // 部门近五年事故(查)
  addOrUpdateDepartmentAccident: '/apps/department/addOrUpdateDepartmentAccident', // 部门近五年事故(增,改)
  deleteDepartmentAccident: '/apps/department/deleteDepartmentAccident', // 部门近五年事故(删除)
  getDepartmentDeathList: '/apps/department/getDepartmentDeathList', // 部门近五年死亡情况(查)
  addOrUpdateDepartmentDeath: '/apps/department/addOrUpdateDepartmentDeath', // 部门近五年死亡情况(增,改)
  deleteDepartmentDeath: '/apps/department/deleteDepartmentDeath', // 部门近五年死亡情况(删除)
  getTownAccidentList: '/apps/town/getTownAccidentList', // 乡镇近五年事故(查)
  addOrUpdateTownAccident: '/apps/town/addOrUpdateTownAccident', // 乡镇近五年事故(增,改)
  deleteTownAccident: '/apps/town/deleteTownAccident', // 乡镇近五年事故(删除)
  getTownDeathList: '/apps/town/getTownDeathList', // 乡镇近五年死亡情况(查)
  addOrUpdateTownDeath: '/apps/town/addOrUpdateTownDeath', // 乡镇近五年死亡情况(增,改)
  deleteTownDeath: '/apps/town/deleteTownDeath', // 乡镇近五年死亡情况(删除)
  // -------------------
  getCurrentChangeBatch: '/apps/change/getCurrentChangeBatch', // 获取当前次的变更id
  submitChangeBatch: '/apps/change/submitChangeBatch', // 提交变更id
  checkCompanyUnitAssessment: '/apps/unit/checkCompanyUnitAssessment', // 检测风险单元是否都完成参数填写
  register: '/apps/company/register', // 企业注册
  dictionary: '/apps/dictionary/getAllDictionary', // 获取配置
  companyGetInfo: '/apps/company/getInfo', // 获取企业基本信息
  updateBaseInfo: '/apps/company/updateBaseInfo', // 修改企业信息
  addOrUpdateBaseInfo: '/apps/company/addOrUpdate', // 修改企业信息
  getSpecialOperationList: '/apps/company/getSpecialOperationList', // 特种作业(查)
  addOrUpdateSpecialOperation: '/apps/company/addOrUpdateSpecialOperation', // 特种作业(增,改)
  deleteSpecialOperation: '/apps/company/deleteSpecialOperation', // 特种作业(删除)
  getSafetyAccidentsList: '/apps/company/getSafetyAccidentsList', // 伤亡事故(查)
  addOrUpdateSafetyAccidents: '/apps/company/addOrUpdateSafetyAccidents', // 伤亡事故(增,改)
  deleteSafetyAccidents: '/apps/company/deleteSafetyAccidents', // 伤亡事故(删除)
  getTeachingCarsList: '/apps/company/getTeachingCarsList', // 教学车辆信息(查)
  addOrUpdateTeachingCars: '/apps/company/addOrUpdateTeachingCars', // 教学车辆信息(增,改)
  deleteTeachingCars: '/apps/company/deleteTeachingCars', // 教学车辆信息(删除)
  getSurroundingWeakTargetList: '/apps/company/getSurroundingWeakTargetList', // 周边脆弱性目标(查)
  addOrUpdateSurroundingWeakTarget: '/apps/company/addOrUpdateSurroundingWeakTarget', // 周边脆弱性目标(增,改)
  deleteSurroundingWeakTarget: '/apps/company/deleteSurroundingWeakTarget', // 周边脆弱性目标(删除)
  getRiskUnitList: '/apps/unit/getRiskUnitList', // 风险单元
  addOrUpdateRiskUnit: '/apps/unit/addOrUpdateRiskUnit', // 风险单元(增,改)
  deleteRiskUnit: '/apps/unit/deleteRiskUnit', // 风险单元(删除)
  getRiskInventoryList: '/apps/unit/getRiskInventoryList', // 单元风险清单
  addOrUpdateRiskInventory: '/apps/unit/addOrUpdateRiskInventory', // 单元风险清单(增,改)
  deleteRiskInventory: '/apps/unit/deleteRiskInventory', // 单元风险清单(删除)
  getHiddenDangerInventoryList: '/apps/unit/getHiddenDangerInventoryList', // 单元隐患清单
  addOrUpdateHiddenDangerInventory: '/apps/unit/addOrUpdateHiddenDangerInventory', // 单元隐患清单(增,改)
  deleteHiddenDangerInventory: '/apps/unit/deleteHiddenDangerInventory', // 单元隐患清单(删除)
  getMajorHazardSourceInventoryList: '/apps/unit/getMajorHazardSourceInventoryList', // 单元重大危险源清单
  addOrUpdateMajorHazardSourceInventory: '/apps/unit/addOrUpdateMajorHazardSourceInventory', // 单元重大危险源清单(增,改)
  deleteMajorHazardSourceInventory: '/apps/unit/deleteMajorHazardSourceInventory', // 单元重大危险源清单(删除)
  getRiskGraphList: '/apps/unit/getRiskGraphList', // 单元风险分布图
  addOrUpdateRiskGraph: '/apps/unit/addOrUpdateRiskGraph', // 单元风险分布图(增,改)
  getAssessment: '/apps/unit/getAssessment', // 风险评估数据
  updateAssessment: '/apps/unit/updateAssessment', // 风险评估数据(改)
  getFocusChemicalProcessList: '/apps/industrial/getFocusChemicalProcessList', // 重点监管化工工艺
  addOrUpdateFocusChemicalProcess: '/apps/industrial/addOrUpdateFocusChemicalProcess', // 重点监管化工工艺(增,改)
  deleteFocusChemicalProcess: '/apps/industrial/deleteFocusChemicalProcess', // 重点监管化工工艺(删除)
  getBoomDustList: '/apps/industrial/getBoomDustList', // 涉爆粉尘
  addOrUpdateBoomDust: '/apps/industrial/addOrUpdateBoomDust', // 涉爆粉尘(增,改)
  deleteBoomDust: '/apps/industrial/deleteBoomDust', // 涉爆粉尘(删除)
  getExplosiveList: '/apps/industrial/getExplosiveList', // 单元内民用爆炸品统计
  addOrUpdateExplosive: '/apps/industrial/addOrUpdateExplosive', // 单元内民用爆炸品统计(增,改)
  deleteExplosive: '/apps/industrial/deleteExplosive', // 单元内民用爆炸品统计(删除)
  getDangerousChemicalList: '/apps/industrial/getDangerousChemicalList', // 单元内的危险化学品统计
  addOrUpdateDangerousChemical: '/apps/industrial/addOrUpdateDangerousChemical', // 单元内的危险化学品统计(增,改)
  deleteDangerousChemical: '/apps/industrial/deleteDangerousChemical', // 单元内的危险化学品统计(删除)
  getDangerousGoodsList: '/apps/industrial/getDangerousGoodsList', // 单元内的危险货物统计
  addOrUpdateDangerousGoods: '/apps/industrial/addOrUpdateDangerousGoods', // 单元内的危险货物统计(增,改)
  deleteDangerousGoods: '/apps/industrial/deleteDangerousGoods', // 单元内的危险货物统计(删除)
  getMinePitList: '/apps/industrial/getMinePitList', // 矿坑
  addOrUpdateMinePit: '/apps/industrial/addOrUpdateMinePit', // 矿坑(增,改)
  deleteMinePit: '/apps/industrial/deleteMinePit', // 矿坑(删除)
  getWasteDumpList: '/apps/industrial/getWasteDumpList', // 排土场
  addOrUpdateWasteDump: '/apps/industrial/addOrUpdateWasteDump', // 排土场(增,改)
  deleteWasteDump: '/apps/industrial/deleteWasteDump', // 排土场(删除)
  getMoltMetalFurnaceList: '/apps/industrial/getMoltMetalFurnaceList', // 熔融金属炉
  addOrUpdateMoltMetalFurnace: '/apps/industrial/addOrUpdateMoltMetalFurnace', // 熔融金属炉(增,改)
  deleteMoltMetalFurnace: '/apps/industrial/deleteMoltMetalFurnace', // 熔融金属炉(删除)
  getMagazineList: '/apps/industrial/getMagazineList', // 炸药库
  addOrUpdateMagazine: '/apps/industrial/addOrUpdateMagazine', // 炸药库(增,改)
  deleteMagazine: '/apps/industrial/deleteMagazine', // 炸药库(删除)
  getFireworkStorageList: '/apps/industrial/getFireworkStorageList', // 烟花爆竹库房
  addOrUpdateFireworkStorage: '/apps/industrial/addOrUpdateFireworkStorage', // 烟花爆竹库房(增,改)
  deleteFireworkStorage: '/apps/industrial/deleteFireworkStorage', // 烟花爆竹库房(删除)
  getBuildingList: '/apps/assembly/getBuildingList', // 建筑物（人员密集场所）
  addOrUpdateBuilding: '/apps/assembly/addOrUpdateBuilding', // 建筑物（人员密集场所）(增,改)
  deleteBuilding: '/apps/assembly/deleteBuilding', // 建筑物（人员密集场所）(删除)
  getChemicalList: '/apps/assembly/getChemicalList', // 化学品（学校）
  addOrUpdateChemical: '/apps/assembly/addOrUpdateChemical', // 化学品（学校）(增,改)
  deleteChemical: '/apps/assembly/deleteChemical', // 化学品（学校）(删除)
  getHospitalChemicalList: '/apps/assembly/getHospitalChemicalList', // 医院危险化学品
  addOrUpdateHospitalChemical: '/apps/assembly/addOrUpdateHospitalChemical', // 医院危险化学品(增,改)
  deleteHospitalChemical: '/apps/assembly/deleteHospitalChemical', // 医院危险化学品(删除)
  getHospitalStoreList: '/apps/assembly/getHospitalStoreList', // 储存物质
  addOrUpdateHospitalStore: '/apps/assembly/addOrUpdateHospitalStore', // 储存物质(增,改)
  deleteHospitalStore: '/apps/assembly/deleteHospitalStore', // 储存物质(删除)
  getRailFreightProductRegionList: '/apps/industrial/getRailFreightProductRegionList', // 生产加工区(铁路货运站场)
  addOrUpdateRailFreightProductRegion: '/apps/industrial/addOrUpdateRailFreightProductRegion', // 生产加工区(铁路货运站场)(增,改)
  deleteRailFreightProductRegion: '/apps/industrial/deleteRailFreightProductRegion', // 生产加工区(铁路货运站场)(删除)
  getRailFreightStorageList: '/apps/industrial/getRailFreightStorageList', // 库房(铁路货运站场)
  addOrUpdateRailFreightStorage: '/apps/industrial/addOrUpdateRailFreightStorage', // 库房(铁路货运站场)(增,改)
  deleteRailFreightStorage: '/apps/industrial/deleteRailFreightStorage', // 库房(铁路货运站场)(删除)
  getStableLineList: '/apps/facility/getStableLineList', // 固定班线
  addOrUpdateStableLine: '/apps/facility/addOrUpdateStableLine', // 固定班线(增,改)
  deleteStableLine: '/apps/facility/deleteStableLine', // 固定班线(删除)
  getConsequenceAreaList: '/apps/facility/getConsequenceAreaList', // 高后果区
  addOrUpdateConsequenceArea: '/apps/facility/addOrUpdateConsequenceArea', // 高后果区(增,改)
  deleteConsequenceArea: '/apps/facility/deleteConsequenceArea', // 高后果区(删除)
  getVehicleList: '/apps/facility/getVehicleList', // 危货车辆
  addOrUpdateVehicle: '/apps/facility/addOrUpdateVehicle', // 危货车辆(增,改)
  deleteVehicle: '/apps/facility/deleteVehicle', // 危货车辆(删除)
  getBoatList: '/apps/company/getShippingInfo', // 获取船舶信息
  addOrUpdateBoat: '/apps/company/addOrUpdateShippingInfo', // 船舶信息(增,改)
  deleteBoat: '/apps/company/deleteShippingInfo', // 船舶信息删
  getBerthList: '/apps/industrial/getBerthList', // 货物码头泊位
  addOrUpdateBerth: '/apps/industrial/addOrUpdateBerth', // 货物码头泊位(增,改)
  deleteBerth: '/apps/industrial/deleteBerth', // 货物码头泊位(删除)
  getBerthageList: '/apps/industrial/getBerthageList', // 客运码头泊位
  addOrUpdateBerthage: '/apps/industrial/addOrUpdateBerthage', // 客运码头泊位(增,改)
  deleteBerthage: '/apps/industrial/deleteBerthage', // 客运码头泊位(删除)
  getCraneList: '/apps/industrial/getCraneList', // 起重设备
  addOrUpdateCrane: '/apps/industrial/addOrUpdateCrane', // 起重设备(增,改)
  deleteCrane: '/apps/industrial/deleteCrane', // 起重设备(删除)
  getTankFarmList: '/apps/industrial/getTankFarmList', // 罐区
  addOrUpdateTankFarm: '/apps/industrial/addOrUpdateTankFarm', // 罐区(增,改)
  deleteTankFarm: '/apps/industrial/deleteTankFarm', // 罐区(删除)
  getspecialOperationStaffList: '/apps/company/getSpecialOperationPersonList', // 特种作业人员情况查询列表
  addOrUpdatespecialOperationStaff: '/apps/company/addOrUpdateSpecialOperationPerson', // 特种作业人员(增,改)
  deletespecialOperationStaff: '/apps/company/deleteSpecialOperationPerson', // 特种作业人员(删除)
  getcredentialsList: '/apps/company/getManagerCertList', // 安全相关负责人情况查询列表
  addOrUpdatecredentials: '/apps/company/addOrUpdateManagerCert', // 安全相关负责人(增,改)
  deletecredentials: '/apps/company/deleteManagerCert', // 安全相关负责人(删除)
  getDangerousTaskList: '/apps/company/getDangerousTaskList', // 危险作业查询列表
  addOrUpdateDangerousTask: '/apps/company/addOrUpdateDangerousTask', // 危险作业(增,改)
  deleteDangerousTask: '/apps/company/deleteDangerousTask', // 危险作业(删除)
  // 石狮六大行业新增
  getLiftingList: '/apps/industrial/getLiftingList', // 起重设备
  addOrUpdateLifting: '/apps/industrial/addOrUpdateLifting', // 起重设备(增,改)
  deleteLifting: '/apps/industrial/deleteLifting', // 起重设备(删除)
  getHazardousWasteList: '/apps/industrial/getHazardousWasteList', // 危险废物
  addOrUpdateHazardousWaste: '/apps/industrial/addOrUpdateHazardousWaste', // 危险废物(增,改)
  deleteHazardousWaste: '/apps/industrial/deleteHazardousWaste', // 危险废物(删除)
  getLandfillsList: '/apps/industrial/getLandfillsList', // 填埋场
  addOrUpdateLandfills: '/apps/industrial/addOrUpdateLandfills', // 填埋场(增,改)
  deleteLandfills: '/apps/industrial/deleteLandfills', // 填埋场(删除)
  getProcessPowerList: '/apps/industrial/getProcessPowerList', // 处理能力
  addOrUpdateProcessPower: '/apps/industrial/addOrUpdateProcessPower', // 处理能力(增,改)
  deleteProcessPower: '/apps/industrial/deleteProcessPower', // 处理能力(删除)
  getShipList: '/apps/company/getShippingInfo', // 货运船舶信息
  addOrUpdateShip: '/apps/company/addOrUpdateShippingInfo', // 货运船舶信息(增,改)
  deleteShip: '/apps/company/deleteShippingInfo', // 货运船舶信息(删除)
  getLegalRegistrationList: '/apps/industrial/getLegalRegistrationList', // 其他法人登记证书
  addOrUpdateLegalRegistration: '/apps/industrial/addOrUpdateLegalRegistration', // 其他法人登记证书(增,改)
  deleteLegalRegistration: '/apps/industrial/deleteLegalRegistration', // 其他法人登记证书(删除)
  getBoilerList: '/apps/industrial/getBoilerList', // 锅炉
  addOrUpdateBoiler: '/apps/industrial/addOrUpdateBoiler', // 锅炉(增,改)
  deleteBoiler: '/apps/industrial/deleteBoiler', // 锅炉(删除)
  getPressureVesselList: '/apps/industrial/getPressureVesselList', // 压力容器
  addOrUpdatePressureVessel: '/apps/industrial/addOrUpdatePressureVessel', // 压力容器(增,改)
  deletePressureVessel: '/apps/industrial/deletePressureVessel', // 压力容器(删除)
  getPressurePipeList: '/apps/industrial/getPressurePipeList', // 压力管道
  addOrUpdatePressurePipe: '/apps/industrial/addOrUpdatePressurePipe', // 压力管道(增,改)
  deletePressurePipe: '/apps/industrial/deletePressurePipe', // 压力管道(删除)
  getDrugSafetyAccessList: '/apps/industrial/getDrugSafetyAccessList', // 非药品类易制毒化学品许可证
  addOrUpdateDrugSafetyAccess: '/apps/industrial/addOrUpdateDrugSafetyAccess', // 非药品类易制毒化学品许可证(增,改)
  deleteDrugSafetyAccess: '/apps/industrial/deleteDrugSafetyAccess', // 非药品类易制毒化学品许可证(删除)
  getChemicalSafetyAccessList: '/apps/industrial/getChemicalSafetyAccessList', // 危险化学品安全许可
  addOrUpdateChemicalSafetyAccess: '/apps/industrial/addOrUpdateChemicalSafetyAccess', // 危险化学品安全许可(增,改)
  deleteChemicalSafetyAccess: '/apps/industrial/deleteChemicalSafetyAccess', // 危险化学品安全许可(删除)
  getDesignAcceptanceList: '/apps/industrial/getDesignAcceptanceList', // 设计与验收
  addOrUpdateDesignAcceptance: '/apps/industrial/addOrUpdateDesignAcceptance', // 设计与验收(增,改)
  deleteDesignAcceptance: '/apps/industrial/deleteDesignAcceptance', // 设计与验收(删除)
  getEmergencyPlanList: '/apps/industrial/getEmergencyPlanList', // 应急演练
  addOrUpdateEmergencyPlan: '/apps/industrial/addOrUpdateEmergencyPlan', // 应急演练(增,改)
  deleteEmergencyPlan: '/apps/industrial/deleteEmergencyPlan', // 应急演练(删除)
  getContingencyDrillAssessProjectList: '/apps/standard/getContingencyDrillAssessProjectList',
  addOrUpdateContingencyDrillAssessProject: '/apps/standard/addOrUpdateContingencyDrillAssessProject',
  deleteContingencyDrillAssessProject: '/apps/standard/deleteContingencyDrillAssessProject',
  getThunderCheckSystemList: '/apps/industrial/getThunderCheckSystemList', // 防雷检测
  addOrUpdateThunderCheckSystem: '/apps/industrial/addOrUpdateThunderCheckSystem', // 防雷检测(增,改)
  deleteThunderCheckSystem: '/apps/industrial/deleteThunderCheckSystem', // 防雷检测(删除)
  getHiddenTroubleList: '/apps/company/getHiddenTroubleList', // 隐患治理
  addOrUpdateHiddenTrouble: '/apps/company/addOrUpdateHiddenTrouble', // 隐患治理(增,改)
  deleteHiddenTrouble: '/apps/company/deleteHiddenTrouble', // 隐患治理(删除)
  getPortSafetyAccessList: '/apps/industrial/getPortSafetyAccessList', // 港口经营许可证
  addOrUpdatePortSafetyAccess: '/apps/industrial/addOrUpdatePortSafetyAccess', // 港口经营许可证(增,改)
  deletePortSafetyAccess: '/apps/industrial/deletePortSafetyAccess', // 港口经营许可证(删除)
  getPortDangerCertList: '/apps/industrial/getPortDangerCertList', // 港口危险货物作业附证(表格)
  addOrUpdatePortDangerCert: '/apps/industrial/addOrUpdatePortDangerCert', // 港口危险货物作业附证(增,改)
  deletePortDangerCert: '/apps/industrial/deletePortDangerCert', // 港口危险货物作业附证(删除)
  getSafetyEngineerList: '/apps/company/getSafetyEngineerList', // 企业注册安全工程师(表格)
  addOrUpdateSafetyEngineer: '/apps/company/addOrUpdateSafetyEngineer', // 企业注册安全工程师(增,改)
  deleteSafetyEngineer: '/apps/company/deleteSafetyEngineer', // 企业注册安全工程师(删除)
  getGasSafetyAccessList: '/apps/industrial/getGasSafetyAccessList', // 燃气经营许可证(表格)
  addOrUpdateGasSafetyAccess: '/apps/industrial/addOrUpdateGasSafetyAccess', // 燃气经营许可证(增,改)
  deleteGasSafetyAccess: '/apps/industrial/deleteGasSafetyAccess', // 燃气经营许可证(删除)
  getPowerBusAccessList: '/apps/industrial/getPowerBusAccessList', // 电力业务许可证(表格)
  addOrUpdatePowerBusAccess: '/apps/industrial/addOrUpdatePowerBusAccess', // 电力业务许可证(增,改)
  deletePowerBusAccess: '/apps/industrial/deletePowerBusAccess', // 电力业务许可证(删除)
  getBoomAccessList: '/apps/industrial/getBoomAccessList', // 电力业务许可证(表格)
  addOrUpdateBoomAccess: '/apps/industrial/addOrUpdateBoomAccess', // 电力业务许可证(增,改)
  deleteBoomAccess: '/apps/industrial/deleteBoomAccess', // 电力业务许可证(删除)
  getEnterpriseLevelList: '/apps/industrial/getEnterpriseLevelList', // 企业类（级）别(表格)
  addOrUpdateEnterpriseLevel: '/apps/industrial/addOrUpdateEnterpriseLevel', // 企业类（级）别(增,改)
  deleteEnterpriseLevel: '/apps/industrial/deleteEnterpriseLevel', // 企业类（级）别(删除)
  getSaftyProductAccessList: '/apps/industrial/getSaftyProductAccessList', // 安全生产许可证(表格)
  addOrUpdateSaftyProductAccess: '/apps/industrial/addOrUpdateSaftyProductAccess', // 安全生产许可证(增,改)
  deleteSaftyProductAccess: '/apps/industrial/deleteSaftyProductAccess', // 安全生产许可证(删除)
  getSaftyDisasterExcerciseList: '/apps/industrial/getSaftyDisasterExcerciseList', // 演练(表格)
  addOrUpdateSaftyDisasterExcercise: '/apps/industrial/addOrUpdateSaftyDisasterExcercise', // 演练(增,改)
  deleteSaftyDisasterExcercise: '/apps/industrial/deleteSaftyDisasterExcercise', // 演练(删除)
  getFireworksAccessList: '/apps/industrial/getFireworksAccessList', // 烟花爆竹(表格)
  addOrUpdateFireworksAccess: '/apps/industrial/addOrUpdateFireworksAccess', // 烟花爆竹(增,改)
  deleteFireworksAccess: '/apps/industrial/deleteFireworksAccess', // 烟花爆竹(删除)
  getRestaurantAccessList: '/apps/assembly/getRestaurantAccessList', // 餐饮许可证(表格)
  addOrUpdateRestaurantAccess: '/apps/assembly/addOrUpdateRestaurantAccess', // 餐饮许可证(增,改)
  deleteRestaurantAccess: '/apps/assembly/deleteRestaurantAccess', // 餐饮许可证(删除)
  getHotelAccessList: '/apps/assembly/getHotelAccessList', // 宾馆(表格)
  addOrUpdateHotelAccess: '/apps/assembly/addOrUpdateHotelAccess', // 宾馆(增,改)
  deleteHotelAccess: '/apps/assembly/deleteHotelAccess', // 宾馆(删除)
  getSchoolAccessList: '/apps/assembly/getSchoolAccessList', // 学校(表格)
  addOrUpdateSchoolAccess: '/apps/assembly/addOrUpdateSchoolAccess', // 学校(增,改)
  deleteSchoolAccess: '/apps/assembly/deleteSchoolAccess', // 学校(删除)
  getOilSaleAccessList: '/apps//industrial/getOilSaleAccessList', // 成品油(表格)
  addOrUpdateOilSaleAccess: '/apps//industrial/addOrUpdateOilSaleAccess', // 成品油(增,改)
  deleteOilSaleAccess: '/apps//industrial/deleteOilSaleAccess', // 成品油(删除)
  // 医疗机构
  getOxygenTankList: '/apps/assembly/getOxygenTankList', // 液氧储罐(表格)
  addOrUpdateOxygenTank: '/apps/assembly/addOrUpdateOxygenTank', // 液氧储罐(表格)(增,改)
  deleteOxygenTank: '/apps/assembly/deleteOxygenTank', // 液氧储罐(表格)(删除)
  getHospitalAccessList: '/apps/assembly/getHospitalAccessList', // 医疗机构职业许可证(表格)
  addOrUpdateHospitalAccess: '/apps/assembly/addOrUpdateHospitalAccess', // 医疗机构职业许可证(表格)(增,改)
  deleteHospitalAccess: '/apps/assembly/deleteHospitalAccess', // 医疗机构职业许可证(表格)(删除)
  // 危化生产
  getProductStoreEquipmentList: '/apps/industrial/getProductStoreEquipmentList', // 危险化学品生产、储存装置(表格)
  addOrUpdateProductStoreEquipment: '/apps/industrial/addOrUpdateProductStoreEquipment', // 危险化学品生产、储存装置(表格) (增,改)
  deleteProductStoreEquipment: '/apps/industrial/deleteProductStoreEquipment', // 危险化学品生产、储存装置(删除)
  // 施工项目
  getConstructionAccessList: '/apps/assembly/getConstructionAccessList', // 施工许可(表格)
  addOrUpdateConstructionAccess: '/apps/assembly/addOrUpdateConstructionAccess', // 施工许可(表格) (增,改)
  deleteConstructionAccess: '/apps/assembly/deleteConstructionAccess', // 施工许可(删除)
  // 导出
  export: '/apps/company/export',
  // 小规模企业
  getIndustryByParentId: '/apps/dictionary/getIndustryByParentId', // 获取行业门类
  getAreaByParentId: '/apps/dictionary/getAreaByParentId', // 获取地址
  // ----------------
  // 风险数据库
  getDbRiskList: '/apps/db/getDbRiskList', // 查询
  addRiskFromDb: '/apps/dynamic/addRiskFromDb', // 从数据库添加风险点(可多选)
  getRiskMatrixForConfig: '/apps/dynamic/getRiskMatrixForConfig', // 获取风险矩阵配置
  updateRiskMatrix: '/apps/dynamic/updateRiskMatrix', // 获取风险矩阵配置

  // 风险矩阵
  getRiskMatrixForSelect: '/apps/dynamic/getRiskMatrixForSelect', // 查询

  // 获取员工接口（新）
  getStaffAccountList: '/apps/dynamic/getStaffAccountList',

  // 获取风险点列表
  getDictionaryRiskSourceList: '/apps/dynamic/getRiskSourceList',
  getRiskSourceList: '/apps/risk/getRiskSourceList', // 风险列表
  addOrUpdateRiskSource: '/apps/risk/addOrUpdateRiskSource',
  deleteRiskSource: '/apps/dynamic/deleteRiskSource',
  getHiddenCheckTableItemList: '/apps/hidden/getHiddenCheckTableItemList', // 风险检查表
  addOrUpdateHiddenCheckTableItem: '/apps/hidden/addOrUpdateHiddenCheckTableItem',
  deleteHiddenCheckTableItem: '/apps/hidden/deleteHiddenCheckTableItem',
  getHiddenDangerTwoList: '/apps/dynamic/getHiddenDangerList', // 隐患清单
  getHiddenDangerByOverTimeList: '/apps/statistics/getHiddenDangerByOverTimeList',
  addOrUpdateHiddenDanger: '/apps/dynamic/addOrUpdateHiddenDanger', // 隐患清单(增加修改)
  deleteHiddenDangerTwo: '/apps/dynamic/deleteHiddenDanger', // 隐患删除
  deleteHiddenDanger: '/apps/dynamic/deleteHiddenDanger',
  calcRiskInfo: '/apps/dynamic/calcRiskInfo', // 计算风险等级

  // 商场市场
  getMotorList: '/apps/industrial/getMotorList', // 场内机动车辆
  addOrUpdateMotor: '/apps/industrial/addOrUpdateMotor', // 场内机动车辆(增,改)
  deleteMotor: '/apps/industrial/deleteMotor', // 场内机动车辆(删除)

  getAmusementList: '/apps/industrial/getAmusementList', // 大型游乐设施
  addOrUpdateAmusement: '/apps/industrial/addOrUpdateAmusement', // 大型游乐设施(增,改)
  deleteAmusement: '/apps/industrial/deleteAmusement', // 大型游乐设施(删除)

  getElevatorList: '/apps/industrial/getElevatorList', // 电梯
  addOrUpdateElevator: '/apps/industrial/addOrUpdateElevator', // 电梯(增,改)
  deleteElevator: '/apps/industrial/deleteElevator', // 电梯(删除)

  // 定期填报提交
  submitFixRisk: '/apps/dynamic/submitFixRisk',
  checkRiskSourceItem: '/apps/dynamic/checkRiskSourceItem',

  getBaseControlIndustry: '/apps/dictionary/getBaseControlIndustry', // 细分行业
  // 复核历史
  getCompanyReviewLog: '/apps/company/getCompanyReviewLog',
  getInfo: '/apps/admin/getInfo',
  getDictionaryRiskUnitList: '/apps/dictionary/getRiskUnitList',
  // 获取管控层级配置
  getRiskControlLevelForConfig: '/apps/dynamic/getRiskControlLevelForConfig',
  // 更新管控层级配置
  updateRiskControlLevel: '/apps/dynamic/updateRiskControlLevel',
  // 隐患检查项获取接口
  getHiddenCheckList: '/apps/dynamic/getHiddenCheckList',
  // 隐患检查项提交接口
  submitHiddenCheckList: '/apps/dynamic/submitHiddenCheckList',
  // 安全管理制度
  getCompanySaftySystem: '/apps/dynamic/getCompanySaftySystem',
  addOrUpdateCompanySaftySystem: '/apps/dynamic/addOrUpdateCompanySaftySystem',
  getCompanySaftyFileList: '/apps/dynamic/getCompanySaftyFileList',
  addOrUpdateCompanySaftyFile: '/apps/dynamic/addOrUpdateCompanySaftyFile',
  deleteCompanySaftyFile: '/apps/dynamic/deleteCompanySaftyFile',
  // 标准化（文件管理）模块接口
  getStandardNodeTree: '/apps/standard/getStandardNodeTree',
  addOrUpdateStandardN: '/apps/standard/addOrUpdateStandardNode',
  deleteStandardNod: '/apps/standard/deleteStandardNode',

  getStandardFileList: '/apps/standard/getStandardFileList',
  uploadStandard: '/apps/standard/uploadStandardFile',
  addOrUpdateStandardFile: '/apps/standard/addOrUpdateStandardFile',
  deleteStandard: '/apps/standard/deleteStandardFile'

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentStaffList', '/apps/organization/getOrganizationTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDepartmentStaff', '/apps/organization/addOrUpdateOrganization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDepartmentStaff', '/apps/organization/deleteOrganization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionStaffList', '/apps/staff/getProductionStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionStaff', '/apps/staff/addOrUpdateProductionStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionStaff', '/apps/staff/deleteProductionStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getBuildingsList', '/apps/build/getRiskBuildingList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateBuildings', '/apps/build/addOrUpdateRiskBuilding'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteBuildings', '/apps/build/deleteRiskBuilding'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getMainProductionEquipmentList', '/apps/device/getMainProductionEquipmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMainProductionEquipment', '/apps/device/addOrUpdateMainProductionEquipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteMainProductionEquipment', '/apps/device/deleteMainProductionEquipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAuxiliaryEquipmentList', '/apps/device/getAuxiliaryEquipmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAuxiliaryEquipment', '/apps/device/addOrUpdateAuxiliaryEquipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAuxiliaryEquipment', '/apps/device/deleteAuxiliaryEquipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialEquipmentList', '/apps/device/getSpecialEquipmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSpecialEquipment', '/apps/device/addOrUpdateSpecialEquipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSpecialEquipment', '/apps/device/deleteSpecialEquipment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyAccessoriesList', '/apps/device/getSafetyAccessoriesList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyAccessories', '/apps/device/addOrUpdateSafetyAccessories'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyAccessories', '/apps/device/deleteSafetyAccessories'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getActivityList', '/apps/activity/getActivityList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateActivity', '/apps/activity/addOrUpdateActivity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteActivity', '/apps/activity/deleteActivity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContractorOrganizationTree', '/apps/organization/getContractorOrganizationTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupplierOrganizationTree', '/apps/organization/getSupplierOrganizationTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentOrganizationTree', '/apps/organization/getDepartmentOrganizationTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialCheckList', '/apps/special/getSpecialCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSpecialCheck', '/apps/special/addOrUpdateSpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSpecialCheck', '/apps/special/deleteSpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDbRiskCheckList', '/apps/db/getDbRiskCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDbRiskCheck', '/apps/db/addOrUpdateDbRiskCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDbRiskCheck', '/apps/db/deleteDbRiskCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDbRiskItemList', '/apps/db/getDbRiskItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDbRiskItem', '/apps/db/addOrUpdateDbRiskItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDbRiskItem', '/apps/db/deleteDbRiskItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'importDbRisk', '/apps/db/importDbRisk'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleWarn', '/apps/warn/handleWarn'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addHiddenDangerFormWarn', '/apps/warn/addHiddenDangerFromWarn'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteWarn', '/apps/warn/deleteWarn'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskCheckList', '/apps/dynamic/getRiskCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateRiskCheck', '/apps/dynamic/addOrUpdateRiskCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteRiskCheck', '/apps/dynamic/deleteRiskCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskCheckTableList', '/apps/dynamic/getRiskCheckTableList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckRecordStatsList', '/apps/company/getCheckRecordStatsList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskControlPlan', '/apps/dynamic/getRiskControlPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'setCheckFrequencyType', '/apps/dynamic/setCheckFrequencyType'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getActivityApplyList', '/apps/activity/getActivityApplyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialWorkList', '/apps/work/getSpecialWorkList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSpecialWork', '/apps/work/addOrUpdateSpecialWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSpecialWork', '/apps/work/deleteSpecialWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'closeSpecialWork', '/apps/work/closeSpecialWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialWorkCount', '/apps/work/getSpecialWorkCount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskSourceByCascade', '/apps/risk/getRiskSourceByCascade'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialCheckStaffList', '/apps/special/getSpecialCheckStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskCheckTableTitleList', '/apps/dynamic/getRiskCheckTableTitleList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateHiddenCheckRecord', '/apps/hidden/addOrUpdateHiddenCheckRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTrainPlan', '/apps/train/deleteTrainPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainPlan', '/apps/train/addOrUpdateTrainPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainPlanList', '/apps/train/getTrainPlanList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTrainCourse', '/apps/train/deleteTrainCourse'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainCourse', '/apps/train/addOrUpdateTrainCourse'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainCourseList', '/apps/train/getTrainCourseList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTrainCoursePhoto', '/apps/train/deleteTrainCoursePhoto'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainCoursePhoto', '/apps/train/addOrUpdateTrainCoursePhoto'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainCoursePhotoList', '/apps/train/getTrainCoursePhotoList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTrainCourseSign', '/apps/train/deleteTrainCourseSign'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainCourseSign', '/apps/train/addOrUpdateTrainCourseSign'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainCourseSignList', '/apps/train/getTrainCourseSignList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDangerActivityListOfCompany', '/apps/activity/getDangerActivityListOfCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteManagerCert', '/apps/company/deleteManagerCert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateManagerCert', '/apps/company/addOrUpdateManagerCert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getManagerCertList', '/apps/company/getManagerCertList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteStaffTrainList', '/apps/standard/deleteStaffTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateStaffTrain', '/apps/standard/addOrUpdateStaffTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getStaffTrainList', '/apps/standard/getStaffTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteViolationRecord', '/apps/standard/deleteViolationRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateViolationRecord', '/apps/standard/addOrUpdateViolationRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getViolationRecordList', '/apps/standard/getViolationRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteEmergencyFacility', '/apps/standard/deleteEmergencyFacility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateEmergencyFacility', '/apps/standard/addOrUpdateEmergencyFacility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getEmergencyFacilityList', '/apps/standard/getEmergencyFacilityList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAccidentRecord', '/apps/standard/deleteAccidentRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAccidentRecord', '/apps/standard/addOrUpdateAccidentRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAccidentRecordList', '/apps/standard/getAccidentRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteFireFightingDevice', '/apps/standard/deleteFireFightingDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateFireFightingDevice', '/apps/standard/addOrUpdateFireFightingDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getFireFightingDeviceList', '/apps/standard/getFireFightingDeviceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyFacility', '/apps/standard/deleteSafetyFacility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyFacility', '/apps/standard/addOrUpdateSafetyFacility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyFacilityList', '/apps/standard/getSafetyFacilityList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteLightningProtectionFacilitie', '/apps/standard/deleteLightningProtectionFacilitie'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateLightningProtectionFacilitie', '/apps/standard/addOrUpdateLightningProtectionFacilitie'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getLightningProtectionFacilitieList', '/apps/standard/getLightningProtectionFacilitieList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyWarningMark', '/apps/standard/deleteSafetyWarningMark'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyWarningMark', '/apps/standard/addOrUpdateSafetyWarningMark'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyWarningMarkList', '/apps/standard/getSafetyWarningMarkList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addRiskSourceByCopy', '/apps/risk/addRiskSourceByCopy'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskUnitQrCode', '/apps/page/getRiskUnitQrCode'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteRescuePerson', '/apps/standard/deleteRescuePerson'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateRescuePerson', '/apps/standard/addOrUpdateRescuePerson'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRescuePersonList', '/apps/standard/getRescuePersonList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContractorOrganization', '/apps/organization/addOrUpdateContractorOrganization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContractorOrganizationList', '/apps/organization/getContractorOrganizationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSupplierOrganization', '/apps/organization/addOrUpdateSupplierOrganization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupplierOrganizationList', '/apps/organization/getSupplierOrganizationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getStaffTrainTimeStatistics', '/apps/train/getStaffTrainTimeStatistics'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateRiskPersonalCheck', '/apps/dynamic/addOrUpdateRiskPersonalCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteRiskPersonalCheck', '/apps/dynamic/deleteRiskPersonalCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionLawStandard', '/apps/standard/addOrUpdateProductionLawStandard'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionLawStandardList', '/apps/standard/getProductionLawStandardList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionLawStandard', '/apps/standard/deleteProductionLawStandard'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionRegulation', '/apps/standard/addOrUpdateProductionRegulation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionRegulationList', '/apps/standard/getProductionRegulationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionRegulation', '/apps/standard/deleteProductionRegulation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionOperation', '/apps/standard/addOrUpdateProductionOperation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionOperation', '/apps/standard/deleteProductionOperation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionOperationList', '/apps/standard/getProductionOperationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionTargetList', '/apps/standard/getSafetyProductionTargetList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyProductionTarget', '/apps/standard/addOrUpdateSafetyProductionTarget'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyProductionTarget', '/apps/standard/deleteSafetyProductionTarget'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionDepartmentTargetList', '/apps/standard/getSafetyProductionDepartmentTargetList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyProductionDepartmentTarget', '/apps/standard/addOrUpdateSafetyProductionDepartmentTarget'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyProductionDepartmentTarget', '/apps/standard/deleteSafetyProductionDepartmentTarget'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentResponsibilityList', '/apps/standard/getDepartmentResponsibilityList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDepartmentResponsibility', '/apps/standard/addOrUpdateDepartmentResponsibility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDepartmentResponsibility', '/apps/standard/deleteDepartmentResponsibility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPostResponsibilityList', '/apps/standard/getPostResponsibilityList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePostResponsibility', '/apps/standard/addOrUpdatePostResponsibility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePostResponsibility', '/apps/standard/deletePostResponsibility'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanySafetyFeeList', '/apps/standard/getCompanySafetyFeeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCompanySafetyFee', '/apps/standard/addOrUpdateCompanySafetyFee'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCompanySafetyFee', '/apps/standard/deleteCompanySafetyFee'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getMonthlySafetyFeeList', '/apps/standard/getMonthlySafetyFeeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMonthlySafetyFee', '/apps/standard/addOrUpdateMonthlySafetyFee'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteMonthlySafetyFee', '/apps/standard/deleteMonthlySafetyFee'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsurancePayCertificateList', '/apps/standard/getInsurancePayCertificateList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateInsurancePayCertificate', '/apps/standard/addOrUpdateInsurancePayCertificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteInsurancePayCertificate', '/apps/standard/deleteInsurancePayCertificate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyCultureActivityList', '/apps/standard/getSafetyCultureActivityList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyCultureActivity', '/apps/standard/addOrUpdateSafetyCultureActivity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyCultureActivity', '/apps/standard/deleteSafetyCultureActivity'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionTargetCheckList', '/apps/standard/getSafetyProductionTargetCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyProductionTargetCheck', '/apps/standard/addOrUpdateSafetyProductionTargetCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyProductionTargetCheck', '/apps/standard/deleteSafetyProductionTargetCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionDepartmentTargetCheckList', '/apps/standard/getSafetyProductionDepartmentTargetCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyProductionDepartmentTargetCheck', '/apps/standard/addOrUpdateSafetyProductionDepartmentTargetCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyProductionDepartmentTargetCheck', '/apps/standard/deleteSafetyProductionDepartmentTargetCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentResponsibilityCheckList', '/apps/standard/getDepartmentResponsibilityCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDepartmentResponsibilityCheck', '/apps/standard/addOrUpdateDepartmentResponsibilityCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDepartmentResponsibilityCheck', '/apps/standard/deleteDepartmentResponsibilityCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPostResponsibilityCheckList', '/apps/standard/getPostResponsibilityCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePostResponsibilityCheck', '/apps/standard/addOrUpdatePostResponsibilityCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePostResponsibilityCheck', '/apps/standard/deletePostResponsibilityCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyPlanList', '/apps/standard/getContingencyPlanList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyPlan', '/apps/standard/addOrUpdateContingencyPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyPlan', '/apps/standard/deleteContingencyPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyOrganizationList', '/apps/standard/getContingencyOrganizationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyOrganization', '/apps/standard/addOrUpdateContingencyOrganization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyOrganization', '/apps/standard/deleteContingencyOrganization'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDeviceList', '/apps/standard/getContingencyDeviceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDevice', '/apps/standard/addOrUpdateContingencyDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDevice', '/apps/standard/deleteContingencyDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionAccidentList', '/apps/standard/getSafetyProductionAccidentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyProductionAccident', '/apps/standard/addOrUpdateSafetyProductionAccident'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyProductionAccident', '/apps/standard/deleteSafetyProductionAccident'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTreeSameTimeList', '/apps/standard/getTreeSameTimeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTreeSameTime', '/apps/standard/addOrUpdateTreeSameTime'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTreeSameTime', '/apps/standard/deleteTreeSameTime'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPartnerList', '/apps/standard/getPartnerList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePartner', '/apps/standard/addOrUpdatePartner'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePartner', '/apps/standard/deletePartner'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPartnerCertList', '/apps/standard/getPartnerCertList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePartnerCert', '/apps/standard/addOrUpdatePartnerCert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePartnerCert', '/apps/standard/deletePartnerCert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPartnerStaffList', '/apps/standard/getPartnerStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePartnerStaff', '/apps/standard/addOrUpdatePartnerStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletegetPartnerStaff', '/apps/standard/deletegetPartnerStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPartnerUnitList', '/apps/standard/getPartnerUnitList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePartnerUnit', '/apps/standard/addOrUpdatePartnerUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePartnerUnit', '/apps/standard/deletePartnerUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPartnerWorkAreaList', '/apps/standard/getPartnerWorkAreaList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getMainDeviceList', '/apps/standard/getMainDeviceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMainDevice', '/apps/standard/addOrUpdateMainDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteMainDevice', '/apps/standard/deleteMainDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDeviceRepairPlanList', '/apps/standard/getDeviceRepairPlanList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDeviceRepairPlan', '/apps/standard/addOrUpdateDeviceRepairPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDeviceRepairPlan', '/apps/standard/deleteDeviceRepairPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyDeviceList', '/apps/standard/getSafetyDeviceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyDevice', '/apps/standard/addOrUpdateSafetyDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyDevice', '/apps/standard/deleteSafetyDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDeviceRepairRecordList', '/apps/standard/getDeviceRepairRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDeviceRepairRecord', '/apps/standard/addOrUpdateDeviceRepairRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDeviceRepairRecord', '/apps/standard/deleteDeviceRepairRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialDeviceList', '/apps/standard/getSpecialDeviceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSpecialDevice', '/apps/standard/addOrUpdateSpecialDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSpecialDevice', '/apps/standard/deleteSpecialDevice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialDeviceDailyList', '/apps/standard/getSpecialDeviceDailyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSpecialDeviceDaily', '/apps/standard/addOrUpdateSpecialDeviceDaily'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSpecialDeviceDaily', '/apps/standard/deleteSpecialDeviceDaily'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialDeviceCheckList', '/apps/standard/getSpecialDeviceCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSpecialDeviceCheck', '/apps/standard/addOrUpdateSpecialDeviceCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSpecialDeviceCheck', '/apps/standard/deleteSpecialDeviceCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetySign', '/apps/standard/deleteSafetySign'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetySign', '/apps/standard/addOrUpdateSafetySign'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetySignList', '/apps/standard/getSafetySignList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteLightningProtection', '/apps/standard/deleteLightningProtection'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateLightningProtection', '/apps/standard/addOrUpdateLightningProtection'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getLightningProtectionList', '/apps/standard/getLightningProtectionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePartnerWorkArea', '/apps/standard/deletePartnerWorkArea'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePartnerWorkArea', '/apps/standard/addOrUpdatePartnerWorkArea'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSixManager', '/apps/standard/deleteSixManager'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSixManager', '/apps/standard/addOrUpdateSixManager'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSixManagerList', '/apps/standard/getSixManagerList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSixManagerProblem', '/apps/standard/deleteSixManagerProblem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSixManagerProblem', '/apps/standard/addOrUpdateSixManagerProblem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSixManagerProblemList', '/apps/standard/getSixManagerProblemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteUnsafetyView', '/apps/standard/deleteUnsafetyView'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateUnsafetyView', '/apps/standard/addOrUpdateUnsafetyView'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getUnsafetyViewList', '/apps/standard/getUnsafetyViewList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionLawStandardEvaluate', '/apps/standard/deleteProductionLawStandardEvaluate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionLawStandardEvaluate', '/apps/standard/addOrUpdateProductionLawStandardEvaluate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionLawStandardEvaluateList', '/apps/standard/getProductionLawStandardEvaluateList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionLawStandardRun', '/apps/standard/deleteProductionLawStandardRun'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionLawStandardRun', '/apps/standard/addOrUpdateProductionLawStandardRun'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionLawStandardRunList', '/apps/standard/getProductionLawStandardRunList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionRegulationTrain', '/apps/standard/deleteProductionRegulationTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionRegulationTrain', '/apps/standard/addOrUpdateProductionRegulationTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionRegulationTrainList', '/apps/standard/getProductionRegulationTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionRegulationCheck', '/apps/standard/deleteProductionRegulationCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionRegulationCheck', '/apps/standard/addOrUpdateProductionRegulationCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionRegulationCheckList', '/apps/standard/getProductionRegulationCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionRegulationReview', '/apps/standard/deleteProductionRegulationReview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionRegulationReview', '/apps/standard/addOrUpdateProductionRegulationReview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionRegulationReviewList', '/apps/standard/getProductionRegulationReviewList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionOperationTrain', '/apps/standard/deleteProductionOperationTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionOperationTrain', '/apps/standard/addOrUpdateProductionOperationTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionOperationTrainList', '/apps/standard/getProductionOperationTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionOperationCheck', '/apps/standard/deleteProductionOperationCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionOperationCheck', '/apps/standard/addOrUpdateProductionOperationCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionOperationCheckList', '/apps/standard/getProductionOperationCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteProductionOperationReview', '/apps/standard/deleteProductionOperationReview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProductionOperationReview', '/apps/standard/addOrUpdateProductionOperationReview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProductionOperationReviewList', '/apps/standard/getProductionOperationReviewList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDeviceMaintenance', '/apps/standard/deleteContingencyDeviceMaintenance'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDeviceMaintenance', '/apps/standard/addOrUpdateContingencyDeviceMaintenance'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDeviceMaintenanceList', '/apps/standard/getContingencyDeviceMaintenanceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDrillProject', '/apps/standard/deleteContingencyDrillProject'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDrillProject', '/apps/standard/addOrUpdateContingencyDrillProject'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDrillProjectList', '/apps/standard/getContingencyDrillProjectList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getEmergencyDrillPlanRecordList', '/apps/standard/getEmergencyDrillPlanRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateEmergencyDrillPlanRecord', '/apps/standard/addOrUpdateEmergencyDrillPlanRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteEmergencyDrillPlanRecord', '/apps/standard/deleteEmergencyDrillPlanRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addRiskCheckDuty', '/apps/dynamic/addRiskCheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getJobStaffList', '/apps/company/getJobStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteRiskCheckDuty', '/apps/dynamic/deleteRiskCheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteRiskCheckDutyList', '/apps/dynamic/deleteRiskCheckDutyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckDutyList', '/apps/check/getCheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addCheckDuty', '/apps/check/addCheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckDuty', '/apps/check/deleteCheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDrillRecord', '/apps/standard/deleteContingencyDrillRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDrillRecord', '/apps/standard/addOrUpdateContingencyDrillRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDrillRecordList', '/apps/standard/getContingencyDrillRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDrillTrain', '/apps/standard/deleteContingencyDrillTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDrillTrain', '/apps/standard/addOrUpdateContingencyDrillTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDrillTrainList', '/apps/standard/getContingencyDrillTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDrillLog', '/apps/standard/deleteContingencyDrillLog'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDrillLog', '/apps/standard/addOrUpdateContingencyDrillLog'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDrillLogList', '/apps/standard/getContingencyDrillLogList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteContingencyDrillEvaluate', '/apps/standard/deleteContingencyDrillEvaluate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateContingencyDrillEvaluate', '/apps/standard/addOrUpdateContingencyDrillEvaluate'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDrillEvaluateList', '/apps/standard/getContingencyDrillEvaluateList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAccidentFourCatch', '/apps/standard/deleteAccidentFourCatch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAccidentFourCatch', '/apps/standard/addOrUpdateAccidentFourCatch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAccidentFourCatchList', '/apps/standard/getAccidentFourCatchList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAccidentAnalysisList', '/apps/standard/getAccidentAnalysisList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAccidentAnalysis', '/apps/standard/addOrUpdateAccidentAnalysis'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAccidentAnalysis', '/apps/standard/deleteAccidentAnalysis'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTrainSchedule', '/apps/standard/deleteTrainSchedule'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainSchedule', '/apps/standard/addOrUpdateTrainSchedule'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainScheduleList', '/apps/standard/getTrainScheduleList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteOuterPersonNotice', '/apps/standard/deleteOuterPersonNotice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateOuterPersonNotice', '/apps/standard/addOrUpdateOuterPersonNotice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOuterPersonNoticeList', '/apps/standard/getOuterPersonNoticeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteOuterPersonSafetyTrain', '/apps/standard/deleteOuterPersonSafetyTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateOuterPersonSafetyTrain', '/apps/standard/addOrUpdateOuterPersonSafetyTrain'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOuterPersonSafetyTrainList', '/apps/standard/getOuterPersonSafetyTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRecheckList', '/apps/recheck/getRecheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateRecheck', '/apps/recheck/addOrUpdateRecheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteRecheck', '/apps/recheck/deleteRecheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleReview', '/apps/company/handleReview'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleReviewPass', '/apps/company/handleReviewPass'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'CancelReviewPass', '/apps/company/CancelReviewPass'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAllRecheckList', '/apps/recheck/getAllRecheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRecheckHistoryList', '/apps/recheck/getRecheckHistoryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateStar', '/apps/company/updateStar'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductStandardStar', '/apps/company/getSafetyProductStandardStar'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyStarHistoryList', '/apps/company/getCompanyStarHistoryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateBaseArea', '/apps/dictionary/addOrUpdateBaseArea'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getBaseAreaList', '/apps/dictionary/getBaseAreaList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteBaseArea', '/apps/dictionary/deleteBaseArea'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getIndustryRiskLevelList', '/apps/statistics/getIndustryRiskLevel'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSysSettings', '/apps/setting/getSysSettings'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSysSetting', '/apps/setting/updateSysSetting'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'sendReviewMessage', '/apps/company/sendReviewMessage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addRiskToDb', '/apps/dynamic/addRiskToDb'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDbCheckList', '/apps/db/getDbCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDbCheck', '/apps/db/addOrUpdateDbCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDbCheck', '/apps/db/deleteDbCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenStandardCheckItemList', '/apps/hidden/getHiddenStandardCheckItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenDangerCheckItemList', '/apps/hidden/getHiddenDangerCheckItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenDangerList', '/apps/statistics/getHiddenDangerList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getBigHiddenDangerList', '/apps/statistics/getBigHiddenDangerList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getIndustryTypeList', '/apps/company/getIndustryTypeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyScalePlaceList', '/apps/company/getCompanyScalePlaceInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyScaleCheckList', '/apps/company/getCompanyScaleCheckInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyThreeListList', '/apps/company/getCompanyThreeListInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyFourColorRiskList', '/apps/company/getCompanyFourColorRiskInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyFourColorRiskDepartmentList', '/apps/company/getCompanyFourColorRiskDepartmentInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyFourColorRiskIndustryTypeList', '/apps/company/getCompanyFourColorRiskIndustryType'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionStandardImproveList', '/apps/company/getSafetyProductionStandardImproveInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionStandardDepartmentImproveList', '/apps/company/getSafetyProductionStandardDepartmentImproveInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenCheckStatsList', '/apps/company/getHiddenCheckStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenCheckStatsByDepartmentList', '/apps/company/getHiddenCheckStatsByDepartment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getBigHiddenCheckStatsList', '/apps/company/getBigHiddenCheckStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getBigHiddenCheckStatsTwoList', '/apps/company/getBigHiddenCheckStatsTwo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyLoginStatsList', '/apps/company/getCompanyLoginStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentLoginStatsList', '/apps/company/getDepartmentLoginStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyStarPlaceInfoList', '/apps/company/getCompanyStarPlaceInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyStarControlInfoList', '/apps/company/getCompanyStarControlInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyStarIndustryTypeList', '/apps/company/getCompanyStarIndustryType'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getStandardBuildMonthlyDataList', '/apps/company/getStandardBuildMonthlyDataList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getStandardBuildDataList', '/apps/company/getStandardBuildDataList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyCollectionRatePlaceList', '/apps/company/getCompanyCollectionRatePlaceInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyCollectionRateManageIndustryList', '/apps/company/getCompanyCollectionRateManageIndustry'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyInfoCollectionRatePlaceList', '/apps/company/getCompanyInfoCollectionRatePlaceInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyInfoCollectionRateManageIndustryList', '/apps/company/getCompanyInfoCollectionRateManageIndustry'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskManageList', '/apps/company/getRiskManageList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPlatFormInfo', '/apps/company/getPlatFormInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDangerWorkingList', '/apps/company/getDangerWorkingList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTeachAndTrainList', '/apps/company/getTeachAndTrainList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyCertificateManagementList', '/apps/train/getCompanyCertificateManagementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOnlineLearningList', '/apps/company/getOnlineLearningList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateOnlineLearning', '/apps/company/addOrUpdateOnlineLearning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteOnlineLearning', '/apps/company/deleteOnlineLearning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOnlineLearningVideoList', '/apps/company/getOnlineLearningVideoList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateOnlineLearningVideo', '/apps/company/addOrUpdateOnlineLearningVideo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteOnlineLearningVideo', '/apps/company/deleteOnlineLearningVideo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyPromotionList', '/apps/company/getSafetyPromotionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyPromotion', '/apps/company/addOrUpdateSafetyPromotion'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyPromotion', '/apps/company/deleteSafetyPromotion'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyPromotionVideoList', '/apps/company/getSafetyPromotionVideoList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyPromotionVideo', '/apps/company/addOrUpdateSafetyPromotionVideo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyPromotionVideo', '/apps/company/deleteSafetyPromotionVideo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNoticeList', '/apps/notice/getNoticeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateNotice', '/apps/notice/addOrUpdateNotice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteNotice', '/apps/notice/delete'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getReceiveDepartmentNoticeList', '/apps/notice/getReceiveDepartmentNoticeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteReceiveDepartmentNotice', '/apps/notice/deleteReceiveDepartmentNotice'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addReadRecord', '/apps/notice/addReadRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPerformanceList', '/apps/performance/getPerformanceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updatePerformanceList', '/apps/performance/updatePerformanceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPerformanceScore', '/apps/performance/getPerformanceScore'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPerformanceReduceList', '/apps/performance/getPerformanceReduceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePerformanceReduce', '/apps/performance/addOrUpdatePerformanceReduce'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePerformanceReduce', '/apps/performance/deletePerformanceReduce'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyHiddenList', '/apps/company/getCompanyHiddenList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAdminCompanyHiddenList', '/apps/company/getAdminCompanyHiddenList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckStandardList', '/apps/standard/getCheckStandardList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckStandard', '/apps/standard/addOrUpdateCheckStandard'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckStandard', '/apps/standard/deleteCheckStandard'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'importCheckStandardItem', '/apps/standard/importCheckStandardItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckStandardItemList', '/apps/standard/getCheckStandardItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckStandardItem', '/apps/standard/addOrUpdateCheckStandardItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckStandardItem', '/apps/standard/deleteCheckStandardItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckHiddenList', '/apps/standard/getCheckHiddenList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckHidden', '/apps/standard/addOrUpdateCheckHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckHidden', '/apps/standard/deleteCheckHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'importCheckHiddenItem', '/apps/standard/importCheckHiddenItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckHiddenItemList', '/apps/standard/getCheckHiddenItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckHiddenItem', '/apps/standard/addOrUpdateCheckHiddenItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckHiddenItem', '/apps/standard/deleteCheckHiddenItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'applyRedHidden', '/apps/gov/applyRedHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleClosApply', '/apps/gov/handleClosApply'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckNumData', '/apps/statistics/getCheckNumData'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckTableDBNum', '/apps/check/getCheckTableDBNum'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getGovSpecialWorkList', '/apps/work/getGovSpecialWorkList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialWorkDataByType', '/apps/work/getSpecialWorkDataByType'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTeachAndTrainData', '/apps/company/getTeachAndTrainData'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getMonitorPerformanceList', '/apps/monitor/getMonitorPerformanceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMonitorPerformance', '/apps/monitor/addOrUpdateMonitorPerformance'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteMonitorPerformance', '/apps/monitor/deleteMonitorPerformance'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getGovSpecialCheckList', '/apps/gov/getGovSpecialCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateGovSpecialCheck', '/apps/gov/addOrUpdateGovSpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addGovSpecialCheck', '/apps/gov/addGovSpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateGovSpecialCheck', '/apps/gov/updateGovSpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteGovSpecialCheck', '/apps/gov/deleteGovSpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getGovSpecialCheckCompanyExpertList', '/apps/gov/getGovSpecialCheckCompanyExpertList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addGovSpecialCheckCompanyExpert', '/apps/gov/addGovSpecialCheckCompanyExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteGovSpecialCheckCompanyExpert', '/apps/gov/deleteGovSpecialCheckCompanyExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getGovSpecialCheckCompanyTableList', '/apps/gov/getGovSpecialCheckCompanyTableList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addGovSpecialCheckCompanyTable', '/apps/gov/addGovSpecialCheckCompanyTable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteGovSpecialCheckCompanyTable', '/apps/gov/deleteGovSpecialCheckCompanyTable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getGovSpecialCheckCompanyList', '/apps/gov/getGovSpecialCheckCompanyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addGovSpecialCheckCompany', '/apps/gov/addGovSpecialCheckCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteGovSpecialCheckCompany', '/apps/gov/deleteGovSpecialCheckCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenDangerListByGovList', '/apps/gov/getHiddenDangerListByGov'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionExportDbList', '/apps/supervision/getSupervisionExportDbList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addSupervisionExportDb', '/apps/supervision/addSupervisionExportDb'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'UpdateSupervisionExportDb', '/apps/supervision/updateSupervisionExportDb'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSupervisionExportDb', '/apps/supervision/deleteSupervisionExportDb'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'pushGovCheckToCompany', '/apps/gov/pushGovCheckToCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyListBySpecialCheck', '/apps/gov/getCompanyListBySpecialCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getBoatList', '/apps/company/getShippingInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateBoat', '/apps/company/addOrUpdateShippingInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteBoat', '/apps/company/deleteShippingInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDockList', '/apps/company/getDockInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDock', '/apps/company/addOrUpdateDockInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDock', '/apps/company/deleteDockInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getManagerList', '/apps/admin/getManagerList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteManager', '/apps/admin/deleteManager'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateManager', '/apps/admin/addOrUpdateManager'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'manageAccountDeletePasswordCache', '/apps/admin/deletePasswordCache'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentTreeList', '/apps/company/getDepartmentTreeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateDepartmentTree', '/apps/company/addOrUpdateDepartmentTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteDepartmentTree', '/apps/company/deleteDepartmentTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCommonDepartmentList', '/apps/company/getCommonDepartmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSubAreaList', '/apps/company/getSubAreaList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getClassifyList', '/apps/auth/getClassifyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateClassify', '/apps/auth/addOrUpdateClassify'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteClassify', '/apps/auth/deleteClassify'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getClassifyPermissionList', '/apps/auth/getClassifyPermissionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateClassifyPermission', '/apps/auth/updateClassifyPermission'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPermissionList', '/apps/auth/getPermissionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePermission', '/apps/auth/addPermission'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePermission', '/apps/auth/deletePermission'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getIndustryConstructionList', '/apps/company/getIndustryConstructionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateIndustryConstruction', '/apps/company/addOrUpdateIndustryConstruction '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaListByParentId', '/apps/common/getAreaListByParentId'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getControlList', '/apps/common/getControlList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'exportIndustryConstruction', '/apps/company/exportIndustryConstruction'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionUnitList', '/apps/supervision/getSupervisionUnitList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addSupervisionUnit', '/apps/supervision/addSupervisionUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSupervisionUnit', '/apps/supervision/updateSupervisionUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSupervisionUnit', '/apps/supervision/deleteSupervisionUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionTaskTraceList', '/apps/supervision/getSupervisionTaskTraceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionLevelHiddenNumberInfo', '/apps/supervision/getSupervisionLevelHiddenNumberInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenManage', '/apps/supervision/getHiddenManage'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionTaskList', '/apps/supervision/getSupervisionTaskList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addSupervisionTask', '/apps/supervision/addSupervisionTask'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSupervisionTask', '/apps/supervision/updateSupervisionTask'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSupervisionTask', '/apps/supervision/deleteSupervisionTask'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionTaskUnitList', '/apps/supervision/getSupervisionTaskUnitList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addSupervisionTaskUnit', '/apps/supervision/addSupervisionTaskUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSupervisionTaskUnit', '/apps/supervision/deleteSupervisionTaskUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionCheckList', '/apps/supervision/getSupervisionCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addSupervisionCheck', '/apps/supervision/addSupervisionCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSupervisionCheck', '/apps/supervision/updateSupervisionCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSupervisionCheck', '/apps/supervision/deleteSupervisionCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionHiddenTraceList', '/apps/supervision/getSupervisionHiddenTraceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getIsSafetyDepartment', '/apps/supervision/getIsSafetyDepartment'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSupervisionCheckHiddenList', '/apps/supervision/getSupervisionCheckHiddenList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addSupervisionCheckHidden', '/apps/supervision/addSupervisionCheckHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSupervisionCheckHidden', '/apps/supervision/updateSupervisionCheckHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSupervisionInspect', '/apps/Supervision/SupervisionInspect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSupervisionCheckHidden', '/apps/supervision/deleteSupervisionCheckHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getJobList', '/apps/company/getJobList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateJob', '/apps/company/addOrUpdateJob'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteJob', '/apps/company/deleteJob'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAssessmentConstructionItemList', '/apps/unit/getAssessmentConstructionItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAssessmentConstructionItem', '/apps/unit/addOrUpdateAssessmentConstructionItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAssessmentConstructionItem', '/apps/unit/deleteAssessmentConstructionItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAssessmentConstructionItemCount', '/apps/unit/getAssessmentConstructionItemCount'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenCheckRecordList', '/apps/inspect/getHiddenCheckRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckTableDBList', '/apps/check/getCheckTableDBList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckTableDB', '/apps/check/addOrUpdateCheckTableDB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckTableDB', '/apps/check/deleteCheckTableDB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckTableDBByBatch', '/apps/check/deleteCheckTableDBItemByBatch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckTableDBItemList', '/apps/check/getCheckTableDBItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckTableDBItem', '/apps/check/addOrUpdateCheckTableDBItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckTableDBItem', '/apps/check/deleteCheckTableDBItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getGovCheckExpertList', '/apps/gov/getGovCheckExpertList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addGovCheckExpert', '/apps/gov/addGovCheckExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateGovCheckExpert', '/apps/gov/updateGovCheckExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteGovCheckExpert', '/apps/gov/deleteGovCheckExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskPointPatrolList', '/apps/inspect/getRiskPointPatrolList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getResponsiblePersonInspectionList', '/apps/inspect/getResponsiblePersonInspectionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getResponsibleDeparttmentInspectionList', '/apps/inspect/getResponsibleDeparttmentInspectionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDataHiddenRectifyList', '/apps/inspect/getDataHiddenRectifyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentHiddenRectifyList', '/apps/inspect/getDepartmentHiddenRectifyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPersonHiddenRectifyList', '/apps/inspect/getPersonHiddenRectifyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAssessmentDetailList', '/apps/company/getAssessmentDetailList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAssessmentDetail', '/apps/company/addOrUpdateAssessmentDetail'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAssessmentDetail', '/apps/company/deleteAssessmentDetail'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getEmergencyPlanManagementList', '/apps/standard/getEmergencyPlanManagementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getEmergencyMaterialsManagementList', '/apps/standard/getEmergencyMaterialsManagementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getEmergencyDrillManagementList', '/apps/standard/getEmergencyDrillManagementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'exportContingencyPlan', '/apps/standard/exportContingencyPlan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContingencyDrillProjectList', '/apps/standard/getContingencyDrillProjectList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getControlDepartmentList', '/apps/company/getControlDepartmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRiskSouceCheckRecordList', '/apps/risk/getRiskSouceCheckRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCustomCheckTitle', '/apps/standard/getCustomCheckTitleList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCustomCheck', '/apps/standard/addOrUpdateCustomCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCustomCheck', '/apps/standard/deleteCustomCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCustomCheckTitle', '/apps/standard/addOrUpdateCustomCheckTitle'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCustomCheckTitle', '/apps/standard/deleteCustomCheckTitle'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyCheckTableDBList', '/apps/check/getCompanyCheckTableDBList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCustomCheckList', '/apps/standard/getCustomCheckList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenStandardCheckIndustryList', '/apps/hidden/getHiddenStandardCheckIndustryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getHiddenStandardCheckItemList', '/apps/hidden/getHiddenStandardCheckItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceList', '/apps/insurance/getInsuranceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateInsurance', '/apps/insurance/updateInsurance'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceStaffList', '/apps/insurance/getInsuranceStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceRecordOnlineList', '/apps/insurance/getInsuranceRecordOnlineList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceRecordOfflineList', '/apps/insurance/getInsuranceRecordOfflineList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAgencyListFirst', '/apps/facilitatingAgency/getAgencyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateAgencyFirst', '/apps/facilitatingAgency/updateAgency'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'resetAgencyPassword', '/apps/newfacilitating/resetPassword'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getServiceOrganizationCertificateList', '/apps/newfacilitating/getServiceOrganizationCertificateList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getServiceSpecialistList', '/apps/newfacilitating/getServiceSpecialistList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceProjectOfflineList', '/apps/insurance/getInsuranceProjectOfflineList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOtherProjectList', '/apps/insurance/getOtherProjectList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceTechnicistList', '/apps/insurance/getInsuranceTechnicistList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateInsuranceTechnicist', '/apps/insurance/addOrUpdateInsuranceTechnicist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteInsuranceTechnicist', '/apps/insurance/deleteInsuranceTechnicist'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceProjectOfflineSpecialistList', '/apps/insurance/getInsuranceProjectOfflineSpecialistList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAgencyBlackHistoryList', '/apps/facilitatingagency/getAgencyBlackHistoryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceBlackHistoryList', '/apps/insurance/getInsuranceBlackHistoryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTechnicistBlackHistoryList', '/apps/insurance/getTechnicistBlackHistoryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSingleInsuranceCheckInfo', '/apps/insurance/getSingleInsuranceCheckInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateOtherProjectCheck', '/apps/insurance/addOrUpdateOtherProjectCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateRecordCheck', '/apps/insurance/addOrUpdateRecordCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdatePaymentCheck', '/apps/insurance/addOrUpdatePaymentCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAccidentPreventCheck', '/apps/insurance/addOrUpdateAccidentPreventCheck'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceRecordList', '/apps/insurance/getInsuranceRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceContractManagementList', '/apps/insurance/getInsuranceContractManagementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAdminInsurancePayManagementList', '/apps/insurance/getAdminInsurancePayManagementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleInspect', '/apps/insurance/handleInspect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleInputInfo', '/apps/insurance/handleInputInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceCheckInfoList', '/apps/insurance/getInsuranceCheckInfoList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateInsuranceCheckInfo', '/apps/insurance/addOrUpdateInsuranceCheckInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteInsuranceCheckInfo', '/apps/insurance/deleteInsuranceCheckInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceLostInfoList', '/apps/insurance/getInsuranceLostInfoList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateInsuranceLostInfo', '/apps/insurance/addOrUpdateInsuranceLostInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteInsuranceLostInfo', '/apps/insurance/deleteInsuranceLostInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceStaffDeathsInfoList', '/apps/insurance/getInsuranceStaffDeathsList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateInsuranceStaffDeathsInfo', '/apps/insurance/addOrUpdateInsuranceStaffDeathsInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteInsuranceStaffDeathsInfo', '/apps/insurance/deleteInsuranceStaffDeathsInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsurancePropertyInfoList', '/apps/insurance/getInsurancePropertyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateInsurancePropertyInfo', '/apps/insurance/addOrUpdateInsurancePropertyInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteInsurancePropertyInfo', '/apps/insurance/deleteInsurancePropertyInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceProjectList', '/apps/insurance/getInsuranceProjectList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPreventionMajorItemsList', '/apps/insurance/getPreventionMajorItemsList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addorUpdatePreventionMajorItems', '/apps/insurance/addorUpdatePreventionMajorItems'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePreventionMajorItems', '/apps/insurance/deletePreventionMajorItems'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updatePreventionMajorItems', '/apps/insurance/updatePreventionMajorItems'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'receivingUnit', '/apps/insurance/receivingUnit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'companyVisit', '/apps/insurance/companyVisit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceInfo', '/apps/insurance/getInsuranceInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOtherInsuranceProjectList', '/apps/insurance/getOtherInsuranceProjectList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPreventionMajorDetailList', '/apps/insurance/getPreventionMajorDetailList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updatePreventionMajorDetail', '/apps/insurance/updatePreventionMajorDetail'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAccidentPreventionFileList', '/apps/insurance/getAccidentPreventionFileList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAccidentPreventionFile', '/apps/insurance/addOrUpdateAccidentPreventionFile'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAccidentPreventionFile', '/apps/insurance/deleteAccidentPreventionFile'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainPlanStaffList', '/apps/train/getTrainPlanStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainPlanStaff', '/apps/train/addOrUpdateTrainPlanStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteTrainPlanStaff', '/apps/train/deleteTrainPlanStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTrainStaffList', '/apps/train/getTrainStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateTrainStaff', '/apps/train/addOrUpdateTrainStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceSubmissionList', '/apps/insurance/getInsuranceSubmissionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addInsuranceSubmissionByPolicy', '/apps/insurance/addInsuranceSubmissionByPolicy'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addInsuranceSubmissionByClaim', '/apps/insurance/addInsuranceSubmissionByClaim'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addInsuranceSubmissionByAccident', '/apps/insurance/addInsuranceSubmissionByAccident'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateSubmission', '/apps/insurance//updateSubmission'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceEvaluationList', '/apps/insurance/getInsuranceEvaluationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getFacilitatingEvaluationList', '/apps/insurance/getFacilitatingEvaluationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceEvaluationTableList', '/apps/insurance/getInsuranceEvaluationTableList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAccidentPreventionStaffList', '/apps/insurance/getAccidentPreventionStaffList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAccidentPreventionStaff', '/apps/insurance/addOrUpdateAccidentPreventionStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAccidentPreventionStaff', '/apps/insurance/deleteAccidentPreventionStaff'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRecordCompanyAreaStatsList', '/apps/insurance/getRecordCompanyAreaStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getRecordCompanyIndustryStatsList', '/apps/insurance/getRecordCompanyIndustryStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceCompanyStatsList', '/apps/insurance/getInsuranceCompanyStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getServiceFeeStatsList', '/apps/insurance/getServiceFeeStats'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOperationLogList', '/apps/requestlog/getList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteOperationLog', '/apps/requestlog/delete'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getListByCompany', '/apps/loginlog/getListByCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getListByGov', '/apps/loginlog/getListByGov'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteEntryLog', '/apps/loginlog/delete'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'get5sCheckDutyList', '/apps/fivesCheck/get5scheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'add5sCheckDuty', '/apps/fivesCheck/add5scheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'delete5sCheckDuty', '/apps/fivesCheck/delete5scheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'update5sCheckDuty', '/apps/fivesCheck/update5scheckDuty'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdate5sCheckRecord', '/apps/fivesCheck/addOrUpdate5sCheckRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'get5sCheckRecordList', '/apps/fivesCheck/get5sCheckRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'delete5sCheckRecord', '/apps/fivesCheck/delete5sCheckRecord'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyProductionTargetMissionList', '/apps/standard/getSafetyProductionTargetMissionList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateSafetyProductionTargetMission', '/apps/standard/addOrUpdateSafetyProductionTargetMission'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteSafetyProductionTargetMission', '/apps/standard/deleteSafetyProductionTargetMission'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTaskRecordList', '/apps/standard/getTaskRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getWorkTaskList', '/apps/standard/getWorkTaskList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getExpertSelectList', '/apps/company/getExpertSelectList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateExpertSelect', '/apps/company/addOrUpdateExpertSelect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteExpertSelect', '/apps/company/deleteExpertSelect'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getExpertWorkList', '/apps/company/getExpertWorkList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateExpertWork', '/apps/company/addOrUpdateExpertWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteExpertWork', '/apps/company/deleteExpertWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getExpertList', '/apps/company/getExpertList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateExpert', '/apps/company/addOrUpdateExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteExpert', '/apps/company/deleteExpert'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteExpertByBatch', '/apps/company/deleteExpertByBatch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getContinuouslyImproveList', '/apps/standard/getContinuouslyImproveList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getPerformanceReduceList', '/apps/performance/getPerformanceReduceList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniPlatFormInfoList', '/apps/nineminicompany/getNineMiniPlatFormInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniCompanyRecordList', '/apps/nineminicompany/getNineMiniCompanyRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyHiddenCheckRecordList', '/apps/nineminicompany/getCompanyHiddenCheckRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCompanyHiddenCheckRecordItemResultList', '/apps/nineminicompany/getCompanyHiddenCheckRecordItemResultList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniCheckManRecordList', '/apps/nineminicompany/getNineMiniCheckManRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAdminCheckManHiddenCheckRecordList', '/apps/nineminicompany/getAdminCheckManHiddenCheckRecordList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckManHiddenCheckRecordItemResultList', '/apps/nineminicompany/getCheckManHiddenCheckRecordItemResultList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAdminNineMiniCheckManHiddenList', '/apps/nineminicompany/getAdminNineMiniCheckManHiddenList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniCompanyCheckManList', '/apps/nineminicompany/getNineMiniCompanyCheckManList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addNineMiniCompanyCheckMan', '/apps/nineminicompany/addNineMiniCompanyCheckMan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateNineMiniCompanyCheckMan', '/apps/nineminicompany/updateNineMiniCompanyCheckMan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteNineMiniCompanyCheckMan', '/apps/nineminicompany/deleteNineMiniCompanyCheckMan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'resetNineMiniCompanyCheckManPassword', '/apps/nineminicompany/resetNineMiniCompanyCheckManPassword'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'openNineMiniCompanyCheckMan', '/apps/nineminicompany/openNineMiniCompanyCheckMan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'closeNineMiniCompanyCheckMan', '/apps/nineminicompany/closeNineMiniCompanyCheckMan'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addCheckManCompany', '/apps/nineminicompany/addCheckManCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckManCompany', '/apps/nineminicompany/deleteCheckManCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCityDepartmentTreeList', '/apps/common/getCityDepartmentTreeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaDepartmentTreeList', '/apps/common/getAreaDepartmentTreeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getTownList1', '/apps/common/getTownList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getVillageList1', '/apps/common/getVillageList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSafetyDepartmentTreeList', '/apps/common/getSafetyDepartmentTreeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'checkLoginName', '/apps/nineminicompany/checkLoginName'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getFourList', '/apps/nineminicompany/getFourList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniCompanyList', '/apps/nineminicompany/getNineMiniCompanyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniCompanyInfo', '/apps/nineminicompany/getInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateNineMiniCompanyBaseInfo', '/apps/nineminicompany/updateBaseInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'resetNineMiniCompanyPassword', '/apps/nineminicompany/resetPassword'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleCompanyProductionStatus', '/apps/nineminicompany/handleCompanyProductionStatus'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteNineMiniCompany', '/apps/nineminicompany/deleteNineMiniCompany'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deletePasswordCache', '/apps/nineminicompany/deletePasswordCache'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniIndustry', '/apps/dictionary/getNineMiniIndustry'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateUsername', '/apps/nineminicompany/updateUsername'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getLinkNineMiniCompanyList', '/apps/nineminicompany/getLinkNineMiniCompanyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckTableList', '/apps/nineminicompany/getCheckTableList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckTable', '/apps/nineminicompany/addOrUpdateCheckTable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckTable', '/apps/nineminicompany/deleteCheckTable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniPlaceType', '/apps/dictionary/getNineMiniPlaceType'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckTableItemList', '/apps/nineminicompany/getCheckTableItemList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateCheckTableItem', '/apps/nineminicompany/addOrUpdateCheckTableItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckTableItem', '/apps/nineminicompany/deleteCheckTableItem'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteCheckTableItemByBatch', '/apps/nineminicompany/deleteCheckTableItemByBatch'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckManCompanyList', '/apps/nineminicompany/getCheckManCompanyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'resetNineMiniCompanyCheckManPassword', '/apps/nineminicompany/resetNineMiniCompanyCheckManPassword'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAdminNineMiniHiddenList', '/apps/nineminicompany/getAdminNineMiniHiddenList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteAdminNineMiniHidden', '/apps/nineminicompany/deleteNineMiniHidden'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineminiCompanyRateInfoList', '/apps/nineminicompany/getNineminiCompanyRateInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineMiniCompanyInfoList', '/apps/nineminicompany/getNineMiniCompanyInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNineminiCompanyHiddenInfoList', '/apps/nineminicompany/getNineminiCompanyHiddenInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCheckManHiddenAreaInfo', '/apps/nineminicompany/getCheckManHiddenAreaInfo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateProjectValuation', '/apps/facilitatingagency/addOrUpdateProjectValuation'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProjectValuationList', '/apps/facilitatingagency/getProjectValuationList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getInsuranceOrganizationYearReportList', '/apps/insurance/getInsuranceOrganizationYearReportList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getYearSeasonMonthList', '/apps/performance/getYearSeasonMonthList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCityDepartmentList', '/apps/performance/getCityDepartmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProcessMonthTableList', '/apps/performance/getProcessMonthTableList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMonthTable', '/apps/performance/addOrUpdateMonthTable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'submitMonthTable', '/apps/performance/submitMonthTable'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProcessMonthTableThreeList', '/apps/performance/getProcessMonthTableThreeList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMonthTableThree', '/apps/performance/addOrUpdateMonthTableThree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getProcessMonthTableTwoList', '/apps/performance/getProcessMonthTableTwoList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateMonthTableTwo', '/apps/performance/addOrUpdateMonthTableTwo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaDepartmentList', '/apps/performance/getAreaDepartmentList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCityWorkList', '/apps/performance/getCityWorkList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateCityWork', '/apps/performance/updateCityWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaWorkList', '/apps/performance/getAreaWorkList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateAreaWork', '/apps/performance/updateAreaWork'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentYearTaskList', '/apps/performance/getDepartmentYearTaskList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateDepartmentYearTask', '/apps/performance/updateDepartmentYearTask'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaYearTaskList', '/apps/performance/getAreaYearTaskList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateAreaYearTask', '/apps/performance/updateAreaYearTask'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getDepartmentAchievementScoreList', '/apps/performance/getDepartmentAchievementScoreList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaAchievementScoreList', '/apps/performance/getAreaAchievementScoreList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getCityDepartmentMonthSummaryList', '/apps/performance/getCityDepartmentMonthSummaryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAreaMonthSummaryList', '/apps/performance/getAreaMonthSummaryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAchievementMonthList', '/apps/performance/getAchievementMonthList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAgencyList', '/apps/newfacilitating/getAgencyList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'updateAgency', '/apps/newfacilitating/updateAgency'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAchievementList', '/apps/newfacilitating/getAchievementList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAchievementDetailList', '/apps/newfacilitating/getAchievementDetailList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAgencyScoreList', '/apps/newfacilitating/getAgencyScoreList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateAgencyScoreList', '/apps/newfacilitating/addOrUpdateAgencyScoreList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAgencySelfAssessmentScoreList', '/apps/newfacilitating/getAgencySelfAssessmentScoreList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getOrganizationList', '/apps/newfacilitating/getOrganizationTree'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getSpecialistCertificateList', '/apps/newfacilitating/getSpecialistCertificateList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'handleFacilitatingAgencyProductionStatus', '/apps/newfacilitating/handleFacilitatingAgencyProductionStatus'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteNewFacilitatingAgency', '/apps/newfacilitating/deleteNewFacilitatingAgency'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getNewFacilitatingAgencyHandleHistoryList', '/apps/newfacilitating/getNewFacilitatingAgencyHandleHistoryList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteNewFacilitatingPasswordCache', '/apps/newfacilitating/deletePasswordCache'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getZAreaList', '/apps/dictionary/getZAreaList'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'addOrUpdateZArea', '/apps/dictionary/addOrUpdateZArea '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'deleteZArea', '/apps/dictionary/deleteZArea'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_api, 'getAnnounceAgencyList', '/apps/newfacilitating/getAnnounceAgencyList'), _api);

/***/ }),

/***/ "PNXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 4,
  path: '/riskManagement',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/riskManagement/index',
  name: 'riskManagement',
  isHead: true,
  meta: {
    title: '风险管控',
    img: __webpack_require__("prKM")
  },
  children: [{
    path: 'index',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "/WDO"));
    },
    name: 'RiskManagement',
    meta: { title: '风险管控', close: false
      // children: [{
      //   path: 'riskStorage',
      //   component: () => import('@/views/riskManagement/riskStorage/index'),
      //   name: 'riskStorage',
      //   meta: { title: '风险库管理', close: false}
      // }, {
      //   path: 'riskRanking',
      //   name: 'riskRanking',
      //   component: () => import('@/views/riskManagement/riskRanking/index'),
      //   meta: {title: '风险分级', close: true}
      // }]
    } }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "Q3mI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Q5zC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__showFile_vue__ = __webpack_require__("iNGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_store__ = __webpack_require__("YtJ0");










var showFileConstructor = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2__showFile_vue__["a" /* default */]);
var instance = void 0;

var selectTip = function selectTip() {
  var _this = this;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var url = options.url;
  if (options.database) {
    __WEBPACK_IMPORTED_MODULE_7__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* api */]['copyFile'], { origin_url: encodeURIComponent(url) }).then(function (res) {
      if (res.data.code == 0) {
        url = res.data.data.url;
      } else {
        _this.$message({
          type: 'warning',
          message: res.data.msg
        });
      }
    });
  }
  var suffix = urlType(url);
  var type = options.type ? 'openEditor' : 'openPreview';
  var title = options.title ? options.title : 'office';
  if (suffix == 'image' || suffix == 'video') {
    if (type == 'openEditor') {
      return Object(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"])({
        type: 'warning',
        message: '\u6682\u4E0D\u652F\u6301\u7F16\u8F91' + suffix + '\u683C\u5F0F'
      });
    } else {
      instance = new showFileConstructor({
        data: options
      });
      document.body.appendChild(instance.$mount().$el);
    }
  } else {
    instance = new showFileConstructor({
      data: options
    });
    document.body.appendChild(instance.$mount().$el);
    // editFile(url, type, title, suffix)
  }
};
function urlType(url) {
  // 后缀获取
  var suffix = '';
  // 获取类型结果
  var result = '';
  try {
    var flieArr = url.split('.');
    suffix = flieArr[flieArr.length - 1];
  } catch (err) {
    suffix = '';
  }
  // fileName无后缀返回 false
  if (!suffix) {
    return '-1';
  }
  // 图片格式
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
  // 进行图片匹配
  result = imglist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'image';
    return result;
  }
  var videolist = ['mp4', 'm2v', 'mkv'];
  result = videolist.some(function (item) {
    return item == suffix;
  });
  if (result) {
    result = 'video';
    return result;
  }
  return suffix;
}

function editFile(url, type, title, suffix) {
  var data = {
    doc: {
      docId: __WEBPACK_IMPORTED_MODULE_4_blueimp_md5___default()(url), // 用文件地址的md5(url)作为id
      title: title + '.' + suffix, // 必须保持后缀，给编辑器用于识别
      fetchUrl: url,
      callback: '/apps/res/onlineEditorCallback?origin_url=' + encodeURIComponent(url)
    },
    user: {
      uid: 'admin',
      nickName: '管理员',
      avatar: 'https://bisheng-upload.nodoc.cn/system/defaultAvatar.png'
    }
  };
  var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
  var wordArray = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Utf8.parse(str);
  var base64 = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.enc.Base64.stringify(wordArray);
  // openPreview
  var new_url = 'http://120.26.95.88:8089/apps/editor/' + type + '?data=' + base64;
  window.open(new_url);
}

// export default importTip
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$showFile = selectTip;
  }
});

/***/ }),

/***/ "QETk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.levelList),function(item){return _c('el-breadcrumb-item',{key:item.path,attrs:{"to":item.path}},[_vm._v(_vm._s(item.meta.title))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QZ7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("2Pvn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc1858e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("CUIY");
function injectStyle (ssrContext) {
  __webpack_require__("8LMS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bc1858e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bc1858e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QeB7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA9RJREFUaEPtmVmo7XMUxz9fD0RkSkKIQhQeZLy5cV03LzzcuDJcriGzDMULpYh4MJRbJGSeH5T7YJ4zdSNvylgikpQpFF99T7992mefvc/+T/voaK/aD2ef9Vu/73et9Vtr/X5bLHHREsfPlMB/HcFpBP6XEbC9M3AicAawN/Ae8AjwhKS/uiTdaQrZXg2cApwAbDoE6DfA4yEj6eMuiLQmYPsA4DTgJGCPGqBeBu6V9GSNNfNUGxGwvQ0Qbwf4ijYAgC+BR/OR9EldW7UI2D4QuKTkd0h0LRuA2yS9VtXwWAK2twXWFG8fWdVwS72PgAdKVH5cyNZIArZXAqeWVNm6JaCmy38BngoZSW8PMzKHgO0dgPMK8P2a7jqhdR+Us3KfpN96e8wSsH0RcAuw5YQAdGX2O+A6SffEYD8Bd7XDYtiRNIO9n8AqIKx2XwwALfZ4FbhB0utzCOQP25uVMpl02rPFJpNcupekz+adgf4dbW8CrAUuBA6dJJoxtr8AbgZ2jNeL7jJJ7yxIYIBMZpsQWawekO0zJyWd75b0j+0MhQ8WXMslvVWZQE/R9hHA6cDJwHYTiEqKyNPA/ZJeGHDilcCtrQj0EUlTy+C2DljWAZGvincfkpSUmSe2r8iI0QmBAc8cVMbndOydapJ5F1gv6bFx62xfBtzROYG+qKR65ZwkvQ4bA+jFAvy5Qb3STDdKStedFdtnltko3+3bP7WOHeaGHOhjgLTzeHBYuA8uZ+W4chuLztfA8zmYkjYO2ExKngtcXO4TayTlLMyI7UwGrwCHlK/WSsrtbkbqErgcuL2s/RBI+J+V9PkIMukluZl9KunvAeBJuUuB8weKworeOG17ebmK7jpgf52kmapUl8DZ8f4QsKkazwAbJGVWGSm2MyQm3c4BNh+iuFJSPB7vn5WqNETnGkk3dUmgt8cfJdwPA+8D3+YSbztld5/i8fSVhWSWQCFxAXBX34JrJd3YNIVGRWAUoO+Bn4FdgC3GAO/9ew6BQuLqMinn7OW8zEpXKVQRWyW1eQQKiVWSUsHmyJIhMIr6lEClpKinNDSFllIEjpWUR69KUjeF+qfCShs0UDpeUt6HKkldAvsDmcUn9cySl7mjxzXDxmW0lLO8f+aBtuubWrr5akm/V3J9UaoVgX7Dtq8C8slbUhv5Abhe0vomRhoTKNHYCkirT3fM7wB1JANg5qo7Jf1aZ2GrFBq1ke3czg4HjgJ2A7Yvj2Rx0p/AT0AGvTeBNyS91BT0RAh0AaaJjVYp1GTDrtdMCXTt0br2phGo67Gu9acR6Nqjde39C/xrMUBrcAjoAAAAAElFTkSuQmCC"

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_KEY; });
// 请求安全校验的check_key值
var CHECK_KEY = '87435979f891460c19s8d2f22f389345';

/***/ }),

/***/ "R6Np":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "RhYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectExpertDialog_vue__ = __webpack_require__("Ldr4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6199c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectExpertDialog_vue__ = __webpack_require__("3uqR");
function injectStyle (ssrContext) {
  __webpack_require__("WYXX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c6199c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectExpertDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6199c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectExpertDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S2ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Smyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Util_commonOptions__ = __webpack_require__("oQse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userInfo: {},
      classify_list: [],
      dialogFormVisible: false,
      industryOptions: __WEBPACK_IMPORTED_MODULE_1__Util_commonOptions__["k" /* industryOptions */],
      departmentOptions: [],
      controlArr: [],
      departmentData: [],
      ruleForm: {
        contact_name: null, // 联系姓名
        contact: null, //联系电话
        id: null
      }
    };
  },

  computed: {
    formTitle: function formTitle() {
      return '账号信息';
    }
  },
  mounted: function mounted() {
    var userInfo = this.$store.getters.userInfo;
    this.userInfo = userInfo;
    this.ruleForm = {
      contact_name: this.userInfo.contact_name,
      contact: this.userInfo.contact,
      id: this.userInfo.id
    };
  },

  methods: {
    showForm: function showForm() {
      this.dialogFormVisible = true;
    },
    submitForm: function submitForm() {
      var _this = this;

      var params = {
        id: this.ruleForm.id,
        contact_name: this.ruleForm.contact_name,
        contact: this.ruleForm.contact
      };
      this.$http.post(__WEBPACK_IMPORTED_MODULE_0__api_api__["a" /* api */]['addOrUpdateManager'], params).then(function (res) {
        if (res.data.code === 0) {
          _this.$message({
            message: '修改成功',
            type: 'success'
          });
          _this.dialogFormVisible = false;
          _this.$emit('refreshTable');
        } else {
          _this.$message({
            message: params.id ? '\u4FEE\u6539\u5931\u8D25 ' + res.data.msg : '\u65B0\u589E\u5931\u8D25 ' + res.data.msg,
            type: 'success'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "T0sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{ref:"view"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TJ3i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportUserFDlg_vue__ = __webpack_require__("DqVw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a3532a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportUserFDlg_vue__ = __webpack_require__("OO9Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportUserFDlg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66a3532a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportUserFDlg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TMsn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UR5A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc.f7d13a7.png";

/***/ }),

/***/ "W27U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 1,
  path: '/home',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/home/index',
  name: 'home',
  isHead: true,
  meta: {
    title: '工作台',
    img: __webpack_require__("Ys/a")
  },
  children: [{
    path: 'index',
    component: function component() {
      return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "KR8f"));
    },
    name: 'Home',
    meta: { title: '工作台', close: false }
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "WYXX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WYls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 6,
  path: '/riskWork',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/riskWork/index',
  name: 'riskWork',
  isHead: true,
  meta: {
    title: '危险作业',
    icon: 'el-icon-position'
  },
  children: [{
    path: 'index',
    component: function component() {
      return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, "8j3J"));
    },
    name: 'RiskWork',
    meta: { title: '危险作业', close: false }
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "XLer":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 10,
  path: '/expert',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/expert/expertService/appoint',
  name: 'expert',
  isHead: true,
  meta: {
    title: '专家服务',
    icon: 'el-icon-s-custom'
  },
  children: [{
    path: 'expertService',
    name: 'expertService',
    component: function component() {
      return __webpack_require__.e/* import() */(179).then(__webpack_require__.bind(null, "Vu+K"));
    },
    meta: { title: '专家服务', close: false },
    children: [{
      path: 'appoint',
      name: 'appoint',
      component: function component() {
        return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, "8QmN"));
      },
      meta: { title: '专家选派', close: false, next: '/expert/expertService/expertManagement' }
    }, {
      path: 'expertManagement',
      name: 'expertManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(149).then(__webpack_require__.bind(null, "VX+K"));
      },
      meta: { title: '专家管理', close: false }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "Y2B9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAe5JREFUSEu1lU2IT1EYh5/HR9MspHwtkNREih0bK6UpysIgC8nXQsqCIrL1sbCQnZKyUpJCYyML0exImih2JBZY+Eoh9OqtO/WfO/d///eOcXbnnt/7e8457/ueK/952NQ/IvqA58AW9WnTuDaABcB7YFC9N2lARBwD+tQznSYRMRO4DhxRX5XW1gJb1YwdNyacICL2A5eAjerdXjuNiDnAM2BU3dQTkIKIOAkMq0+K+XxgHTAX+AE8Ul8UawuB08BR9XMjwJgoItI4r2oX0F8KfgCcUB/WnbJrkiNiALgDLKsx+A3sUa920xgR/er3UtKyJB8Dq3rlAPgDrFFHq7QJ+Ah8AS6o54p7PZjzioDUza74fl9dX8QOAqeAeeryBKwEtmcTqVmGmeTc/eqS0QdgRQHeUQEZUF9GxE5gCLim3qgq01nAJ2B6yeQ4kA2WSZ1RAahswCrAIuBtyeB1keylQK7vzeSWNEPqcM8yjYgqwDfgMvBOPRsRF4EDJbPN6u3JAsbi0jSvqKpipgSwATgETHgSgCkB1LXFP+WgQb/RGLAYeNPEsaTZpt5skuRpxasZLSBZ7l/Vn7WAiMh2P5zN3MK8Uzqinu/8MK7RIiKfgK4vYwPoFXV3HWAJMALkf6Dt+AXsU291BbR1bKL/C8y5tRlm3Is0AAAAAElFTkSuQmCC"

/***/ }),

/***/ "YH7k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YHT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectCheckListDialog_vue__ = __webpack_require__("ZLWG");



var selectCheckListDialogConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1__selectCheckListDialog_vue__["a" /* default */]);
var instance = void 0;

var selectTip = function selectTip() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  instance = new selectCheckListDialogConstructor({
    data: options
  });
  document.body.appendChild(instance.$mount().$el);
};

// export default importTip
/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.$selectCheckList = selectTip;
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_frame_Login__ = __webpack_require__("Co0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_frame_Error__ = __webpack_require__("MN1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__ = __webpack_require__("QZ7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_frame_Success__ = __webpack_require__("vOrB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__ = __webpack_require__("OqaL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_frame_showCompany_showCompany__ = __webpack_require__("O5EB");



// import {PAGE_PERMISSION_MAP} from './permission'







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var routes = [];
var routerContext = __webpack_require__("kyiS");
routerContext.keys().forEach(function (route) {
  var routerModule = routerContext(route);
  var router = routerModule.default || routerModule;
  if (router.isShow) {
    routes.push(router);
  }
  // routes = [...routes, ...(routerModule.default || routerModule)]
});
var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  // scrollBehavior (to,from,savedPosition){
  //   // return 期望滚动到哪个位置
  //   // 返回原来的位置
  //   // return savePosition
  //   // 返回页面顶部
  //   return { x:0, y:0 }
  // },
  mode: 'history',
  routes: [].concat(routes, [
  // 默认进入路劲
  {
    path: '/', redirect: '/login'
  },
  // 登录页面
  {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_frame_Login__["a" /* default */]
  },
  // 企业管理（工作台）
  // {
  //   path: '/home',
  //   component: Home,
  //   name: 'home',
  //   redirect: '/home/index',
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'home/index',
  //       component: () => import('@/views/dataViews/dataViews'),
  //       meta: {title: '整体数据概况', close: false}
  //     }
  //   ]
  // },
  // 系统资料
  {
    path: '/systemData',
    name: 'systemData',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    children: [{ path: '/', name: 'page', redirect: 'index' }, {
      path: 'index',
      name: 'systemData/index',
      component: function component() {
        return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "3yK/"));
      },
      meta: { title: '系统资料', close: true }
    }]
  },
  // 区域管理
  {
    path: '/areaManagement',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    name: 'areaManagement',
    redirect: '/areaManagement/index',
    children: [{
      path: 'index',
      name: 'areaManagement/index',
      component: function component() {
        return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "hoH2"));
      },
      meta: { title: '区域管理', close: true }
    }, {
      path: 'AccountManagement',
      name: 'AccountManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, "V2sR"));
      },
      meta: { title: '账号管理', close: true }
    }]
  },
  // 部门账号配置
  {
    path: '/departmentManagement',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    name: 'departmentManagement',
    redirect: '/departmentManagement/index',
    children: [{
      path: 'index',
      name: 'departmentManagement/index',
      component: function component() {
        return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "WVu7"));
      },
      meta: { title: '部门账号配置', close: true }
    }]
  }, {
    path: '/townManagement',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    name: 'townManagement',
    redirect: '/townManagement/index',
    children: [{
      path: 'index',
      name: 'townManagement/index',
      component: function component() {
        return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "GUQg"));
      },
      meta: { title: '乡镇账号配置', close: true }
    }]
  }, {
    path: '/villageManagement',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    name: 'villageManagement',
    redirect: '/villageManagement/index',
    children: [{
      path: 'index',
      name: 'villageManagement/index',
      component: function component() {
        return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "siX7"));
      },
      meta: { title: '村账号配置', close: true }
    }]
  }, {
    path: '/town',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    name: 'index',
    redirect: '/town/index',
    children: [{
      path: 'index',
      name: 'town/index',
      component: function component() {
        return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, "7dwd"));
      },
      meta: { title: '相关乡镇信息', close: true }
    }]
  },
  // 相关部门信息
  {
    path: '/department',
    component: __WEBPACK_IMPORTED_MODULE_6__components_frame_Home__["a" /* default */],
    name: 'department',
    redirect: '/department/departmentBase',
    children: [{
      path: 'departmentBase',
      name: 'department/departmentBase',
      component: function component() {
        return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, "tm4d"));
      },
      meta: { title: '基本信息调研', close: true }
    }, {
      path: 'specialDepartment',
      name: 'department/specialDepartment',
      component: function component() {
        return __webpack_require__.e/* import() */(159).then(__webpack_require__.bind(null, "c1FM"));
      },
      meta: { title: '特定信息调研', close: true }
    }]
  },
  // 企业信息
  {
    path: '/company',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    name: 'company',
    redirect: '/company/index',
    // meta: {title: ''},
    children: [{
      path: 'index',
      name: 'company/index',
      component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "JXTs"));
      },
      meta: { title: '安全基本信息', close: false, isCompany: true }
    }]
  }, {
    path: '/unit',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    name: 'unit',
    redirect: '/unit/index',
    // meta: {title: ''},
    children: [{
      path: 'index',
      name: 'unit/index',
      component: function component() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "YPkc"));
      },
      meta: { title: '单元风险', close: true, isCompany: true }
    }]
  }, {
    path: '/staff',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    children: [{ path: '/', name: '', redirect: 'index' }, {
      path: 'index',
      name: 'staff/index',
      component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "CwGy"));
      },
      meta: { title: '人员机构', close: true, isCompany: true }
    }]
  }, {
    path: '/building',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    children: [{ path: '/', name: '', redirect: 'index' }, {
      path: 'index',
      name: 'building/index',
      component: function component() {
        return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, "6GvA"));
      },
      meta: { title: '场所管理', close: true, isCompany: true }
    }]
  }, {
    path: '/device',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    children: [{ path: '/', name: '', redirect: 'index' }, {
      path: 'index',
      name: 'device/index',
      component: function component() {
        return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "ArSg"));
      },
      meta: { title: '设备管理', close: true, isCompany: true }
    }]
  }, {
    path: '/work',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    children: [{ path: '/', name: '', redirect: 'index' }, {
      path: 'index',
      name: 'work/index',
      component: function component() {
        return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, "Sj0h"));
      },
      meta: { title: '作业管理', close: true, isCompany: true }
    }]
  }, {
    path: '/controlCompliance',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    // name: 'unit',
    // redirect: '/unit/index',
    // meta: {title: '工作台'},
    children: [{ path: '/', name: '', redirect: 'index' }, {
      path: 'index',
      name: 'controlCompliance/index',
      component: function component() {
        return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "4gPb"));
      },
      meta: { title: '隐患上报', close: true, isCompany: true }
    }]
  }, {
    path: '/dynamic',
    component: __WEBPACK_IMPORTED_MODULE_8__components_frame_company_CompanyHome__["a" /* default */],
    name: 'dynamic',
    redirect: '/dynamic/riskList',
    // meta: {title: ''},
    children: [{
      path: 'riskList',
      name: 'dynamic/riskList',
      component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "dQop"));
      },
      meta: { title: '整体风险清单', close: true, isCompany: true }
    }, {
      path: 'majorHazardSourceList',
      name: 'dynamic/majorHazardSourceList',
      component: function component() {
        return __webpack_require__.e/* import() */(187).then(__webpack_require__.bind(null, "UsCP"));
      },
      meta: { title: '重大危险源清单', close: true, isCompany: true }
    }, {
      path: 'yinhuan',
      name: 'dynamic/yinhuan',
      component: function component() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "Wglr"));
      },
      meta: { title: '隐患排查清单', close: true, isCompany: true }
    }, {
      path: 'riskLevelMap',
      name: 'dynamic/riskLevelMap',
      component: function component() {
        return __webpack_require__.e/* import() */(186).then(__webpack_require__.bind(null, "70XA"));
      },
      meta: { title: '风险四色图', close: true, isCompany: true }
    }]
  },
  // 纯信息展示的页面（大屏跳至后台）
  {
    path: '/info',
    component: __WEBPACK_IMPORTED_MODULE_9__components_frame_showCompany_showCompany__["a" /* default */],
    name: 'info',
    redirect: '/info/base',
    children: [{
      path: 'hiddenList',
      name: 'info/hiddenList',
      component: function component() {
        return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "9LY+"));
      },
      meta: { title: '隐患列表', close: false }
    }, {
      path: 'hiddenPage',
      name: 'info/hiddenPage',
      component: function component() {
        return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, "ruEA"));
      },
      meta: { title: '隐患排查', close: false }
    }, {
      path: 'admin',
      name: 'info/admin',
      component: function component() {
        return __webpack_require__.e/* import() */(177).then(__webpack_require__.bind(null, "5M5G"));
      },
      meta: { title: '隐患', close: false }
    }, {
      path: 'base',
      name: 'info/base',
      component: function component() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "YPwU"));
      },
      meta: { title: '基本信息', close: false }
    }, {
      path: 'unit',
      name: 'info/unit',
      component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "jUhO"));
      },
      meta: { title: '单元安全参数', close: false }
    }, {
      path: 'unitMulti',
      name: 'info/unitMulti',
      component: function component() {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "J8S3"));
      },
      meta: { title: '单元信息', close: false }
    }, {
      path: 'hidden',
      name: 'info/hidden',
      component: function component() {
        return __webpack_require__.e/* import() */(171).then(__webpack_require__.bind(null, "Ua0e"));
      },
      meta: { title: '隐患信息', close: false }
    }, {
      path: 'risk',
      name: 'info/risk',
      component: function component() {
        return __webpack_require__.e/* import() */(170).then(__webpack_require__.bind(null, "x08+"));
      },
      meta: { title: '风险点信息', close: false }
    }, {
      path: 'echart',
      name: 'info/echart',
      component: function component() {
        return __webpack_require__.e/* import() */(172).then(__webpack_require__.bind(null, "NQ8g"));
      },
      meta: { title: '图表', close: false }
    }, {
      path: 'riskCheck',
      name: 'info/riskCheck',
      component: function component() {
        return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "xpfP"));
      },
      meta: { title: '检查记录', close: false }
    }, {
      path: 'riskList',
      name: 'info/riskList',
      component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "2riU"));
      },
      meta: { title: '风险管控到位率', close: false }
    }, {
      path: 'emergency',
      name: 'info/emergency',
      component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "tD8H"));
      },
      meta: { title: '应急管理', close: false }
    }, {
      path: 'accident',
      name: 'info/accident',
      component: function component() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "QTse"));
      },
      meta: { title: '应急管理', close: false }
    }, {
      path: 'hiddenInfo',
      name: 'info/hiddenInfo',
      component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "hFZh"));
      },
      meta: { title: '隐患治理', close: false }
    }, {
      path: 'education',
      name: 'info/education',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "S7hD"));
      },
      meta: { title: '安全教育培训', close: false }
    }, {
      path: '5SManage',
      name: 'info/5SManage',
      component: function component() {
        return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, "wsRx"));
      },
      meta: { title: '5S管理', close: false }
    }, {
      path: 'performanceManage',
      name: 'info/performanceManage',
      component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "STgj"));
      },
      meta: { title: '履职管理', close: false }
    }, {
      path: 'hidenCheck',
      name: 'info/hidenCheck',
      component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "Z9Br"));
      },
      meta: { title: '隐患清单', close: false }
    }, {
      path: 'majiorHidden',
      name: 'info/majiorHidden',
      component: function component() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "lCRk"));
      },
      meta: { title: '重大隐患管理', close: false }
    }, {
      path: 'securityCheck',
      name: 'info/securityCheck',
      component: function component() {
        return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, "XUjB"));
      },
      meta: { title: '整改清单', close: false }
    }, {
      path: 'managementPage',
      name: 'info/managementPage',
      component: function component() {
        return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, "v+eS"));
      },
      meta: { title: '一企一档', close: false }
    }, {
      path: 'riskInventory',
      name: 'info/riskInventory',
      component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "ig/n"));
      },
      meta: { title: '风险清单', close: false }
    }, {
      path: 'supervisionCheck',
      name: 'info/supervisionCheck',
      redirect: '/info/supervisionCheck/check_manage',
      component: function component() {
        return __webpack_require__.e/* import() */(169).then(__webpack_require__.bind(null, "uAtv"));
      },
      meta: { title: '监督检查', close: false },
      children: [{
        path: 'check_manage',
        name: 'check_manage',
        component: function component() {
          return __webpack_require__.e/* import() */(176).then(__webpack_require__.bind(null, "BgtA"));
        },
        meta: { title: '监督检查管理', close: false }
      }, {
        path: 'check_object',
        name: 'check_object',
        component: function component() {
          return __webpack_require__.e/* import() */(146).then(__webpack_require__.bind(null, "Yh1T"));
        },
        meta: { title: '临时检查对象', close: false }
      }, {
        path: 'check_quest',
        name: 'check_quest',
        component: function component() {
          return __webpack_require__.e/* import() */(145).then(__webpack_require__.bind(null, "JAR5"));
        },
        meta: { title: '检查任务部署', close: false }
      }, {
        path: 'check_task',
        name: 'check_task',
        component: function component() {
          return __webpack_require__.e/* import() */(175).then(__webpack_require__.bind(null, "wptM"));
        },
        meta: { title: '待检查任务', close: false }
      }, {
        path: 'handover_tracking',
        name: 'handover_tracking',
        component: function component() {
          return __webpack_require__.e/* import() */(173).then(__webpack_require__.bind(null, "Tjyw"));
        },
        meta: { title: '隐患移交跟踪', close: false }
      }, {
        path: 'trace_table',
        name: 'trace_table',
        component: function component() {
          return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, "ofMG"));
        },
        meta: { title: '任务隐患跟踪表', close: false }
      }, {
        path: 'statistics',
        name: 'statistics',
        component: function component() {
          return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, "jPRp"));
        },
        meta: { title: '层级隐患数统计', close: false }
      }, {
        path: 'dynamic_manage',
        name: 'dynamic_manage',
        component: function component() {
          return __webpack_require__.e/* import() */(174).then(__webpack_require__.bind(null, "Gsu8"));
        },
        meta: { title: '隐患动态管理', close: false }
      }, {
        path: 'check_deployment',
        name: 'check_deployment',
        component: function component() {
          return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "pOgA"));
        },
        meta: { title: '企业专项检查部署', close: false }
      }, {
        path: 'planned_deployment',
        name: 'planned_deployment',
        component: function component() {
          return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "r8sM"));
        },
        meta: { title: '政府检查计划部署', close: false }
      }, {
        path: 'expert_database',
        name: 'expert_database',
        component: function component() {
          return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "kfeK"));
        },
        meta: { title: '检查专家库管理', close: false }
      }, {
        path: 'industry_field',
        name: 'industry_field',
        component: function component() {
          return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "oL3R"));
        },
        meta: { title: '行业领域检查清单', close: false }
      }, {
        path: 'grid_staff',
        name: 'grid_staff',
        component: function component() {
          return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "kl5A"));
        },
        meta: { title: '网格员检查导则', close: false }
      }, {
        path: 'special_project',
        name: 'special_project',
        component: function component() {
          return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "GBTq"));
        },
        meta: { title: '专项检查清单', close: false }
      }, {
        path: 'hidden_danger',
        name: 'hidden_danger',
        component: function component() {
          return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "T7ZT"));
        },
        meta: { title: '重大隐患检查清单', close: false }
      }, {
        path: 'subject_responsibility',
        name: 'subject_responsibility',
        component: function component() {
          return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "7R26"));
        },
        meta: { title: '主体责任检查清单', close: false }
      }]
    }, {
      path: 'announceAgency',
      name: 'info/announceAgency',
      component: function component() {
        return __webpack_require__.e/* import() */(148).then(__webpack_require__.bind(null, "UM63"));
      },
      meta: { title: '服务机构注册公告', close: false }
    }, {
      path: 'announceService',
      name: 'info/announceService',
      component: function component() {
        return __webpack_require__.e/* import() */(147).then(__webpack_require__.bind(null, "xZVl"));
      },
      meta: { title: '服务质量等级公告', close: false }
    }]
  }, {
    path: '/success', name: 'success', component: __WEBPACK_IMPORTED_MODULE_7__components_frame_Success__["a" /* default */]
  }, {
    path: '/newcxgj',
    name: 'standardize/newcxgj',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "sW6p"));
    },
    meta: { title: '持续改进', close: true, isCompany: true }
  }, {
    path: '*', name: 'error', component: __WEBPACK_IMPORTED_MODULE_5__components_frame_Error__["a" /* default */]
  }])
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yfqv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg.708f8f6.jpg";

/***/ }),

/***/ "Yh4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_qiboMixins__ = __webpack_require__("pBm9");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_qiboMixins__["a" /* dialogMixins */], __WEBPACK_IMPORTED_MODULE_4__mixins_qiboMixins__["d" /* multipleImgMixins */], __WEBPACK_IMPORTED_MODULE_4__mixins_qiboMixins__["b" /* fileMixins */]],
  computed: {},
  data: function data() {
    return {
      images: [],
      ruleForm: {
        module: null, // '模块/单元',
        field_name: null, // '字段名',
        remark: null, // '问题描述',
        image_list: null, // '图片列表',(用json或者逗号分隔都可以，客户端来定)
        file: null, // '文件',
        deadline_time: null // 最后期限,
      },
      rules: {
        // module: [
        //   { required: true, message: '请输入模块/单元', trigger: 'blur' }
        // ],
        field_name: [{ required: true, message: '请输入字段名', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入问题描述', trigger: 'blur' }]
        // image_list: [
        //   { required: true, message: '请上传图片', trigger: 'change' }
        // ],
        // file: [
        //   { required: true, message: '请上传附件', trigger: 'change' }
        // ]
      }
    };
  },
  mounted: function mounted() {},

  methods: {
    submitForm: function submitForm(needCompanyId) {
      var _this = this;

      // 默认需要传companyId,检查清单特判不用，其他的不知道要不要
      this.$refs['form'].validate(function (valid) {
        if (!valid) {
          return;
        }
        var params = _this.handleParams ? _this.handleParams() : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.ruleForm);
        if (_this.dataId) {
          params.id = _this.dataId;
        }
        if (_this.$store.state.companyId && _this.$store.state.companyId !== 'null' && needCompanyId) {
          params.company_id = _this.$store.state.companyId;
        }
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* api */]['addOrUpdateRecheck'], params).then(function (res) {
          if (res.data.code === 0) {
            _this.$message({
              message: params.id ? '修改成功' : '新增成功',
              type: 'success'
            });
            _this.dialogFormVisible = false;
            _this.$emit('refreshTable');
            localStorage.clear('reviewForm');
          } else {
            _this.$message({
              message: params.id ? '\u4FEE\u6539\u5931\u8D25 ' + res.data.msg : '\u65B0\u589E\u5931\u8D25 ' + res.data.msg,
              type: 'warning'
            });
          }
        });
      });
    },
    handleshowForm: function handleshowForm(row) {
      this.images = [];
      var date = new Date();
      date.setTime(date.getTime() + 5 * 24 * 60 * 60 * 1000);
      var s1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      this.ruleForm.deadline_time = s1;
      if (localStorage.getItem('reviewForm')) {
        this.ruleForm = JSON.parse(localStorage.getItem('reviewForm'));
      }
    },
    handleRuleForm: function handleRuleForm(rowData) {
      this.images = [];
      if (rowData.image_list) {
        this.ruleForm.image_list = rowData.image_list.split(',');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.ruleForm.image_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            this.images.push({
              url: item
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.ruleForm.image_list = this.images;
      }
    },
    handleParams: function handleParams() {
      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.ruleForm);
      if (params.image_list && params.image_list.length > 0) {
        params.image_list = params.image_list.map(function (item) {
          return item.url;
        }).join(',');
      }
      return params;
    },
    clear: function clear() {
      for (var key in this.ruleForm) {
        this.ruleForm[key] = null;
      }
      this.images = [];
      localStorage.clear('reviewForm');
    },

    // 暂存
    storage: function storage() {
      localStorage.setItem('reviewForm', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.ruleForm));
    }
  }
});

/***/ }),

/***/ "Ys/a":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAgJJREFUaEPtmT1rVFEQhp9XC0khWArBJl3EH5HCTrQRYiWIRAQLTRMhqCiaIrFSexHBKoLiBzaC/oHkL8TGzipRBEV55cAKYXUz9+Pc3Rs4B7ZYhvl4ZubemT0r9vnRPo+fAjDpCo6sgO0N4HfHASb/BlYlvWziay+AZHicZ1HSw7oO+wSQYj8r6UUdiL4BpNgXJD2uCtFHgBT7LeCRpJ0IpA7AL+Ad8BM4EBluIZ8CjgA3JX2I7NQB2JaUDI/l2Jak8EVSB+ArcFTS97EQVHRSF2BaUgLpzSkAky5F6wrYvgRczrx2HAReSboXJSgHQBr/VyNHDeRvJZ2O9HIA3AFuR44ayJ9IuhjpFQDbpQIj2qS00PAekibwP5PY9t3B9hg9b3XlTyVdiJRyPMQPgGuRowbyN5LORHo5AGaBEx0Msi1Jm50DRA66lreuQNcBRvYLQJShruWtK2B7GpgBfmQM9hDwWdKnyGYOgDXgeuSogXxd0rlILwfACnAjctRA/kzS+UgvB0BZ5soy978M2K66zPW2hU4Br3ddI47aRvsJkKpi+yTwflChbeDY8MVWb3+R/W0r23PAx8H3w5K+7W452/eBpeh110D+XNJ8pFfpTz7b6XYgDazjkr4MASwD6ZP7pDlwJTJaCSAyMkl5AZhk9pPvUoFSgZYZKC3UMoGt1f8Af4JFQOj9cEEAAAAASUVORK5CYII="

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_tab__ = __webpack_require__("Mwe+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_permission__ = __webpack_require__("cCKo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__http__ = __webpack_require__("0zyd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_api__ = __webpack_require__("P9l9");






var _SEARCHFORM, _mutations, _actions;









__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var LOCAL_STORAGE_KEY_SESSION_ID = 'sessionId';
var LOCAL_STORAGE_KEY_PERMISSION_LIST = 'permissionList';
var LOCAL_STORAGE_KEY_COMPANY_ID = 'companyId';
var LOCAL_STORAGE_KEY_CONTROL_ID = 'controlId';
var LOCAL_STORAGE_KEY_ROLE = 'role';
var LOCAL_STORAGE_KEY_RISKLEVEL = 'riskLevel';
var LOCAL_STORAGE_KEY_EDITTIME = 'editTime';
var LOCAL_STORAGE_KEY_SYSURL = 'sysUrl';
var LOCAL_STORAGE_DEPARTMENT_OPTIONS = 'departmentOptions';
var InitUserInfo = {
  roles: []
};
var SEARCHFORM = (_SEARCHFORM = {
  is_fire_safety_focus: null,
  is_safety_insurance: null,
  safety_standard_A: null,
  safety_standard_B: null,
  safety_standard_C: null,
  name: null,
  control_id: null,
  area_id: null,
  risk_level: null,
  check_status: null
}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'area_id', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'town', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'info_status', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'source_type', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'dynamic_risk_level', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'dynamic_info_status', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'department_area_id', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_SEARCHFORM, 'department_type_id', null), _SEARCHFORM);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: {
    cityId: 3505,
    sessionId: localStorage.getItem(LOCAL_STORAGE_KEY_SESSION_ID),
    userInfo: InitUserInfo,
    permissionList: localStorage.getItem(LOCAL_STORAGE_KEY_PERMISSION_LIST),
    companyId: localStorage.getItem(LOCAL_STORAGE_KEY_COMPANY_ID),
    controlId: localStorage.getItem(LOCAL_STORAGE_KEY_CONTROL_ID),
    role: localStorage.getItem(LOCAL_STORAGE_KEY_ROLE),
    riskLevel: localStorage.getItem(LOCAL_STORAGE_KEY_RISKLEVEL),
    editTime: localStorage.getItem(LOCAL_STORAGE_KEY_EDITTIME),
    sysUrl: localStorage.getItem(LOCAL_STORAGE_KEY_SYSURL),
    currentRow: null,
    currentPage: 1,
    departmentOptions: localStorage.getItem(LOCAL_STORAGE_DEPARTMENT_OPTIONS), // 监管部门类型
    searchForm: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, SEARCHFORM),
    AdvancedForm: null, // 高级查询
    advancedSearch: false, // 高级查询是否展开
    checkCompany: '1',
    receivedNum: null
  },
  getters: {
    departmentOptions: function departmentOptions(state) {
      var departmentOptions = state.departmentOptions ? JSON.parse(state.departmentOptions) : [];
      departmentOptions.splice(0, 1);
      return departmentOptions;
    },
    roles: function roles(state) {
      return state.userInfo ? state.userInfo.roles ? state.userInfo.roles : [] : [];
    },
    controlId: function controlId(state) {
      return Number(state.controlId);
    },
    sysUrl: function sysUrl(state) {
      return JSON.parse(state.sysUrl);
    },
    needControlCompliance: function needControlCompliance(state) {
      var id = Number(state.controlId);
      var data = [101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 121, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 201, 202, 206, 207, 208, 211];
      if (data.indexOf(id) != -1) {
        return true;
      }
      return false;
    },

    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    isSuperAdmin: function isSuperAdmin(state, getters) {
      if (getters.userInfo.town_id == 0 && getters.userInfo.department_id == 0) {
        return true;
      } else {
        return false;
      }
    },

    receivedNum: function receivedNum(state) {
      return state.receivedNum;
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["DEPARTMENTOPTIONS"], function (state, data) {
    state.departmentOptions = data;
    localStorage.setItem(LOCAL_STORAGE_DEPARTMENT_OPTIONS, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["CURRENTROW"], function (state, data) {
    state.currentRow = data;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["CURRENTPAGE"], function (state, data) {
    state.currentPage = data;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["SEARCHFORM"], function (state, data) {
    state.searchForm = data;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["ADVANCEFORM"], function (state, data) {
    state.AdvancedForm = data;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["ADVANCEDSEARCH"], function (state, data) {
    state.advancedSearch = data;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["EDITTIME"], function (state, data) {
    state.editTime = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_EDITTIME, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["RISKLEVEL"], function (state, data) {
    state.riskLevel = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_RISKLEVEL, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["ROLE"], function (state, data) {
    state.role = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_ROLE, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["CONTROL_ID"], function (state, data) {
    state.controlId = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_CONTROL_ID, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["COMPANY_ID"], function (state, data) {
    state.companyId = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_COMPANY_ID, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["SESSION_ID"], function (state, data) {
    state.sessionId = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_SESSION_ID, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, 'setUserInfo', function setUserInfo(state, data) {
    state.userInfo = data;
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["LOGOUT"], function (state) {
    state.sessionId = null;
    state.searchForm = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, SEARCHFORM);
    state.userInfo = InitUserInfo;
    localStorage.removeItem(LOCAL_STORAGE_KEY_SESSION_ID);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["PERMISSION_LIST"], function (state, data) {
    state.permissionList = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_PERMISSION_LIST, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["SYSURL"], function (state, data) {
    state.sysUrl = data;
    localStorage.setItem(LOCAL_STORAGE_KEY_SYSURL, data);
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, 'setreceivedNum', function setreceivedNum(state, data) {
    state.receivedNum = data;
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__types__["GETSYSSETTINGS"], function (context) {
    __WEBPACK_IMPORTED_MODULE_10__http__["a" /* default */].post('/apps/setting/getSysSettings').then(function (res) {
      if (res.data.code == 0) {
        context.commit(__WEBPACK_IMPORTED_MODULE_7__types__["SYSURL"], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res.data.data));
      } else {
        console.log(res.data.msg);
      }
    }).catch(function (err) {
      console.log(err);
    });
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_actions, 'getUserInfo', function getUserInfo(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, userInfo, adminType;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit('setUserInfo', null);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_10__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_11__api_api__["a" /* api */].getInfo);

            case 3:
              res = _context.sent;
              userInfo = {};

              if (res.data.code == 0) {
                userInfo = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, res.data.data, { roles: ['ALL_ROUTERS']
                });
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__types__["SESSION_ID"], userInfo.token);
              commit(__WEBPACK_IMPORTED_MODULE_7__types__["ROLE"], userInfo.role);
              commit(__WEBPACK_IMPORTED_MODULE_7__types__["RISKLEVEL"], 0);
              // commit(types.COMPANY_ID, null)
              adminType = 1;

              if (userInfo.department_id == 0 && userInfo.town_id == 0) {
                // 判断是否为超级管理员
                adminType = 0;
              }
              commit(__WEBPACK_IMPORTED_MODULE_7__types__["RESETPAGELIST"], adminType); // 重置标签页
              commit('setUserInfo', userInfo);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_actions, 'getBaseDepartmentTypeList', function getBaseDepartmentTypeList(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_10__http__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_11__api_api__["a" /* api */].getBaseDepartmentTypeList);

            case 2:
              res = _context2.sent;

              if (res.data.code === 0) {
                commit(__WEBPACK_IMPORTED_MODULE_7__types__["DEPARTMENTOPTIONS"], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(res.data.data));
              }

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_actions, 'getReceivedNum', function getReceivedNum(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var receivedNum;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              receivedNum = null;

              __WEBPACK_IMPORTED_MODULE_10__http__["a" /* default */].post('/apps/notice/getReceiveDepartmentNoticeList').then(function (res) {
                if (res.data.code == 0) {
                  receivedNum = res.data.page_info.not_read_num;
                  commit('setreceivedNum', receivedNum);
                }
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }), _actions),
  modules: {
    tab: __WEBPACK_IMPORTED_MODULE_8__modules_tab__["a" /* default */],
    permission: __WEBPACK_IMPORTED_MODULE_9__modules_permission__["a" /* default */]
  }
}));

/***/ }),

/***/ "Z8Y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({backgroundImage:'url('+_vm.bgImage+')'})},[_c('div',{staticClass:"tell"},[_c('div',[_vm._v("温馨提示 :")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left"}},[_c('div',[_vm._v("1.为了获得最佳用户体验，建议使用 Google Chrome 浏览器"),_c('span',{staticStyle:{"cursor":"pointer","color":"#ebda15"},on:{"click":_vm.uploadGoogle}},[_vm._v("(点击下载)")]),_vm._v(";")]),_vm._v(" "),_c('div',[_vm._v("2.使用360 浏览器、QQ 浏览器等其他浏览器的用户建议调整到极速模式。")])])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"login",style:({'background-color': _vm.port == 9014 ? 'rgba(255, 255, 255, .7)' : 'rgba(255, 255, 255, .5)'})},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"tab1",on:{"click":_vm.changePort}},[_vm._v("企业端登录")]),_vm._v(" "),_c('div',{staticClass:"tab2"},[_vm._v("监管端登录")])]),_vm._v(" "),_c('el-form',{ref:"ruleForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.ruleForm,"rules":_vm.rules}},[_c('div',{staticClass:"box"},[_c('el-form-item',{attrs:{"prop":"userName"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.userName),expression:"ruleForm.userName"}],staticClass:"loginInput",attrs:{"size":"small","placeholder":"用户名"},domProps:{"value":(_vm.ruleForm.userName)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitForm('ruleForm')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ruleForm, "userName", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-user-solid"})])],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('el-form-item',{attrs:{"prop":"password"}},[_c('span',{staticClass:"show-pwd",on:{"click":_vm.showPwd}},[(_vm.passwordType=='password')?_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("Q3mI")}}):_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":__webpack_require__("xOqt")}})]),_vm._v(" "),((_vm.passwordType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.password),expression:"ruleForm.password"}],ref:"password",staticClass:"loginInput",attrs:{"size":"small","placeholder":"密码","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.ruleForm.password)?_vm._i(_vm.ruleForm.password,null)>-1:(_vm.ruleForm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitForm('ruleForm')},"change":function($event){var $$a=_vm.ruleForm.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.ruleForm, "password", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.ruleForm, "password", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.ruleForm, "password", $$c)}}}}):((_vm.passwordType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.password),expression:"ruleForm.password"}],ref:"password",staticClass:"loginInput",attrs:{"size":"small","placeholder":"密码","type":"radio"},domProps:{"checked":_vm._q(_vm.ruleForm.password,null)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitForm('ruleForm')},"change":function($event){return _vm.$set(_vm.ruleForm, "password", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.password),expression:"ruleForm.password"}],ref:"password",staticClass:"loginInput",attrs:{"size":"small","placeholder":"密码","type":_vm.passwordType},domProps:{"value":(_vm.ruleForm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitForm('ruleForm')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ruleForm, "password", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-unlock"})])],1),_vm._v(" "),_c('div',{staticClass:"box",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('el-form-item',{staticStyle:{"width":"68%"},attrs:{"prop":"ca_code"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.ca_code),expression:"ruleForm.ca_code"}],staticClass:"loginInput",staticStyle:{"padding":"3px 10px"},attrs:{"size":"small","type":"ca_code","placeholder":"验证码"},domProps:{"value":(_vm.ruleForm.ca_code)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitForm('ruleForm')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ruleForm, "ca_code", $event.target.value)}}})]),_vm._v(" "),_c('img',{staticStyle:{"width":"30%","height":"33px"},attrs:{"src":("/apps/common/captcha?ca_key=" + (this.ruleForm.ca_key)),"alt":""},on:{"click":_vm.getId}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginError!=null),expression:"loginError!=null"}],staticClass:"login-error"},[_vm._v(_vm._s(_vm.loginError))]),_vm._v(" "),_c('div',{staticClass:"login-btn"},[_c('el-button',{staticClass:"loginBtn",staticStyle:{"border-color":"#5190FB","background-color":"#5190FB","width":"310px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.submitForm('ruleForm')}}},[_vm._v("登录\n                ")])],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZLWG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectCheckListDialog_vue__ = __webpack_require__("rvCh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa7d874_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectCheckListDialog_vue__ = __webpack_require__("C8CO");
function injectStyle (ssrContext) {
  __webpack_require__("egS5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fa7d874"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectCheckListDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fa7d874_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectCheckListDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zji8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenAdapter_vue__ = __webpack_require__("G0Jh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e88825_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenAdapter_vue__ = __webpack_require__("esmR");
function injectStyle (ssrContext) {
  __webpack_require__("EpLh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenAdapter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e88825_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenAdapter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZoXT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"page-container"},[_vm._v("此页面不存在，点击"),_c('router-link',{attrs:{"to":"/home/index"}},[_vm._v("这里")]),_vm._v("返回主页")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZvsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("J8Un");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8d2a8f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__ = __webpack_require__("2a9c");
function injectStyle (ssrContext) {
  __webpack_require__("iu0h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8d2a8f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8d2a8f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aG9v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b14p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bRx8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    goon: function goon() {
      // let controlId = this.$store.state.controlId
      // if (controlId === 101 || controlId === 102 || controlId === 103) {
      //   this.$router.push('/company/companyinfo')
      // } else {
      //   this.$router.push('/company/industry')
      // }
      this.$router.push('/company/companyinfo');
    },
    back: function back() {
      this.$router.push('/project/enterprise');
    }
  }
});

/***/ }),

/***/ "c9nE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cBLO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 16,
  path: '/setting',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/setting/setting/notice',
  name: 'setting',
  isHead: true,
  meta: {
    title: '系统配置',
    icon: 'el-icon-setting'
  },
  children: [{
    path: 'setting',
    component: function component() {
      return __webpack_require__.e/* import() */(164).then(__webpack_require__.bind(null, "VlR1"));
    },
    name: 'Setting',
    meta: { title: '系统配置', close: false },
    children: [
    // 通知公告
    {
      path: 'notice',
      name: 'notice',
      component: function component() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "6QFG"));
      },
      meta: { title: '新建通知', next: '/setting/setting/sent', close: true }
    }, {
      path: 'sent',
      name: 'sent',
      component: function component() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "qAXp"));
      },
      meta: { title: '已发通知', next: '/setting/setting/received', close: true }
    }, {
      path: 'received',
      name: 'received',
      component: function component() {
        return __webpack_require__.e/* import() */(154).then(__webpack_require__.bind(null, "uVAG"));
      },
      meta: { title: '已收通知', next: '/setting/setting/departmentManagement', close: true }
    }, {
      path: 'departmentManagement',
      name: 'departmentManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "WVu7"));
      },
      meta: { title: '部门账号配置', next: '/setting/setting/townManagement', close: true }
    }, {
      path: 'townManagement',
      name: 'townManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "GUQg"));
      },
      meta: { title: '乡镇账号配置', next: '/setting/setting/villageManagement', close: true }
    }, {
      path: 'villageManagement',
      name: 'villageManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "siX7"));
      },
      meta: { title: '村账号配置', next: '/setting/setting/departmentTypeManage', close: true }
    }, {
      path: 'areaManagement',
      name: 'areaManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "hoH2"));
      },
      meta: { title: '区域信息配置', next: '/setting/setting/AccountManagement', close: true }
    }, {
      path: 'AccountManagement',
      name: 'AccountManagement',
      component: function component() {
        return __webpack_require__.e/* import() */(8/* duplicate */).then(__webpack_require__.bind(null, "V2sR"));
      },
      meta: { title: '管理员账号配置', next: '/setting/setting/departmentManagement', close: true }
    }, {
      path: 'departmentTypeManage',
      name: 'departmentTypeManage',
      component: function component() {
        return __webpack_require__.e/* import() */(160).then(__webpack_require__.bind(null, "KKWU"));
      },
      meta: { title: '部门类型管理', next: '/setting/setting/departmentManage', close: true }
    }, {
      path: 'departmentManage',
      name: 'departmentManage',
      component: function component() {
        return __webpack_require__.e/* import() */(161).then(__webpack_require__.bind(null, "z+DA"));
      },
      meta: { title: '部门管理', next: '/setting/setting/permissionManage', close: true }
    }, {
      path: 'permissionManage',
      name: 'permissionManage',
      component: function component() {
        return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, "DRVi"));
      },
      meta: { title: '权限配置', next: '/setting/setting/roleManage', close: true }
    }, {
      path: 'roleManage',
      name: 'roleManage',
      component: function component() {
        return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, "MVh/"));
      },
      meta: { title: '角色配置', next: '/setting/setting/operationParameter', close: true }
    }, {
      path: 'operationParameter',
      name: 'operationParameter',
      component: function component() {
        return __webpack_require__.e/* import() */(162).then(__webpack_require__.bind(null, "w/5F"));
      },
      meta: { title: '运行参数配置', next: '/setting/setting/operationLog', close: true }
    }, {
      path: 'operationLog',
      name: 'operationLog',
      component: function component() {
        return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "StEx"));
      },
      meta: { title: '操作日志', next: '/setting/setting/entryLog', close: true }
    }, {
      path: 'entryLog',
      name: 'entryLog',
      component: function component() {
        return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "8iMf"));
      },
      meta: { title: '登录日志', next: '/setting/setting/administrativeConfiguration', close: true }
    }, {
      path: 'administrativeConfiguration',
      name: 'administrativeConfiguration',
      component: function component() {
        return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, "0rzb"));
      },
      meta: { title: '行政区域配置（机构端）', close: true }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "cCKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");





var permissions = ['/dataV', '/educationalTraining', '/hiddenCheck', '/home', '/riskManagement', '/riskWork', '/setting', '/emergencyManagement'];

function filterPermissionsRouters(routes, roles) {
  var res = [];
  // routes.forEach((route) => {
  //   const children = [];
  //   route.children?.forEach((childRouter) => {
  //     const roleCode = childRouter.meta?.roleCode || childRouter.name;
  //     if (roles.indexOf(roleCode) !== -1) {
  //       children.push(childRouter);
  //     }
  //   });
  //   if (children.length > 0) {
  //     route.children = children;
  //     res.push(route);
  //   }
  // });
  return res;
}

var state = {
  whiteListRouters: [// 白名单
  '/login', '/info/hiddenList', '/info/unitMulti', '/info/hiddenPage', '/info/admin', '/info/riskCheck', '/info/riskList', '/info/base', '/info/hidden', '/info/risk', '/info/echart', '/info/unit', '/info/emergency', '/info/accident', '/info/hiddenInfo', '/info/education', '/info/5SManage', '/info/performanceManage', '/info/hidenCheck', '/info/majiorHidden', '/info/securityCheck', '/info/managementPage', '/info/riskInventory', // 风险管控-风险清单
  '/info/supervisionCheck', // 监督检查
  '/info/supervisionCheck/check_manage', '/info/supervisionCheck/check_object', '/info/supervisionCheck/check_quest', '/info/supervisionCheck/check_task', '/info/supervisionCheck/handover_tracking', '/info/supervisionCheck/trace_table', '/info/supervisionCheck/statistics', '/info/supervisionCheck/dynamic_manage', '/info/supervisionCheck/check_deployment', '/info/supervisionCheck/planned_deployment', '/info/supervisionCheck/expert_database', '/info/supervisionCheck/industry_field', '/info/supervisionCheck/grid_staff', '/info/supervisionCheck/special_project', '/info/supervisionCheck/hidden_danger', '/info/supervisionCheck/subject_responsibility', '/riskManagement/index', '/hiddenCheck/hidenList/hideenMaintain', '/info/announceAgency', '/info/announceService'],
  routers: []
};

var mutations = {
  setRouters: function setRouters(state, routers) {
    state.routers = routers;
  }
};

var getters = {
  routers: function routers(state) {
    return state.routers;
  },
  whiteListRouters: function whiteListRouters(state) {
    return state.whiteListRouters;
  }
};

var actions = {
  initRoutes: function initRoutes(_ref, userInfo) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var newRouter, i;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newRouter = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].options.routes));
              i = newRouter.length;

              while (i--) {
                if (userInfo.auth_list && !userInfo.auth_list.includes(newRouter[i].path)) {
                  newRouter.splice(i, 1);
                }
              }
              commit('setRouters', [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newRouter)));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  restore: function restore(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              resetRouter();
              commit('setRouters', []);

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ "cNfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 3,
  path: '/standardization',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/standardization/standardization/index',
  name: 'standardization',
  isHead: true,
  meta: {
    title: '标准化建设',
    icon: 'el-icon-s-marketing'
  },
  children: [{
    path: 'standardization',
    component: function component() {
      return __webpack_require__.e/* import() */(165).then(__webpack_require__.bind(null, "T9dD"));
    },
    name: 'standardization',
    meta: { title: '标准化建设', close: false },
    children: [{
      path: 'index',
      component: function component() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "O929"));
      },
      name: 'Standardization',
      meta: { title: '企业标准化运行管理', next: '/standardization/standardization/selfStandardization', close: false }
    }, {
      path: 'selfStandardization',
      component: function component() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "C4jr"));
      },
      name: 'selfStandardization',
      meta: { title: '企业标准化自评管理', next: '/standardization/standardization/selfSetting', close: false }
    }, {
      path: 'selfSetting',
      name: 'selfSetting',
      component: function component() {
        return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, "vc+P"));
      },
      meta: { title: '评定细则维护', close: false }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "cWbZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeadBar_vue__ = __webpack_require__("5u8R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228ffc20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeadBar_vue__ = __webpack_require__("ryYJ");
function injectStyle (ssrContext) {
  __webpack_require__("4ivE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-228ffc20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeadBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228ffc20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeadBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d6JS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"auto"}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"unique-opened":"","collapse":_vm.iscollapse,"default-active":_vm.path,"collapse-transition":false,"router":""},on:{"select":_vm.select}},[_c('el-menu-item',{attrs:{"index":"/company/index"}},[_c('i',{staticClass:"el-icon-s-home"}),_vm._v(" "),_c('span',[_vm._v("基础信息")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/unit/index"}},[_c('i',{staticClass:"el-icon-odometer"}),_vm._v(" "),_c('span',[_vm._v("风险单元")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dLd/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "egS5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "esmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-adapter"},[_c('div',{staticClass:"content-wrap",style:(_vm.style)},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f1dN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportUserFDlg__ = __webpack_require__("TJ3i");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    href: String,
    url: String,
    download: String,
    unitId: Number,
    btntitle: String,
    params: Object,
    prompt: String
  },
  components: {
    ImportUserFDlg: __WEBPACK_IMPORTED_MODULE_0__ImportUserFDlg__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    // 导入
    showImportUserDlg: function showImportUserDlg() {
      this.$refs['importUserDlg'].showImportUserDlg();
    },
    search: function search() {
      this.$emit('refreshTable');
    }
  }
});

/***/ }),

/***/ "fJrK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_control__ = __webpack_require__("//7k");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    iscollapse: Boolean
  },
  data: function data() {
    return {
      userInfo: {},
      permissionMap: {},
      url: false
    };
  },

  computed: {
    divisionPrinciple: function divisionPrinciple() {
      if (this.$store.state.controlId) {
        var key = this.$store.state.controlId;
        return __WEBPACK_IMPORTED_MODULE_0__router_control__["d" /* principleMap */][key];
      }
    },
    path: function path() {
      if (this.url) {
        this.url = false;
        return '/company/companyinfo';
      }
      return this.$route.path;
    },
    query: function query() {
      return this.permissionMap['QueryVisited'] && this.permissionMap['NoQueryVisited'] && this.permissionMap['QuestionableRecords'] && this.permissionMap['RevenueAlert'];
    },
    riskLevel: function riskLevel() {
      var controlId = this.$store.state.controlId;
      if (controlId === 101 || controlId === 102 || controlId === 103) {
        return '/company/companyinfo';
      } else {
        return '/company/industry';
      }
    }
  },
  mounted: function mounted() {
    var userInfo = this.$store.getters.userInfo;
    this.userInfo = userInfo;
    // 权限表
    var permissionMap = {};
    var permissionList = JSON.parse(this.$store.state.permissionList);
    for (var i in permissionList) {
      permissionMap[permissionList[i]] = true;
    }
    this.permissionMap = permissionMap;
  },

  methods: {
    select: function select(index, indexPath) {
      if (this.$route.path === '/company/companyinfo') {
        this.url = true;
      }
    },
    click: function click() {}
  }
});

/***/ }),

/***/ "fLKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"append-to-body":"","close-on-click-modal":"","title":_vm.title,"visible":_vm.dialogVisible,"width":"900px"},on:{"close":_vm.close,"update:visible":function($event){_vm.dialogVisible=$event}}},[(_vm.urlType == '-1')?_c('span',[_vm._v("错误的url类型")]):(_vm.urlType == 'image')?_c('img',{staticStyle:{"width":"500px","margin":"0 auto","display":"block"},attrs:{"src":_vm.url,"alt":""}}):(_vm.urlType == 'video')?_c('video',{staticStyle:{"width":"500px"},attrs:{"controls":"","src":_vm.url}}):_c('iframe',{attrs:{"src":(_vm.platformUrl + "/apps/res/onlinePreview?url=" + _vm.url),"width":"100%","height":"600px","frameborder":"0"}},[_vm._v("这是嵌入 "),_c('a',{attrs:{"target":"_blank","href":"http://office.com"}},[_vm._v("Microsoft Office")]),_vm._v(" 文档，由 "),_c('a',{attrs:{"target":"_blank","href":"http://office.com/webapps"}},[_vm._v("Office Online")]),_vm._v(" 支持。")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("关 闭")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.downloadFile}},[_vm._v("批量下载")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g3qS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gaV6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h/+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_importantBtn_vue__ = __webpack_require__("f1dN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afa9706_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_importantBtn_vue__ = __webpack_require__("xe4V");
function injectStyle (ssrContext) {
  __webpack_require__("YH7k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6afa9706"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_importantBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afa9706_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_importantBtn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iNGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showFile_vue__ = __webpack_require__("AaAB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc733dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showFile_vue__ = __webpack_require__("fLKJ");
function injectStyle (ssrContext) {
  __webpack_require__("okWP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fc733dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc733dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iu0h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j9Kv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 7,
  path: '/educationalTraining',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/educationalTraining/education/situation',
  name: 'educationalTraining',
  isHead: true,
  meta: {
    title: '教育培训',
    img: __webpack_require__("QeB7")
  },
  children: [{
    path: 'education',
    name: 'education',
    component: function component() {
      return __webpack_require__.e/* import() */(185).then(__webpack_require__.bind(null, "3AtP"));
    },
    meta: { title: '教育培训', close: false },
    children: [{
      path: 'situation',
      name: 'situation',
      component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "Pl3q"));
      },
      meta: { title: '企业培训情况', next: '/educationalTraining/education/manage', close: false }
    }, {
      path: 'manage',
      name: 'manage',
      component: function component() {
        return __webpack_require__.e/* import() */(184).then(__webpack_require__.bind(null, "3a37"));
      },
      meta: { title: '企业人员持证管理', next: '/educationalTraining/education/study', close: false }
    }, {
      path: 'study',
      name: 'study',
      component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "U65Z"));
      },
      meta: { title: '在线学习', next: '/educationalTraining/education/publicize', close: false }
    }, {
      path: 'publicize',
      name: 'publicize',
      component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "LmVE"));
      },
      meta: { title: '安全宣传', close: false }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "jOSF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgnN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__("YtJ0");

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el, bindling) {
    // bindling.value为指令的绑定值
    var perVal = bindling.value;
    if (bindling.value) {
      var pers = __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].getters.userInfo.auth_list;
      // 这个权限信息(即pers)应该是不同用户登录时从后台拿到的对应的信息
      var hasPer = pers.some(function (item) {
        return perVal.includes(item);
      });
      // 没有权限就先隐藏此元素吧
      if (!hasPer) {
        el.style.display = 'none';
      }
    }
  }
});

/***/ }),

/***/ "jlaG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"修改密码","visible":_vm.dialogFormVisible,"width":"40%"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event},"open":_vm.handleDialogOpen}},[_c('el-form',{ref:"form",attrs:{"model":_vm.ruleForm,"rules":_vm.rules,"label-width":"100px","status-icon":""}},[_c('el-form-item',{attrs:{"label":"旧密码","prop":"oldPwd"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.ruleForm.oldPwd),callback:function ($$v) {_vm.$set(_vm.ruleForm, "oldPwd", $$v)},expression:"ruleForm.oldPwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"新密码","prop":"newPwd"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.ruleForm.newPwd),callback:function ($$v) {_vm.$set(_vm.ruleForm, "newPwd", $$v)},expression:"ruleForm.newPwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"确认新密码","prop":"comfirmNewPwd"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off"},model:{value:(_vm.ruleForm.comfirmNewPwd),callback:function ($$v) {_vm.$set(_vm.ruleForm, "comfirmNewPwd", $$v)},expression:"ruleForm.comfirmNewPwd"}})],1),_vm._v(" "),_c('div',{staticStyle:{"color":"red","font-size":"12px","margin-left":"5px"}},[_vm._v("*密码长度采用8位以上，采用数字、大、小写字母、特殊符号任意三种字符组合方式*")])],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.hideForm}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":_vm.submitForm}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jqZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "juBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_blueimp_md5__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        var reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('密码格式错误，请重新输入！'));
        }
      }
    };
    // 验证密码是不是两次输入相同
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value !== _this.ruleForm.newPwd) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      ruleForm: {
        oldPwd: null,
        newPwd: null,
        comfirmNewPwd: null
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' }],
        comfirmNewPwd: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }, { validator: validatePass2, trigger: 'blur' }]
      }
    };
  },

  methods: {
    // 显示修改密码表单对话框
    showForm: function showForm() {
      var _this2 = this;

      this.dialogFormVisible = true;
      this.$nextTick(function () {
        if (_this2.$refs['form']) {
          // 清楚数据校验信息
          _this2.$refs['form'].clearValidate();
        }
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;

      this.$refs['form'].validate(function (valid) {
        if (!valid) {
          return;
        }
        // TODO:向后端请求各种，上传表单
        _this3.$http.post('/apps/admin/modifyPassword', { 'password': __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default()(_this3.ruleForm.oldPwd), 'new_password': __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default()(_this3.ruleForm.newPwd) }).then(function (response) {
          if (response.data.code === 0) {
            _this3.$message({
              type: 'success',
              message: '密码修改成功'
            });
            // 关闭表单对话框
            _this3.dialogFormVisible = false;
          } else {
            _this3.$message({
              message: response.data.msg,
              type: 'warning'
            });
          }
        });
      });
    },

    // 隐藏对话框
    hideForm: function hideForm() {
      this.dialogFormVisible = false;
    },

    // 打开对话框的事件响应
    handleDialogOpen: function handleDialogOpen() {
      if (this.$refs['form']) {
        // 重置表单
        this.$refs['form'].resetFields();
      }
    }
  }
});

/***/ }),

/***/ "k0sn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table1_vue__ = __webpack_require__("Mwfn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e91197a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table1_vue__ = __webpack_require__("GBvD");
function injectStyle (ssrContext) {
  __webpack_require__("g3qS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e91197a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e91197a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k2Yx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordForm_vue__ = __webpack_require__("juBj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5900e299_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordForm_vue__ = __webpack_require__("jlaG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5900e299_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kSnM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);




var _this = this;






var whiteListRouters = __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters['permission/whiteListRouters'];

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var sid, roles, hasPer;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sid = __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].state['sessionId'];

            if (!(sid && whiteListRouters.indexOf(to.path) == -1)) {
              _context.next = 26;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 6;
              break;
            }

            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_5__vuex_types__["LOGOUT"]);
              // store.dispatch('permission/restore');
            });
            next();
            return _context.abrupt('return');

          case 6:
            roles = __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters['roles'];

            if (!(roles && roles.length > 0)) {
              _context.next = 12;
              break;
            }

            hasPer = __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters.userInfo.auth_list.some(function (item) {
              return to.path.indexOf(item) > -1;
            });

            if (__WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters.userInfo.auth_list.includes(to.path) || to.meta.isCompany) {
              next();
            } else if (to.meta.next) {
              next(to.meta.next);
            } else if (whiteListRouters.indexOf(to.path) !== -1) {
              next();
            } else if (hasPer) {
              next();
            } else {
              __WEBPACK_IMPORTED_MODULE_6_element_ui__["Message"].error({
                message: '请联系管理员分配权限',
                showClose: true
              });
              next('/login');
            }
            _context.next = 24;
            break;

          case 12:
            _context.prev = 12;
            _context.next = 15;
            return __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('getUserInfo');

          case 15:
            _context.next = 17;
            return __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('permission/initRoutes', __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters['userInfo']);

          case 17:
            next(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, to));
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context['catch'](12);

            __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_5__vuex_types__["LOGOUT"]);
            next('/login');

          case 24:
            _context.next = 32;
            break;

          case 26:
            if (!(sid && sid != 'undefined')) {
              _context.next = 31;
              break;
            }

            _context.next = 29;
            return __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('getUserInfo');

          case 29:
            _context.next = 31;
            return __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('permission/initRoutes', __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].getters['userInfo']);

          case 31:
            /* white list router */
            if (whiteListRouters.indexOf(to.path) !== -1) {
              next();
            } else {
              next('/login');
            }

          case 32:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[12, 20]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].afterEach(function () {});

/***/ }),

/***/ "kvbG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyiS":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./analysis.js": "swh5",
	"./dataV.js": "mem4",
	"./educationalTraining.js": "j9Kv",
	"./emergencyManagement.js": "vazN",
	"./enterpriseManagement.js": "DOow",
	"./examine.js": "7zo9",
	"./expert.js": "XLer",
	"./hiddenCheck.js": "+1yJ",
	"./home.js": "W27U",
	"./insurance.js": "09T9",
	"./intermediary.js": "tYbs",
	"./nineSmallPlace.js": "xGIh",
	"./riskManagement.js": "PNXc",
	"./riskWork.js": "WYls",
	"./setting.js": "cBLO",
	"./standardization.js": "cNfL",
	"./supervisionCheck.js": "LBnT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kyiS";

/***/ }),

/***/ "lgZ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "llpM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoForm_vue__ = __webpack_require__("Smyh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39efda35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoForm_vue__ = __webpack_require__("+5qe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39efda35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mEhX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABENJREFUaEPtmHvIn2MYxz9fhpWcsq2wZUxsRDbzNrK2Mcq5kJllQ3PIMYc/NmzlMCaHEDmsZQ4hJEWiqMl5yChsZFrtLSn/DKHX+ur6df/0uLvf3969fs/2rN77n7f3ue/neb6f+/7+rut6LrGdD23n+hkC2NYn2PgTsL0XsD9wKDATOBH4QdL02LzGAdg+DDgcOACYARwL7Jqd9EZJezQOwPaTwIUDsOXrkk5vIsCpwGsDcMblkh5vHEAIsn0Q8DwwucNJTJL0RSMBEsRdwIIOACMk/dJIANvXAg90EL9a0sT2fKOikO1FwG2b+REvlbSwcQC27wBuLoiP6+cCB6e5iyStaBSA7XuBGwriL5W0zHY45SdgFNAj6dPGANi+HrivIH6RpNj9iEzDU1KbBiyU5EYA2L4VWFwQf5WkR5L4WcCjwN5V4dscwPadsZv92SaJPxt4uRUupWLA6WoUsh01yyhJP3aKJLYfBK4prJkt6YUk/hzgpbRmPTBO0qb8nq4B2N4FWAOMBaZLercEYfsh4OrC3MWSohYKz88Bnq2s6Y2KtDYA27sB7wNHVF46Q9LKqtAB2uZM4NUMsD6AFCFWA4cUdnWmpHfSri4BbiqsmS9peVpzMvBGYU09AOlj4wNgQgfPnwKMB+4vrJkj6bn2ddv3ADduFQDbuwOfA1E9DmbMk/R0ZrEo4KKQy0d3TyB5/pPCzkeGjB/yBZshmivpmWSbs4ANklbZrh/A9p5AiG/XJm2tkeoPlPSH7ahV5vUDURV/CfAEcIykj2sHsB21SHg+t813wPGS4qhbw/YyYH4GMUvSi2l+NtD2/xhJG2oFsD0CiK+g0ZmotanA2mj7NGCipNsLEOdLii+tgLsSeLjynEhS62oDsB2iVwH7ZOK/AqYk20QO+DLNL65ARI3/taRXkvjSB0t9AGnnQ9i+mfhI7xNCfBJ2C9Da+TQWSLo7izLRcWhl22zUA2B7v+T5aCxVR3h+qqSf43eR/obfw/fVsURSgIVtTgDeLoiPS90HsD0yWSK3TXh+sqTfbJ8BLJc00naUva1CLBvrJI2zPRd4aqsA2I4dfw8Yk70wrHRcEj8pJbJWqWu7GlX+c1uaPwl4q3aAJP4zIKJOdYT4oyX12Z4KRI2zE7Be0tgOAJskDbPdX53TXQvZ7gOGZeK/TeHxL9s9wIfAjmlNr6TRTQKIWH1eBeB74ChJv9qOzvCbwA6V+WYBpIjxGHAZ8E1K85GkpgAfFTzcPIAEEY3WlZJ+T/9HjG+FxGw0EyBX2aH9sd0AXNfPR8kQQC2ZuGChaEBFIyoffZJ2tl0qJVprUyL7t8dTeMZ4SWs79Ef/Bob/r65EKgWqJXBbxxpJPbYj00atXw2xsSZKiSNTFIsP9jzH/JlyTK/tK4ClBcBoGkxrVGeun5Jiiy93rbG1xW/u0g1DAF3ayEE/ZugEBr11XbrxH/j4cE8ypdZeAAAAAElFTkSuQmCC"

/***/ }),

/***/ "mcCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"auto"}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"unique-opened":"","collapse":_vm.iscollapse,"default-active":_vm.$route.path,"collapse-transition":false,"router":""}},[_c('el-menu-item',{attrs:{"index":"/enterpriseManagement/index"}},[_c('i',{staticClass:"el-icon-office-building"}),_vm._v(" "),_c('span',[_vm._v("企业信息查询")])]),_vm._v(" "),(_vm.showAdmin)?_c('el-menu-item',{attrs:{"index":"/departmentManagement/index"}},[_c('i',{staticClass:"el-icon-copy-document"}),_vm._v(" "),_c('span',[_vm._v("部门账号配置")])]):_vm._e(),_vm._v(" "),(_vm.showAdmin)?_c('el-menu-item',{attrs:{"index":"/townManagement/index"}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" "),_c('span',[_vm._v("乡镇账号配置")])]):_vm._e(),_vm._v(" "),(_vm.showAdmin)?_c('el-submenu',{attrs:{"index":"1"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-setting"}),_vm._v(" "),_c('span',[_vm._v("系统管理配置")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/areaManagement/index"}},[_c('i',{staticClass:"el-icon-s-grid"}),_vm._v(" "),_c('span',[_vm._v("区域管理")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"AccountManagement"}},[_c('i',{staticClass:"el-icon-s-grid"}),_vm._v(" "),_c('span',[_vm._v("账号管理")])])],2):_vm._e(),_vm._v(" "),(_vm.showDepartment)?[_c('el-menu-item',{attrs:{"disabled":_vm.$store.getters.userInfo.id != 10773,"index":"/department/departmentBase"}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" "),_c('span',[_vm._v("部门信息调研")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"disabled":_vm.$store.getters.userInfo.id != 10773,"index":"/department/specialDepartment"}},[_c('i',{staticClass:"el-icon-pie-chart"}),_vm._v(" "),_c('span',[_vm._v("特定信息调研")])])]:_vm._e(),_vm._v(" "),(_vm.showTown)?_c('el-menu-item',{attrs:{"disabled":"","index":"/town/index"}},[_c('i',{staticClass:"el-icon-collection"}),_vm._v(" "),_c('span',[_vm._v("相关乡镇信息")])]):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "meMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SESSION_ID", function() { return SESSION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_INFO", function() { return USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESETPAGELIST", function() { return RESETPAGELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GETPAGELIST", function() { return GETPAGELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOVETAB", function() { return REMOVETAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIXTAB", function() { return FIXTAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERMISSION_LIST", function() { return PERMISSION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPANY_ID", function() { return COMPANY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROL_ID", function() { return CONTROL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGEINFO", function() { return CHANGEINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGEDELETE", function() { return CHANGEDELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGECLEAR", function() { return CHANGECLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADDSTAFF", function() { return ADDSTAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETESTAFF", function() { return DELETESTAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROLE", function() { return ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RISKLEVEL", function() { return RISKLEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITTIME", function() { return EDITTIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYSURL", function() { return SYSURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GETSYSSETTINGS", function() { return GETSYSSETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CURRENTROW", function() { return CURRENTROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CURRENTPAGE", function() { return CURRENTPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCHFORM", function() { return SEARCHFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADVANCEFORM", function() { return ADVANCEFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADVANCEDSEARCH", function() { return ADVANCEDSEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STEPSACTIVE", function() { return STEPSACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEPARTMENTOPTIONS", function() { return DEPARTMENTOPTIONS; });
// 设置sessionId
var SESSION_ID = 'sessionId';
// 登出，清除用户权限数据
var LOGOUT = 'logout';
// 设置用户信息
var USER_INFO = 'userInfo';
// 重置标签页状态
var RESETPAGELIST = 'resetPageList';
// 设置标签页状态
var GETPAGELIST = 'getPagelist';
//
var REMOVETAB = 'removetab';
// 设置固定标签页
var FIXTAB = 'fixtab';
// 设置权限列表
var PERMISSION_LIST = 'permissionList';
// 企业id
var COMPANY_ID = 'companyid';
// 管控id
var CONTROL_ID = 'controlid';
// 变更管理
var CHANGEINFO = 'changeinfo';
// 变更管理删除
var CHANGEDELETE = 'changedelete';
// 变更管理清空
var CHANGECLEAR = 'changeclear';
// 添加负责人
var ADDSTAFF = 'addstaff';
// 删除负责人
var DELETESTAFF = 'deletestaff';
// 当前属于哪个端
var ROLE = 'role';
var RISKLEVEL = 'riskLevel';
// 上次填报时间
var EDITTIME = 'editTime';
// 跳转时需要的动态url
var SYSURL = 'sysUrl';
var GETSYSSETTINGS = 'getSysSettings';
var CURRENTROW = 'currentRow';
var CURRENTPAGE = 'currentPage';
// 跳转时保存所有的筛选状态
var SEARCHFORM = 'searchForm';
var ADVANCEFORM = 'AdvancedForm';
var ADVANCEDSEARCH = 'advancedSearch';
// 填报进度
var STEPSACTIVE = 'stepsActive';
// 行业监管部门
var DEPARTMENTOPTIONS = 'departmentOptions';

/***/ }),

/***/ "mem4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 15,
  path: '/dataV',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/dataV/index',
  name: 'dataV',
  isHead: true,
  meta: {
    title: '数据大屏',
    icon: 'el-icon-s-platform'
  }
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "nCqF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 300
    },
    lineWidth: {
      type: Number,
      default: 4
    },
    lineColor: {
      type: String,
      default: '#000000'
    },
    bgColor: {
      type: String,
      default: ''
    },
    isCrop: {
      type: Boolean,
      default: false
    },
    isClearBgColor: {
      type: Boolean,
      default: true
    },
    format: {
      type: String,
      default: 'image/png'
    },
    quality: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      hasDrew: false,
      resultImg: '',
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      sratio: 1
    };
  },

  computed: {
    ratio: function ratio() {
      return this.height / this.width;
    },
    stageInfo: function stageInfo() {
      return this.$refs.canvas.getBoundingClientRect();
    },
    myBg: function myBg() {
      return this.bgColor ? this.bgColor : 'rgba(255, 255, 255, 0)';
    }
  },
  watch: {
    'myBg': function myBg(newVal) {
      this.$refs.canvas.style.background = newVal;
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted: function mounted() {
    var _this = this;

    var canvas = this.$refs.canvas;
    canvas.height = this.height;
    canvas.width = this.width;
    canvas.style.background = this.myBg;
    this.$_resizeHandler();
    // 在画板以外松开鼠标后冻结画笔
    document.onmouseup = function () {
      _this.isDrawing = false;
    };
  },

  methods: {
    $_resizeHandler: function $_resizeHandler() {
      var canvas = this.$refs.canvas;
      canvas.style.width = this.width + "px";
      var realw = parseFloat(window.getComputedStyle(canvas).width);
      canvas.style.height = this.ratio * realw + "px";
      this.canvasTxt = canvas.getContext('2d');
      this.canvasTxt.scale(1 * this.sratio, 1 * this.sratio);
      this.sratio = realw / this.width;
      this.canvasTxt.scale(1 / this.sratio, 1 / this.sratio);
    },

    // pc
    mouseDown: function mouseDown(e) {
      e = e || event;
      e.preventDefault();
      this.isDrawing = true;
      this.hasDrew = true;
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawStart(obj);
    },
    mouseMove: function mouseMove(e) {
      e = e || event;
      e.preventDefault();
      if (this.isDrawing) {
        var obj = {
          x: e.offsetX,
          y: e.offsetY
        };
        this.drawMove(obj);
      }
    },
    mouseUp: function mouseUp(e) {
      e = e || event;
      e.preventDefault();
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawEnd(obj);
      this.isDrawing = false;
    },

    // mobile
    touchStart: function touchStart(e) {
      e = e || event;
      e.preventDefault();
      this.hasDrew = true;
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawStart(obj);
      }
    },
    touchMove: function touchMove(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawMove(obj);
      }
    },
    touchEnd: function touchEnd(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawEnd(obj);
      }
    },

    // 绘制
    drawStart: function drawStart(obj) {
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
    },
    drawMove: function drawMove(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.strokeStyle = this.lineColor;
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.startY = obj.y;
      this.startX = obj.x;
      this.points.push(obj);
    },
    drawEnd: function drawEnd(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.points.push({ x: -1, y: -1 });
    },

    // 操作
    generate: function generate(options) {
      var _this2 = this;

      var imgFormat = options && options.format ? options.format : this.format;
      var imgQuality = options && options.quality ? options.quality : this.quality;
      var pm = new Promise(function (resolve, reject) {
        if (!_this2.hasDrew) {
          reject('Warning: Not Signned!');
          return;
        }
        var resImgData = _this2.canvasTxt.getImageData(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.globalCompositeOperation = "destination-over";
        _this2.canvasTxt.fillStyle = _this2.myBg;
        _this2.canvasTxt.fillRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.resultImg = _this2.$refs.canvas.toDataURL(imgFormat, imgQuality);
        var resultImg = _this2.resultImg;
        _this2.canvasTxt.clearRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.putImageData(resImgData, 0, 0);
        _this2.canvasTxt.globalCompositeOperation = "source-over";
        if (_this2.isCrop) {
          var _canvasTxt;

          var crop_area = _this2.getCropArea(resImgData.data);
          var crop_canvas = document.createElement('canvas');
          var crop_ctx = crop_canvas.getContext('2d');
          crop_canvas.width = crop_area[2] - crop_area[0];
          crop_canvas.height = crop_area[3] - crop_area[1];
          var crop_imgData = (_canvasTxt = _this2.canvasTxt).getImageData.apply(_canvasTxt, _toConsumableArray(crop_area));
          crop_ctx.globalCompositeOperation = "destination-over";
          crop_ctx.putImageData(crop_imgData, 0, 0);
          crop_ctx.fillStyle = _this2.myBg;
          crop_ctx.fillRect(0, 0, crop_canvas.width, crop_canvas.height);
          resultImg = crop_canvas.toDataURL(imgFormat, imgQuality);
          crop_canvas = null;
        }
        resolve(resultImg);
      });
      return pm;
    },
    reset: function reset() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      if (this.isClearBgColor) {
        this.$emit('update:bgColor', '');
        this.$refs.canvas.style.background = 'rgba(255, 255, 255, 0)';
      }
      this.points = [];
      this.hasDrew = false;
      this.resultImg = '';
    },
    getCropArea: function getCropArea(imgData) {
      var topX = this.$refs.canvas.width;var btmX = 0;var topY = this.$refs.canvas.height;var btnY = 0;
      for (var i = 0; i < this.$refs.canvas.width; i++) {
        for (var j = 0; j < this.$refs.canvas.height; j++) {
          var pos = (i + this.$refs.canvas.width * j) * 4;
          if (imgData[pos] > 0 || imgData[pos + 1] > 0 || imgData[pos + 2] || imgData[pos + 3] > 0) {
            btnY = Math.max(j, btnY);
            btmX = Math.max(i, btmX);
            topY = Math.min(j, topY);
            topX = Math.min(i, topX);
          }
        }
      }
      topX++;
      btmX++;
      topY++;
      btnY++;
      var data = [topX, topY, btmX, btnY];
      return data;
    }
  }
});

/***/ }),

/***/ "ngqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nqDt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "nwRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recheck_addOrUpdateForm__ = __webpack_require__("pCDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recheck_table__ = __webpack_require__("ZvsT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeadBar__ = __webpack_require__("cWbZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Sidebar__ = __webpack_require__("sSDe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__("P9l9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import * as types from '@/vuex/types'
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Headbar: __WEBPACK_IMPORTED_MODULE_3__HeadBar__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__Sidebar__["a" /* default */],
    RecheckTable: __WEBPACK_IMPORTED_MODULE_1__recheck_table__["a" /* default */],
    addOrUpdateForm: __WEBPACK_IMPORTED_MODULE_0__recheck_addOrUpdateForm__["a" /* default */]
  },
  data: function data() {
    return {
      dialogVisible: false,
      showHead: true,
      iscollapse: false
    };
  },
  mounted: function mounted() {
    if (this.$route.query.companyId && this.$route.query.controlId) {
      this.showHead = false;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_types__["COMPANY_ID"], this.$route.query.companyId);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_types__["CONTROL_ID"], this.$route.query.controlId);
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_types__["SESSION_ID"], this.$route.query.sid);
    }
  },
  destroyed: function destroyed() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_types__["COMPANY_ID"], null);
  },

  methods: {
    refreshTable: function refreshTable() {
      if (this.$refs['recheckTable']) {
        this.$refs['recheckTable'].getList();
      }
    },
    back: function back() {
      this.$router.push('/enterpriseManagement/index');
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_types__["COMPANY_ID"], null);
    },
    addRecheck: function addRecheck() {
      this.$refs['addOrUpdateForm'].showForm();
    },
    showRecheckTable: function showRecheckTable() {
      this.dialogVisible = true;
    },
    send: function send() {
      var _this = this;

      this.$confirm('点击确定将发送短信提醒单位有新的复核要求?', '提示', {
        confirmButtonText: '确定发送',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$http.post(__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* api */]['sendReviewMessage'], { company_id: _this.$store.state.companyId }).then(function (response) {
          if (response.data.code === 0) {
            _this.$message({
              type: 'success',
              message: '发送成功'
            });
          } else {
            _this.$message({
              type: 'warning',
              message: '发送失败 ' + response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    }
  }
});

/***/ }),

/***/ "oQse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return mineOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return industryOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return levelOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return standardOptionA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return standardOptionB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return standardOptionC; });
/* unused harmony export firestandardOptions */
/* unused harmony export funeralOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isStandardOptions; });
/* unused harmony export isFuneralOptions */
/* unused harmony export isfireStandardOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return standardOptions; });
/* unused harmony export standardMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return nineSmallPlaceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return scaleOptions; });
/* unused harmony export staffTypeOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return controlLevelOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return frequencyTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dangerOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return rateColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return flowStatusOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearStatusOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return categoryOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return industryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return expertTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return majorServiceOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return industriesOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return qualificationCertificateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return projectTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return occupationNameOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return educationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return personnelCertificateOptions; });
// 矿山种类
var mineOptions = ['煤（地下开采）', '煤（露天开采）', '石油', '油页岩', '烃类天然气', '二氧化碳气', '煤成(层)气', '地热(热水)', '地热(热气)', '放射性矿产', '金(岩金)', '金(砂金船采)', '金(砂金机采)', '银', '其他贵金属', '铁（地下开采）', '铁（露天开采）', '锰', '铬、钛、钒', '铜', '铅', '锌', '钨', '锡', '锑', '铝土矿', '钼', '镍', '钴', '镁', '铋', '汞', '稀土、稀有金属', '石灰岩', '硅石', '白云岩', '耐火粘土', '萤石', '硫铁矿', '自然硫', '磷矿', '蛇纹岩', '硼矿', '岩盐、井盐', '湖盐', '钾盐', '芒硝', '碘', '砷、雌黄、雄黄、毒砂', '金刚石', '宝石', '云母', '石棉', '重晶石', '石膏', '滑石', '长石', '高岭土、瓷土等', '膨润土', '叶蜡石', '沸石', '石墨', '玻璃用砂、砂岩', '水泥用砂岩', '建筑石料', '建筑用砂、砖瓦粘土', '页岩', '矿泉水'];
// 企业类型
var industryOptions = [{
  value: 1,
  label: '工业风险单元',
  children: [{
    disabled: false,
    value: 101,
    label: '危险化学品生产企业'
  }, {
    disabled: false,
    value: 102,
    label: '带储存的危险化学品经营企业'
  }, {
    disabled: false,
    value: 103,
    label: '危险化学品使用企业'
  }, {
    disabled: false,
    value: 104,
    label: '加油站'
  }, {
    disabled: false,
    value: 105,
    label: '天然气站场'
  }, {
    disabled: false,
    value: 106,
    label: '液化气储配站（含供应站）'
  }, {
    disabled: false,
    value: 107,
    label: '冶金企业'
  }, {
    disabled: false,
    value: 108,
    label: '有色企业'
  }, {
    disabled: false,
    value: 109,
    label: '民用爆炸物品企业'
  }, {
    disabled: false,
    value: 110,
    label: '建材企业'
  }, {
    disabled: false,
    value: 121,
    label: '轻工企业'
  }, {
    disabled: false,
    value: 111,
    label: '机械企业'
  }, {
    disabled: false,
    value: 112,
    label: '纺织企业'
  }, {
    disabled: false,
    value: 113,
    label: '电力企业'
  }, {
    disabled: false,
    value: 114,
    label: '露天矿山'
  }, {
    disabled: false,
    value: 115,
    label: '地下矿山'
  }, {
    disabled: false,
    value: 116,
    label: '尾矿库'
  }, {
    disabled: false,
    value: 117,
    label: '烟花爆竹企业'
  }, {
    disabled: false,
    value: 118,
    label: '港口经营企业（泉州港口）'
  }, {
    disabled: false,
    value: 119,
    label: '铁路货运站场'
  }, {
    disabled: false,
    value: 120,
    label: '建筑业'
  }, {
    disabled: false,
    value: 122,
    label: '农业与农机(农药、兽药)'
  }, {
    disabled: false,
    value: 123,
    label: '农机(含农机作业)'
  }, {
    disabled: false,
    value: 124,
    label: '农业与农机(农产品初加工、饲料及饲料添加剂生产)'
  }, {
    disabled: false,
    value: 126,
    label: '机动车维修企业'
  }, {
    disabled: false,
    value: 127,
    label: '粮食和物资储备行业'
  }, {
    disabled: false,
    value: 128,
    label: '烟草'
  }, {
    disabled: false,
    value: 129,
    label: '林业'
  }, {
    disabled: false,
    value: 132,
    label: '农田水利建设'
  }, {
    disabled: false,
    value: 133,
    label: '公路、水运工程'
  }, {
    disabled: false,
    value: 134,
    label: '房地产业(含房地产开发、房屋征收拆迁等)'
  }, {
    disabled: false,
    value: 135,
    label: '水利工程'
  }, {
    disabled: false,
    value: 136,
    label: '民爆物品(爆破)'
  }, {
    disabled: false,
    value: 137,
    label: '特种设备生产企业'
  }, {
    disabled: false,
    value: 138,
    label: '港口经营企业（湄洲湾港口）'
  }, {
    disabled: false,
    value: 141,
    label: '加气站'
  }]
}, {
  disabled: false,
  value: 2,
  label: '人员密集场所单元',
  children: [{
    value: 201,
    label: '餐饮场所'
  }, {
    value: 202,
    label: '医疗机构'
  }, {
    value: 203,
    label: '房地产业（物业服务）'
  }, {
    value: 204,
    label: '宗教场所'
  }, {
    value: 205,
    label: '体育场馆'
  }, {
    value: 206,
    label: '城市公园'
  }, {
    value: 207,
    label: '学校'
  }, {
    value: 208,
    label: '宾馆酒店（非星级）'
  }, {
    value: 209,
    label: '养老机构和福利机构'
  }, {
    value: 210,
    label: '文化行业'
  }, {
    value: 211,
    label: '商贸'
  }, {
    value: 213,
    label: '技工院校和职业培训机构'
  }, {
    value: 214,
    label: '新闻出版'
  }, {
    value: 215,
    label: '文物和博物馆'
  }, {
    value: 216,
    label: '星级饭店（酒店）'
  }, {
    value: 217,
    label: '商贸（医药及医疗器材）'
  }, {
    disabled: false,
    value: 229,
    label: '驾校'
  }]
}, {
  disabled: false,
  value: 3,
  label: '公共设施单元',
  children: [{
    value: 301,
    label: '城市桥梁'
  }, {
    value: 302,
    label: '城市隧道'
  }, {
    value: 303,
    label: '水库大坝'
  }, {
    value: 304,
    label: '客运车站'
  }, {
    value: 305,
    label: '旅行社'
  }, {
    value: 306,
    label: '陆上油气长输管道企业'
  }, {
    value: 307,
    label: '城镇燃气管道企业'
  }, {
    value: 308,
    label: '危险货物道路运输企业'
  }, {
    value: 309,
    label: '建筑垃圾受纳场'
  }, {
    value: 310,
    label: '渔业船舶'
  }, {
    value: 312,
    label: '城市垃圾处理企业'
  }, {
    value: 313,
    label: '散装物料运输企业'
  }, {
    value: 314,
    label: '普通货物运输企业'
  }, {
    value: 315,
    label: '邮政(含快递)'
  }, {
    disabled: false,
    value: 316,
    label: '城市供水企业'
  }, {
    disabled: false,
    value: 317,
    label: '污水处理企业'
  }, {
    disabled: false,
    value: 318,
    label: '农村水电站'
  }, {
    disabled: false,
    value: 319,
    label: '公路客运企业'
  }, {
    value: 320,
    label: '水路旅客运输企业'
  }, {
    disabled: false,
    value: 335,
    label: '水路货物运输企业'
  }]
}];
// 风险等级
var levelOptions = [{ label: '重大风险', value: 1 }, { label: '较大风险', value: 2 }, { label: '一般风险', value: 3 }, { label: '低风险', value: 4 }];

var standardOptionA = ['评审达标', '自评达标', '未创建标准化'];

var standardOptionB = ['国家标准', '省级标准', '泉州标准'];

var standardOptionC = ['一级', '二级', '三级', '不定级(泉州标准达标)'];

var firestandardOptions = ['已达标', '未达标', '未创建'];
var funeralOptions = ['一级', '二级', '三级', '未评定'];
var isStandardOptions = ['一级达标', '二级达标', '三级达标', '小微达标'];
var isFuneralOptions = ['一级', '二级', '三级'];
var isfireStandardOptions = ['已达标'];
// 标准化创建
var standardOptions = [{
  value: '评审达标',
  label: '评审达标',
  children: [{
    value: '国家标准',
    label: '国家标准',
    children: [{
      value: '一级',
      label: '一级'
    }, {
      value: '二级',
      label: '二级'
    }, {
      value: '三级',
      label: '三级'
    }, {
      value: '不定级',
      label: '不定级'
    }]
  }, {
    value: '省级标准',
    label: '省级标准',
    children: [{
      value: '一级',
      label: '一级'
    }, {
      value: '二级',
      label: '二级'
    }, {
      value: '三级',
      label: '三级'
    }, {
      value: '不定级',
      label: '不定级'
    }]
  }, {
    value: '泉州标准',
    label: '泉州标准',
    children: [{
      value: '一级',
      label: '一级'
    }, {
      value: '二级',
      label: '二级'
    }, {
      value: '三级',
      label: '三级'
    }, {
      value: '不定级（泉州标准达标）',
      label: '不定级（泉州标准达标）'
    }]
  }]
}, {
  value: '自评达标',
  label: '自评达标',
  children: [{
    value: '国家标准',
    label: '国家标准',
    children: [{
      value: '一级',
      label: '一级'
    }, {
      value: '二级',
      label: '二级'
    }, {
      value: '三级',
      label: '三级'
    }, {
      value: '不定级',
      label: '不定级'
    }]
  }, {
    value: '省级标准',
    label: '省级标准',
    children: [{
      value: '一级',
      label: '一级'
    }, {
      value: '二级',
      label: '二级'
    }, {
      value: '三级',
      label: '三级'
    }, {
      value: '不定级',
      label: '不定级'
    }]
  }, {
    value: '泉州标准',
    label: '泉州标准',
    children: [{
      value: '一级',
      label: '一级'
    }, {
      value: '二级',
      label: '二级'
    }, {
      value: '三级',
      label: '三级'
    }, {
      value: '不定级（泉州标准达标）',
      label: '不定级（泉州标准达标）'
    }]
  }]
}, {
  value: '未创建标准化',
  label: '未创建'
}];
// 标准化映射
var standardMap = {
  '评审达标,国家标准,一级': '国标一级',
  '评审达标,国家标准,二级': '国标二级',
  '评审达标,国家标准,三级': '国标三级',
  '评审达标,国家标准,不定级': '国标不定级',
  '评审达标,省级标准,一级': '省标一级',
  '评审达标,省级标准,二级': '省标二级',
  '评审达标,省级标准,三级': '省标三级',
  '评审达标,省级标准,不定级': '省标不定级',
  '评审达标,泉州标准,一级': '泉州一级',
  '评审达标,泉州标准,二级': '泉州二级',
  '评审达标,泉州标准,三级': '泉州三级',
  '评审达标,泉州标准,不定级（泉州标准达标）': '泉州标准化达标',
  '自评达标,国家标准,一级': '国标一级（自评）',
  '自评达标,国家标准,二级': '国标二级（自评）',
  '自评达标,国家标准,三级': '国标三级（自评）',
  '自评达标,国家标准,不定级': '不定级（自评）',
  '自评达标,省级标准,一级': '省标一级（自评）',
  '自评达标,省级标准,二级': '省标二级（自评）',
  '自评达标,省级标准,三级': '省标三级（自评）',
  '自评达标,省级标准,不定级': '省标不定级（自评）',
  '自评达标,泉州标准,一级': '泉州一级（自评）',
  '自评达标,泉州标准,二级': '泉州二级（自评）',
  '自评达标,泉州标准,三级': '泉州三级（自评）',
  '自评达标,泉州标准,泉州标准达标': '泉州标准化达标（自评）',
  未创建标准化: '未创建标准化'

  // 九小场所
};var nineSmallPlaceType = [{
  value: '九小场所',
  label: '九小场所',
  children: [{
    value: '小商店',
    label: '小商店'
  }, {
    value: '小旅馆',
    label: '小旅馆'
  }, {
    value: '小学校（幼儿园、校外培训机构）',
    label: '小学校（幼儿园、校外培训机构）'
  }, {
    value: '小医院（诊所、养老院）',
    label: '小医院（诊所、养老院）'
  }, {
    value: '小网吧',
    label: '小网吧'
  }, {
    value: '小餐饮馆',
    label: '小餐饮馆'
  }, {
    value: '小歌舞娱乐场所',
    label: '小歌舞娱乐场所'
  }, {
    value: '小美容洗浴场所',
    label: '小美容洗浴场所'
  }, {
    value: '小生产加工企业',
    label: '小生产加工企业'
  }]
}];
// 单位规模
var scaleOptions = ['大型', '中型', '小型', '微型'];

// 人员类型
var staffTypeOptions = ['主要负责人', '安全管理人员', '其他管理人员', '一线生产人员', '其他人员', '特种作业人员', '特种设备作业人员'];

var controlLevelOptions = {
  1: '岗位',
  2: '部门',
  3: '单位'
};

var frequencyTypeOptions = {
  1: '小时 / 次',
  2: '天 / 次',
  3: '周 / 次',
  4: '月 / 次',
  5: '年 / 次'

  // 危险作业类型
};var dangerOptions = ['动火作业', '有限空间作业', '高处作业', '吊装作业', '断路作业', '动土作业', '临时用电作业', '盲板抽堵作业'];
var rateColors = ['#99A9BF', '#F7BA2A', '#FF9900'];
var flowStatusOptions = [{
  // 危险作业状态
  label: '未开始',
  value: 0
}, {
  label: '进行中',
  value: 1
}, {
  label: '已关闭',
  value: 2
}, {
  label: '逾期未关闭',
  value: 3
}];

var clearStatusOptions = [{
  // 销号状态
  label: '挂牌督办待审核',
  value: 1
}, {
  label: '打回一般隐患',
  value: 2
}, {
  label: '挂牌督办中',
  value: 3
}, {
  label: '摘牌销案待审核',
  value: 4
}, {
  label: '已摘牌销案',
  value: 5
}];

var categoryOption = [{
  disabled: false,
  value: '基础管理',
  label: '基础管理',
  children: [{
    disabled: false,
    value: '生产经营单位资质证照类',
    label: '生产经营单位资质证照类'
  }, {
    disabled: false,
    value: '安全生产管理机构及人员类',
    label: '安全生产管理机构及人员类'
  }, {
    disabled: false,
    value: '安全生产责任制类',
    label: '安全生产责任制类'
  }, {
    disabled: false,
    value: '安全生产管理制度类',
    label: '安全生产管理制度类'
  }, {
    disabled: false,
    value: '安全操作规程类',
    label: '安全操作规程类'
  }, {
    disabled: false,
    value: '教育培训类',
    label: '教育培训类'
  }, {
    disabled: false,
    value: '安全生产管理档案类',
    label: '安全生产管理档案类'
  }, {
    disabled: false,
    value: '安全生产投入类',
    label: '安全生产投入类'
  }, {
    disabled: false,
    value: '应急管理类',
    label: '应急管理类'
  }, {
    disabled: false,
    value: '特种设备基础管理类',
    label: '特种设备基础管理类'
  }, {
    disabled: false,
    value: '职业卫生基础管理类',
    label: '职业卫生基础管理类'
  }, {
    disabled: false,
    value: '相关方基础管理类',
    label: '相关方基础管理类'
  }, {
    disabled: false,
    value: '其他基础管理类',
    label: '其他基础管理类'
  }]
}, {
  disabled: false,
  value: '现场管理',
  label: '现场管理',
  children: [{
    disabled: false,
    value: '特种设备现场管理类',
    label: '特种设备现场管理类'
  }, {
    disabled: false,
    value: '生产设备设施及工艺类',
    label: '生产设备设施及工艺类'
  }, {
    disabled: false,
    value: '场所环境类',
    label: '场所环境类'
  }, {
    disabled: false,
    value: '从业人员操作行为类',
    label: '从业人员操作行为类'
  }, {
    disabled: false,
    value: '消防安全类',
    label: '消防安全类'
  }, {
    disabled: false,
    value: '用电安全类',
    label: '用电安全类'
  }, {
    disabled: false,
    value: '职业卫生现场安全类',
    label: '职业卫生现场安全类'
  }, {
    disabled: false,
    value: '有限空间现场安全类',
    label: '有限空间现场安全类'
  }, {
    disabled: false,
    value: '辅助动力系统类',
    label: '辅助动力系统类'
  }, {
    disabled: false,
    value: '相关方现场管理类',
    label: '相关方现场管理类'
  }, {
    disabled: false,
    value: '其他现场管理类',
    label: '其他现场管理类'
  }]
}];

// 带有八大行业的企业类型
var industryList = [{
  value: 1,
  label: '矿山',
  children: [{
    value: 114,
    label: '露天矿山'
  }]
}, {
  value: 2,
  label: '危险化学品',
  children: [{
    value: 101,
    label: '危险化学品生产企业'
  }, {
    disabled: false,
    value: 102,
    label: '带储存的危险化学品经营企业'
  }, {
    disabled: false,
    value: 103,
    label: '危险化学品使用企业'
  }, {
    disabled: false,
    value: 104,
    label: '加油站'
  }]
}, {
  value: 3,
  label: '烟花爆竹',
  children: [{
    disabled: false,
    value: 117,
    label: '烟花爆竹企业'
  }]
}, {
  value: 4,
  label: '交通运输',
  children: [{
    value: 322,
    label: '城市轨道交通（地铁）'
  }, {
    value: 321,
    label: '城市道路公共交通运营企业'
  }, {
    value: 308,
    label: '道路危险货物运输企业'
  }, {
    value: 319,
    label: '公路客运企业'
  }]
}, {
  value: 5,
  label: '建筑施工',
  children: [{
    value: 139,
    label: '房屋建设'
  }]
}, {
  value: 6,
  label: '民用爆炸物品',
  children: [{
    value: 109,
    label: '民用爆炸物品企业'
  }]
}, {
  value: 7,
  label: '金属冶炼',
  children: [{
    value: 107,
    label: '冶金企业'
  }]
}, {
  value: 8,
  label: '渔业生产',
  children: [{
    value: 310,
    label: '渔业船舶'
  }]
}, {
  value: 9,
  label: '工业风险单元',
  children: [{
    disabled: false, // 104
    value: 140,
    label: '加油加气站'
  }, {
    disabled: false, // 104
    value: 141,
    label: '加气站'
  }, {
    disabled: false,
    value: 108,
    label: '有色企业'
  }, {
    disabled: false,
    value: 110,
    label: '建材企业'
  }, {
    disabled: false,
    value: 121,
    label: '轻工企业'
  }, {
    disabled: false,
    value: 111,
    label: '机械企业'
  }, {
    disabled: false,
    value: 112,
    label: '纺织企业'
  }, {
    disabled: false, // 111
    value: 142,
    label: '汽车制造企业'
  }, {
    disabled: false, // 111
    value: 144,
    label: '船舶修造企业'
  }, {
    disabled: false,
    value: 105,
    label: '天然气站场'
  }, {
    disabled: false,
    value: 145,
    label: '危险废物处置企业'
  }, {
    disabled: false,
    value: 118,
    label: '港口经营企业'
  }, {
    disabled: false,
    value: 126,
    label: '机动车维修企业'
  }, {
    disabled: false,
    value: 106,
    label: '液化气储配站（含供应站）'
  }, {
    value: 330, // 111
    label: '民航设施维修产业'
  }]
}, {
  disabled: false,
  value: 10,
  label: '人员密集单元',
  children: [{
    disabled: false,
    value: 205,
    label: '体育场馆'
  }, {
    disabled: false,
    value: 202,
    label: '医疗机构'
  }, {
    disabled: false, // 208
    value: 216,
    label: '星级饭店（酒店）' // 公路、水运工程
  }, {
    disabled: false,
    value: 208,
    label: '宾馆酒店（非星级）'
  }, {
    disabled: false, // 208
    value: 217,
    label: '民宿'
  }, {
    disabled: false,
    value: 201,
    label: '餐饮场所'
  }, {
    disabled: false, // 207
    value: 213,
    label: '技工院校'
  }, {
    disabled: false, // 207
    value: 219,
    label: '职业技能培训机构'
  }, {
    disabled: false,
    value: 207,
    label: '学校'
  }, {
    disabled: false, // 207
    value: 220,
    label: '托育机构'
  }, {
    disabled: false,
    value: 209,
    label: '养老机构和福利机构'
  }, {
    disabled: false,
    value: 222,
    label: '殡仪服务场所'
  }, {
    disabled: false,
    value: 211,
    label: '商场'
  }, {
    disabled: false, // 211
    value: 223,
    label: '市场'
  }, {
    disabled: false,
    value: 204,
    label: '宗教场所'
  }, {
    disabled: false,
    value: 210,
    label: '文化娱乐行业'
  }, {
    disabled: false,
    value: 215,
    label: '文物和博物馆'
  }, {
    disabled: false,
    value: 224,
    label: '少年宫'
  },
  // {
  //   disabled: true,
  //   value: 225,
  //   label: '科技馆'
  // },
  {
    disabled: false,
    value: 226,
    label: '会展场馆'
  }, {
    disabled: false,
    value: 227,
    label: '会堂场馆'
  }, {
    disabled: false,
    value: 206,
    label: '旅游景区'
  }, {
    disabled: false, // 206
    value: 228,
    label: '风景名胜区'
  }, {
    disabled: false,
    value: 304,
    label: '客运车站'
  }, {
    disabled: false,
    value: 229,
    label: '驾校'
  }]
}, {
  disabled: false,
  value: 11,
  label: '公共设施单元',
  children: [{
    disabled: false,
    value: 133,
    label: '公路建设项目'
  }, {
    disabled: false,
    value: 135,
    label: '在建水利水电项目（水利局）'
  }, {
    disabled: false, // 135
    value: 323,
    label: '在建水电项目（工信局）'
  }, {
    disabled: false,
    value: 309,
    label: '建筑垃圾消纳场'
  }, {
    value: 325, // 113
    label: '发电企业（水力）（水利局）'
  }, {
    value: 326, // 113
    label: '发电企业（水力）（工信局）'
  }, {
    value: 327, // 113
    label: '发电企业（火力）'
  }, {
    value: 306,
    label: '陆上长输油气管道企业'
  }, {
    value: 315, // 111
    label: '快递企业'
  }, {
    value: 307,
    label: '城镇燃气管道企业'
  }, {
    value: 316,
    label: '城市供水企业'
  }, {
    value: 317,
    label: '污水处理企业'
  }, {
    value: 331, // 302
    label: '市政隧道（市政园林局）'
  }, {
    value: 302,
    label: '公路隧道（交通运输局）'
  }, {
    value: 332, // 206
    label: '城市公园'
  }, {
    value: 333, // 301
    label: '市政桥梁（市政园林局）'
  }, {
    value: 301,
    label: '公路桥梁（交通运输局）'
  }, {
    value: 314,
    label: '道路普通货物运输企业'
  }, {
    disabled: false,
    value: 335,
    label: '水路货物运输企业'
  }, {
    value: 320,
    label: '水路旅客运输企业'
  }, {
    value: 303,
    label: '水库大坝'
  }, {
    value: 320,
    label: '水路旅客运输企业'
  }, {
    disabled: false,
    value: 335,
    label: '水路货物运输企业'
  }]
}];

// 专家服务-专家库级别下拉选项
var expertTypeList = [{
  value: '国家级',
  label: '国家级'
}, {
  value: '省级',
  label: '省级'
}, {
  value: '地市级',
  label: '地市级'
}, {
  value: '区县级',
  label: '区县级'
}];

// 主要服务项目
var majorServiceOptions = [
// {value: '安全评价', label: '安全评价'},
// {value: '安全标准化服务', label: '安全标准化服务'},
// {value: '其他', label: '其他'},
{ value: '安全生产标准化服务', label: '安全生产标准化服务' }, { value: '安全技术咨询', label: '安全技术咨询' }, { value: '安全评估', label: '安全评估' }, { value: '安全风险分级管控', label: '安全风险分级管控' }, { value: '隐患排查治理', label: '隐患排查治理' }, { value: '安全生产评价', label: '安全生产评价' }, { value: '应急预案', label: '应急预案' }, { value: '其他', label: '其他' }];

// 主要服务行业领域
var industriesOptions = [{ value: '危化', label: '危化' }, { value: '工贸', label: '工贸' }, { value: '矿山', label: '矿山' }, { value: '建筑', label: '建筑' }, { value: '消防', label: '消防' }, { value: '交通', label: '交通' }, { value: '烟花爆竹', label: '烟花爆竹' }, { value: '电力', label: '电力' }, { value: '其他', label: '其他' }];

// 资格证书名称
var qualificationCertificateOptions = ['安全评价机构资质证书', '营业执照（或独立法人资格证书）', '职业卫生技术服务机构资质证书', '其他'];

var projectTypeOptions = [{ value: '安全评价', label: '安全评价' }, { value: '安全现状评价', label: '安全现状评价' }, { value: '安全验收评价', label: '安全验收评价' }, { value: '安全标准化服务', label: '安全标准化服务' }, { value: '隐患排查', label: '隐患排查' }, { value: '应急预案', label: '应急预案' }, { value: '其他', label: '其他' }];

// 职称
var occupationNameOptions = [
// '无',
// '初级技术职称人员',
// '中级技术职称人员',
// '高级技术职称人员',
// '省市级应急安全专家',
// '其他',
'无', '正高级', '副高级', '中级', '初级', '其他'];

// 学历
var educationOptions = ['高中', '中专', '专科', '本科', '研究生及以上', '其他'];

// 人员信息-证书类型
var personnelCertificateOptions = ['注册安全工程师', '安全评价师', '注册消防师', '高级工程技术职称', '省市级应急安全专家', '其他'];

/***/ }),

/***/ "okWP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pBm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return tableMixins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dialogMixins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fileMixins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return imageMixins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return multipleImgMixins; });
/* unused harmony export commonTableMixins */
/* unused harmony export infoMixins */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Util_importantBtn__ = __webpack_require__("h/+5");












var tableMixins = {
  components: {
    importBtn: __WEBPACK_IMPORTED_MODULE_10__Util_importantBtn__["a" /* default */]
  },
  props: {
    tab: String,
    modules: String
  },
  data: function data() {
    return {
      deleteArr: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      pagination: false,
      exportloading: false,
      exportloading1: false,
      exportloading3: false
    };
  },
  mounted: function mounted() {
    if (this.type != 'sonTable') {
      this.getList();
    }
  },

  methods: {
    // 选择年度
    handleUserDropdownCommand: function handleUserDropdownCommand(command) {
      this.search_year = command;
      this.refreshTable();
    },

    // 导出
    downloadExcel: function downloadExcel(url) {
      var _this = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.exportloading = true;
      // 参数
      var params = {
        six_manager_id: this.sixMangerId
      };
      if (this.$store.state.companyId && this.$store.state.companyId != 'null' && this.$store.state.companyId != 'undefined') {
        params.company_id = this.$store.state.companyId;
      } else {
        params.company_id = null;
      }
      params = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, params, data);
      if (params.hasOwnProperty("page_size")) {
        delete params.page_size;
      }
      if (params.hasOwnProperty("page_index")) {
        delete params.page_index;
      }
      this.$http.post(url, params, { headers: { 'Accept': 'application/octet-stream' } }).then(function (response) {
        _this.exportloading = false;
        if (response.data.code !== 0) {
          _this.$message({
            type: 'warning',
            message: '导出Excel文件失败：' + response.data.msg
          });
        } else {
          window.open(response.data.data['file_url']);
        }
      }).catch(function (error) {
        _this.exportloading = false;
        if (error.message.includes('timeout')) {
          _this.$message({
            type: 'warning',
            message: '导出失败，可能数据量太大，请添加过滤条件'
          });
        } else {
          console.log(error);
        }
        console.log(error);
      });
    },
    archive: function archive(url) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.exportloading1 = true;
      // 参数
      var params = {
        company_id: this.$store.state.companyId,
        is_archive: this.$store.state.is_archive
      };
      params = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, params, data);
      this.$http.post(url, params, { headers: { 'Accept': 'application/octet-stream' } }).then(function (response) {
        _this2.exportloading1 = false;
        if (response.data.code === 0) {
          _this2.$message({
            type: 'success',
            message: '归档成功! '
          });
        } else {
          _this2.$message({
            type: 'warning',
            message: '归档失败! '
          });
        }
      }).catch(function (error) {
        _this2.exportloading1 = false;
        if (error.message.includes('timeout')) {
          _this2.$message({
            type: 'warning',
            message: '请求超时'
          });
        } else {
          console.log(error);
        }
        console.log(error);
      });
    },
    archiveNew: function archiveNew(url) {
      var _this3 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.exportloading3 = true;
      // 参数
      var params = {
        company_id: this.$store.state.companyId,
        is_archive: this.$store.state.is_archive
      };
      params = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, params, data);
      this.$http.post(url, params, { headers: { 'Accept': 'application/octet-stream' } }).then(function (response) {
        _this3.exportloading3 = false;
        if (response.data.code === 0) {
          _this3.$message({
            type: 'success',
            message: '归档成功! '
          });
        } else {
          _this3.$message({
            type: 'warning',
            message: '归档失败! '
          });
        }
      }).catch(function (error) {
        _this3.exportloading3 = false;
        if (error.message.includes('timeout')) {
          _this3.$message({
            type: 'warning',
            message: '请求超时'
          });
        } else {
          console.log(error);
        }
        console.log(error);
      });
    },
    personFormat: function personFormat(person) {
      if (person) {
        var arr = person.split(',');
        var arr2 = arr.filter(function (item, index) {
          return index < 3;
        });
        return '' + arr2.join(',') + (arr.length > 2 ? '\u7B49' + arr.length + '\u4EBA' : '');
      }
      return '-';
    },

    // 表格增加按钮
    showForm: function showForm() {
      this.$refs['addOrUpdateForm'].showForm();
    },
    showEditForm: function showEditForm(row, param) {
      this.$refs['addOrUpdateForm'].showEditForm(row, param);
    },

    // 刷新操作
    refreshTable: function refreshTable() {
      this.getList();
      this.SelectionAll = {};
    },
    deletePromise: function deletePromise(id) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */]['delete' + _this4.data_class], { id: id }).then(function (response) {
          if (response.data.code === 0) {
            resolve(response.data);
          } else {
            _this4.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      });
    },

    // 批量删除
    batchDelete: function batchDelete(name) {
      var _this5 = this;

      if (this.deleteArr.length == 0) {
        this.$message({
          type: 'warning',
          message: '\u8BF7\u5148\u52FE\u9009\u8981\u5220\u9664\u7684' + name
        });
        return;
      }
      this.$confirm('请确认您是否要进行批量删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var uploadTasks = _this5.deleteArr.map(function (id) {
          return _this5.deletePromise(id);
        });
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a.all(uploadTasks).then(function (data) {
          _this5.refreshTable();
          _this5.$message({
            type: 'success',
            message: '\u5220\u9664\u6210\u529F'
          });
        });
      }).catch(function () {});
    },

    // 删除操作
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      this.$confirm('请确认您是否要删除该条数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 调删除接口，刷新表格
        _this6.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */]['delete' + _this6.data_class], { id: row.id }).then(function (response) {
          if (response.data.code === 0) {
            _this6.refreshTable();
            _this6.$message({
              type: 'success',
              message: '删除成功'
            });
          } else {
            _this6.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },

    // 获取表格数据
    getList: function getList(newParams) {
      var _this7 = this;

      this.loading = true;
      var params = {
        year: this.search_year ? this.search_year : null
      };
      if (this.$store.state.companyId && this.$store.state.companyId !== 'null') {
        params.company_id = this.$store.state.companyId;
      }
      if (this.pagination) {
        params.page_index = this.currentPage;
        params.page_size = this.pageSize ? this.pageSize : 10;
      }
      if (newParams) {
        for (var key in newParams) {
          params[key] = newParams[key];
        }
      }
      if (this.handleNewParams) {
        var myParams = this.handleNewParams();
        for (var _key in myParams) {
          params[_key] = myParams[_key];
        }
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */]['get' + this.data_class + 'List'], params).then(function (response) {
        _this7.tableData = response.data.data;
        if (_this7.pagination && _this7.tableData.length > 0) {
          _this7.totalCount = response.data.page_info.total_num;
        } else {
          _this7.totalCount = 0;
        }
        if (_this7.initTableData) {
          _this7.initTableData(response);
        }
        setTimeout(function () {
          _this7.loading = false;
        }, 400);
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 切换页面
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.refreshTable();
    },

    // 分页选择
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.refreshTable();
    },

    // 表格样式
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return {
        padding: '8px 0',
        color: '#000'
      };
    },

    // 批量删除表格数据
    batchDeleteTable: function batchDeleteTable() {
      var _this8 = this;

      var riskListArr = [];
      for (var key in this.SelectionAll) {
        riskListArr.push(key);
      }
      if (riskListArr.length === 0) {
        this.$message({
          type: 'warning',
          message: '\u8BF7\u5148\u52FE\u9009\u8981\u5220\u9664\u7684\u4FE1\u606F'
        });
        return;
      }
      this.$confirm('请确认您是否要删除选中的信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 调删除接口，刷新表格
        _this8.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */]['delete' + _this8.delete_class + 'ByBatch'], __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({
          company_id: _this8.$store.state.companyId
        }, _this8.id_list + '_id_list', riskListArr.join(','))).then(function (response) {
          if (response.data.code === 0) {
            _this8.refreshTable();
            _this8.$message({
              type: 'success',
              message: '删除成功'
            });
          } else {
            _this8.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    },

    // table 表格导出
    exportTableToExcel: function exportTableToExcel() {
      var isExporting = true; // 设置导出标志

      // 创建下载链接
      var downloadLink = document.createElement('a');
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);

      // 存储input元素的值和对应的文本节点
      var table = document.getElementById('tableId');
      var inputTextNodeMap = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();

      // 替换input元素为文本节点，并存储映射关系
      table.querySelectorAll('input').forEach(function (input) {
        var textNode = document.createTextNode(input.value || '');
        input.parentNode.insertBefore(textNode, input);
        input.style.display = 'none'; // 隐藏input元素
        inputTextNodeMap.set(textNode, input); // 存储映射
      });

      // 序列化表格并创建Blob
      var tableHTML = table.outerHTML;
      var blob = new Blob([tableHTML], { type: 'application/vnd.ms-excel;charset=utf-8' });

      // 设置下载链接
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = 'exportReport.xls';
      downloadLink.click();

      // 等待下载开始后再恢复input元素
      setTimeout(function () {
        // 恢复input元素并移除文本节点
        inputTextNodeMap.forEach(function (input, textNode) {
          input.parentNode.insertBefore(input, textNode);
          input.style.display = ''; // 恢复input元素的显示
          textNode.parentNode.removeChild(textNode);
        });

        // 清理downloadLink
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(downloadLink.href);
        isExporting = false; // 重置导出标志
      }, 10); // 延迟时间可以根据需要调整
    }
  }
  // 表单mixins
};var dialogMixins = {
  props: {
    tab: String,
    modules: String,
    data_class: String
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      dataId: null,
      oldShowForm: {},
      oldEditForm: {},
      rowData: null
    };
  },
  mounted: function mounted() {
    this.oldShowForm = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.ruleForm);
  },

  computed: {
    formTitle: function formTitle() {
      return this.dataId ? '编辑' : '新增';
    }
  },
  methods: {
    // 返回树数组
    getTreeArr: function getTreeArr(value, key, treeData) {
      var arr = [];
      var returnArr = [];
      var depth = 0;
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN; // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key];
          if (childrenData[j][key] === value) {
            returnArr = arr.slice(0, depthN + 1); // 将目前匹配的数组，截断并保存到结果数组，
            break;
          } else {
            if (childrenData[j].children) {
              depth++;
              childrenEach(childrenData[j].children, depth);
            }
          }
        }
        return returnArr;
      }
      return childrenEach(treeData, depth);
    },
    showFileDetail: function showFileDetail(url) {
      this.dialogVisible2 = true;
      // window.open(row.url)
      this.url = url;
    },
    checkRules: function checkRules(key) {
      this.$refs.form.validateField(key);
    },

    // 显示新用户表单对话框
    showForm: function showForm(param) {
      var _this9 = this;

      this.dialogFormVisible = true;
      this.dataId = null;
      for (var key in this.ruleForm) {
        this.ruleForm[key] = this.oldShowForm[key];
      }
      // if (param) {
      //   for (let key in param) {
      //     this.ruleForm[key] = param[key]
      //   }
      // }
      if (this.handleshowForm) {
        this.handleshowForm(param);
      }
      this.$nextTick(function () {
        if (_this9.$refs['form']) {
          // 清楚数据校验信息
          _this9.$refs['form'].clearValidate();
        }
      });
    },

    // 显示编辑用户表单对话框
    showEditForm: function showEditForm(rowData, param) {
      var _this10 = this;

      this.dialogFormVisible = true;
      this.dataId = rowData.id;
      this.rowData = rowData;
      for (var key in this.ruleForm) {
        this.ruleForm[key] = rowData[key];
        if (rowData[key] === null) {
          this.ruleForm[key] = undefined;
        }
      }
      if (this.handleRuleForm) {
        this.handleRuleForm(rowData, param);
      }
      this.oldEditForm = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.ruleForm);
      this.$nextTick(function () {
        if (_this10.$refs['form']) {
          // 清楚数据校验信息
          _this10.$refs['form'].clearValidate();
        }
      });
    },
    submitForm: function submitForm() {
      var _this11 = this;

      if (this.checkForm) {
        if (!this.checkForm()) {
          return;
        }
      }
      this.$refs['form'].validate(function (valid) {
        if (!valid) {
          return;
        }
        var params = _this11.handleParams ? _this11.handleParams() : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, _this11.ruleForm);
        if (_this11.dataId) {
          params.id = _this11.dataId;
        }
        if (_this11.$store.state.companyId != 'null') {
          params.company_id = _this11.$store.state.companyId;
        }
        _this11.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */]['addOrUpdate' + _this11.data_class], params).then(function (res) {
          if (res.data.code === 0) {
            _this11.$message({
              message: params.id ? '修改成功' : '新增成功',
              type: 'success'
            });
            _this11.dialogFormVisible = false;
            _this11.$emit('refreshTable');
          } else {
            _this11.$message({
              message: params.id ? '\u4FEE\u6539\u5931\u8D25 ' + res.data.msg : '\u65B0\u589E\u5931\u8D25 ' + res.data.msg,
              type: 'warning'
            });
          }
        });
      });
    },
    dataChange: function dataChange(val, type, data) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (val == item.id) {
            if (type == 'name') {
              this.ruleForm['name'] = item.name;
            } else {
              this.ruleForm[type + '_name'] = item.name;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    dataMultipleChange: function dataMultipleChange(val, type, data) {
      var arr = val.map(function (item) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var i = _step2.value;

            if (i.id == item) {
              return i.name;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
      this.ruleForm[type + '_name'] = arr.join(',');
    },

    // 隐藏对话框
    hideForm: function hideForm() {
      this.dialogFormVisible = false;
    },

    // 打开对话框的事件响应
    handleDialogOpen: function handleDialogOpen() {
      if (this.$refs['form']) {
        // 清楚数据校验信息
        this.$refs['form'].clearValidate();
      }
    }
  }

  // 上传文件用的mixins
};var fileMixins = {
  data: function data() {
    return {
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'file',
        role: 4
      }
    };
  },

  methods: {
    // 文件处理 --start
    handleAvatarSuccess: function handleAvatarSuccess(res, file, key) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '上传成功'
        });
        this.ruleForm[key] = res.data['url'];
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types__["LOGOUT"]);
        this.$router.replace({ name: 'login' });
      } else {
        this.$message({
          type: 'warning',
          message: '上传失败'
        });
      }
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      // const isJPGorPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      var isLt5M = file.size / 1024 / 1024 < 200;
      // if (!isJPGorPNG) {
      //   this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      // }
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 200MB!');
      }
      return isLt5M;
    }
    // 文件处理 --end

  }
  // 上传图片的mixins
};var imageMixins = {
  data: function data() {
    return {
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'image',
        role: 4
      }
    };
  },

  methods: {
    // 图片处理
    handleAvatarSuccess: function handleAvatarSuccess(res, file, key) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '图片上传成功'
        });
        this.ruleForm[key] = res.data['url'];
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types__["LOGOUT"]);
        this.$router.replace({ name: 'login' });
      } else {
        this.$message({
          type: 'warning',
          message: '图片上传失败'
        });
      }
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt5M = file.size / 1024 / 1024 < 200;
      if (!isJPGorPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 200MB!');
      }
      return isJPGorPNG && isLt5M;
    }
  }
  // 多图片的mixins
};var multipleImgMixins = {
  data: function data() {
    return {
      uploadHeaders: {
        sid: this.$store.state.sessionId
      },
      uploadParams: {
        dir: 'image',
        role: 4
      }
    };
  },

  methods: {
    handleRemove: function handleRemove(file, fileList, key) {
      this.images = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(fileList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var item = _step3.value;

          this.images.push(item.url);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.ruleForm[key] = this.images.join(',');
    },
    handlepicture: function handlepicture(res, file, fileList, key) {
      if (res.code === 0) {
        var image = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fileList));
        this.ruleForm[key] = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(image), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var item = _step4.value;

            if (item.response) {
              this.ruleForm[key].push(item.response.data.url);
            } else {
              this.ruleForm[key].push(item.url);
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        this.ruleForm[key] = this.ruleForm[key].join(',');
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types__["LOGOUT"]);
        this.$router.replace({ name: 'login' });
      } else {
        this.$message({
          type: 'warning',
          message: '图片上传失败 ' + res.data.msg
        });
      }
    },

    // 图片处理
    handlepictureSuccess: function handlepictureSuccess(res, file, fileList, key) {
      if (res.code === 0) {
        var image = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fileList));
        var imagestr = [];
        this.ruleForm[key] = [];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(image), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var item = _step5.value;

            if (item.response) {
              this.ruleForm[key].push({ url: item.response.data.url });
              imagestr.push(item.response.data.url);
            } else {
              this.ruleForm[key].push({ url: item.url });
              imagestr.push(item.url);
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        this.image_url = imagestr.join('|');
      } else if (res.code === 10004 || res.code === 10005 || res.code === 10006) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_9__vuex_types__["LOGOUT"]);
        this.$router.replace({ name: 'login' });
      } else {
        this.$message({
          type: 'warning',
          message: '图片上传失败 ' + res.data.msg
        });
      }
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      var isLt5M = file.size / 1024 / 1024 < 200;
      if (!isJPGorPNG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 200MB!');
      }
      return isJPGorPNG && isLt5M;
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 10 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
    },
    beforeRemove: function beforeRemove(file, fileList, key) {
      var _this12 = this;

      this.$confirm('\u786E\u5B9A\u79FB\u9664\u8BE5\u56FE\u7247\uFF1F').then(function () {
        for (var i in fileList) {
          if (fileList[i] === file) {
            // fileList.
            fileList.splice(i, 1);
            break;
          }
        }
        var image = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(fileList));
        var imagestr = [];
        _this12.ruleForm[key] = [];
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(image), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var item = _step6.value;

            if (item.response) {
              _this12.ruleForm[key].push({ url: item.response.data.url });
              imagestr.push(item.response.data.url);
            } else {
              _this12.ruleForm[key].push({ url: item.url });
              imagestr.push(item.url);
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        _this12.image_url = imagestr.join('|');
      }).catch(function () {});
      return false;
    }
  }
  // 公共数据的表格
};var commonTableMixins = {
  props: {
    tab: String,
    modules: String
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    tableData: function tableData() {
      return this.$store.getters[this.data_class.replace(this.data_class[0], this.data_class[0].toLowerCase()) + 'Data'];
    }
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var _this13 = this;

      this.loading = true;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__vuex_types__['GET' + this.data_class.toUpperCase() + 'DATA']).then(function (res) {
        setTimeout(function () {
          _this13.loading = false;
        }, 500);
      });
    },

    // 表格增加按钮
    showForm: function showForm() {
      this.$refs['addOrUpdateForm'].showForm();
    },
    showEditForm: function showEditForm(row) {
      this.$refs['addOrUpdateForm'].showEditForm(row);
    },

    // 刷新操作
    refreshTable: function refreshTable(params) {
      this.getList();
    },

    // 删除操作
    handleDelete: function handleDelete(row) {
      var _this14 = this;

      this.$confirm('请确认您是否要删除该条数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 调删除接口，刷新表格
        _this14.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */]['delete' + _this14.data_class], { id: row.id }).then(function (response) {
          if (response.data.code === 0) {
            _this14.refreshTable();
            _this14.$message({
              type: 'success',
              message: '删除成功'
            });
          } else {
            _this14.$message({
              type: 'warning',
              message: '删除失败 ' + response.data.msg
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },

    // 表格样式
    cellStyle: function cellStyle(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      return {
        padding: '8px 0',
        color: '#000'
      };
    }
  }
  //
};var infoMixins = {
  methods: {
    // 保存操作 --start
    saveCompanyInfo: function saveCompanyInfo() {
      var _this15 = this;

      this.$refs['ruleForm'].validate(function (valid) {
        if (!valid) {
          _this15.$message({
            message: '请完善信息',
            type: 'warning'
          });
          return;
        }
        _this15.saveData();
      });
    },
    saveData: function saveData() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, key, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  company_id: _this16.$store.state.companyId,
                  is_update_info: 1
                };

                for (key in _this16.ruleForm) {
                  if (_this16.ruleForm[key] !== null) {
                    params[key] = _this16.ruleForm[key];
                  }
                }
                _context.next = 4;
                return _this16.$http.post(__WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* api */].addOrUpdate, params);

              case 4:
                res = _context.sent;

                if (res.data.code === 0) {
                  _this16.$message({ message: '保存成功', type: 'success' });
                } else {
                  _this16.$message({ message: res.data.msg, type: 'warining' });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this16);
      }))();
    }
  }
};



/***/ }),

/***/ "pCDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addOrUpdateForm_vue__ = __webpack_require__("Yh4T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af11815e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addOrUpdateForm_vue__ = __webpack_require__("OVV6");
function injectStyle (ssrContext) {
  __webpack_require__("kvbG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af11815e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addOrUpdateForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af11815e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addOrUpdateForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pS/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util_DataCard__ = __webpack_require__("5NEy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataCard: __WEBPACK_IMPORTED_MODULE_0__Util_DataCard__["a" /* default */]
  },
  data: function data() {
    return {
      title: '',
      visible: false,
      playerOptions: {
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: '',
          src: '' // url地址
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    showVideo: function showVideo(src, title) {
      var _this = this;

      this.visible = true;
      // this.playerOptions.sources[0].src = src
      // this.title = title
      this.$nextTick(function () {
        _this.$refs.videoPlayer.player.src(src);
        _this.$refs.videoPlayer.player.reset();
        _this.title = title;
      });
    }
  }
});

/***/ }),

/***/ "prKM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAYpJREFUSEvVlL8rrmEYxz9fqRNJiezHomSwWJQ6m8GOjjJJJixmvJNBObaDycDgDzCYOJ3yo0yKQQYymGQh+fXVXQ+97+N53ufNk+Lenvu67u/n+j7XfV/ik5c+WZ+vA7DdAqwDNcCApMNK3FfkwHYVcAB0RKIXQKuk2yxIpYBhYDkmVpA0lRtguxk4AeqBa+ARaAKegXZJx+UgmQ5sLwIjkcgQcA5sRd8bkno/DLDdDfwrEugHzoDd4j1JofmJq6wD2/tAZwwQHOwU7QVgW1rDUwG2x4CFWFnBQRwQUuYkTSZZSAREjT0CGisE3IcrnNTwNMAKEBoaX2kOQt6mpJ74gXcA213Af0gcI31Rk/dSejooaa04lgQII6A9RaAAhFe8lBK/BH5KunuNlwBsjwN/sl5nRnxB0sQ7gO2G6IbUlRH4C4Qqp8vkPEVz6jTkvDmwvQr8zqguPKgrYDQjb1vSrzjgBqjN+Xtejz9Jqo4DwryZBX7khDwA85JmSgA5RVOPZ07TvODvD3gBkodyGRqZl2wAAAAASUVORK5CYII="

/***/ }),

/***/ "rjUQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rvCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Util_commonOptions__ = __webpack_require__("oQse");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Util_Search__ = __webpack_require__("JJCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__table1__ = __webpack_require__("k0sn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import {tableMixins} from '@/mixins/qiboMixins'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_6__Util_Search__["a" /* default */],
    table1: __WEBPACK_IMPORTED_MODULE_8__table1__["a" /* default */]
  },
  // mixins: [tableMixins],
  data: function data() {
    var _ref;

    return _ref = {
      type: 1,
      title: "行业领域检查清单",
      industryOptions: __WEBPACK_IMPORTED_MODULE_3__Util_commonOptions__["k" /* industryOptions */], //适用行业类型选项
      departmentData: [], //上传部门选项
      Daterange: [], //上传时间
      searchForm: {
        name: null,
        control_id: null,
        create_department: null
      },
      pagination: true,
      totalCount: null,
      currentPage: 1,
      selectType: 'select',
      dialogVisible: true,
      loading: false,
      jobOptions: [],
      tableData: [],
      treeData: [], // 员工树
      checkedData: null }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'totalCount', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'parent_node_id', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'parent_node_label', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'defaultProps', {
      children: 'children',
      label: 'name'
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'callback', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'job_id', null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'SelectionAll', {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'SelectionTable', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'list', null), _ref;
  },
  mounted: function mounted() {
    this.getList();
    this.getDepartmentTreeList();
  },

  methods: {
    changeType: function changeType() {
      switch (this.type) {
        case 1:
          this.title = '行业领域检查清单';break;
        case 2:
          this.title = '专项检查清单';break;
        case 3:
          this.title = '重大隐患检查清单';break;
        case 4:
          this.title = '网格员检查导则';break;
        case 5:
          this.title = '主体责任检查清单';break;
      }
      this.reset();
      this.getList();
    },

    // treeCheck (val) {
    //   let data = this.$refs['tree'].getCheckedKeys(true)
    //   this.treeId = data.join(',')
    //   this.getList()
    // },

    //多选 --begin
    select: function select(selection, row) {
      for (var key in this.SelectionAll) {
        if (key == row.id) {
          delete this.SelectionAll[key];
          this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
          return;
        }
      }
      this.SelectionAll[row.id] = row;
      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
    },
    selectAll: function selectAll(select) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          if (select.length === 0) {
            delete this.SelectionAll[row.id];
          } else {
            this.SelectionAll[row.id] = row;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.SelectionTable = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.SelectionAll);
    },

    //多选 --end

    currentChange: function currentChange(currentRow) {
      if (currentRow) {
        this.list = currentRow;
      }
    },

    //双击事件
    tableDbEdit: function tableDbEdit() {
      if (this.selectType == 'select') {
        this.save();
      }
    },
    closeForm: function closeForm() {
      this.list = null;
      // this.checkedData = null
      // this.$refs['table'].setCurrentRow()
      // this.$el.parentNode.removeChild(this.$el);
    },
    save: function save() {
      if (this.selectType == 'multiple') {
        this.saveMultiple();
      } else {
        this.saveSingle();
      }
    },
    saveSingle: function saveSingle() {
      if (!this.list) {
        return this.$message({
          type: 'warning',
          message: '请选择清单'
        });
      }
      if (this.callback && typeof this.callback === 'function') {
        this.callback([this.list]);
      }
      this.dialogVisible = false;
    },
    saveMultiple: function saveMultiple() {
      if (this.SelectionTable.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请选择清单'
        });
      }
      if (this.callback && typeof this.callback === 'function') {
        this.callback(this.SelectionTable);
      }
      this.dialogVisible = false;
    },
    showForm: function showForm() {
      this.dialogVisible = true;
    },

    // 获取列表
    getList: function getList(currentPage) {
      var _this = this;

      this.loading = true;
      var params = {
        page_index: 1,
        page_size: 10,
        // control_ids: this.treeId,
        type: this.type
      };
      if (this.pagination) {
        params.page_index = currentPage;
        params.page_size = 10;
      }
      if (this.handleNewParams) {
        var myParams = this.handleNewParams();
        for (var key in myParams) {
          params[key] = myParams[key];
        }
      }
      this.$http.post(__WEBPACK_IMPORTED_MODULE_7__api_api__["a" /* api */]['getCheckTableDBList'], params).then(function (response) {
        _this.tableData = response.data.data;
        if (_this.selectType == 'multiple') {
          _this.$nextTick(function () {
            _this.checkSelect();
          });
        }
        if (_this.pagination && _this.tableData.length > 0) {
          _this.totalCount = response.data.page_info.total_num;
        } else {
          _this.totalCount = 0;
        }
        setTimeout(function () {
          _this.loading = false;
        }, 400);
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 每次刷新时检查是否有选项，并设置已选中
    checkSelect: function checkSelect() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tableData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var row = _step2.value;

          if (this.SelectionAll.hasOwnProperty(row.id)) {
            this.$refs.table.toggleRowSelection(row, true);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },

    //查询-上传部门
    getDepartmentTreeList: function getDepartmentTreeList() {
      var _this2 = this;

      this.$http.post(__WEBPACK_IMPORTED_MODULE_7__api_api__["a" /* api */].getDepartmentTreeList, {}).then(function (res) {
        if (res.data.code == 0) {
          _this2.departmentData = res.data.data;
          _this2.departmentData.forEach(function (v) {
            v.name = '' + v.name;
          });
        }
      });
    },
    search: function search() {
      // this.handleNewParams()
      this.getList();
    },
    handleNewParams: function handleNewParams() {
      var params = {
        // control_ids: this.treeId || null,
        type: this.type
      };
      for (var key in this.searchForm) {
        if (this.searchForm[key]) {
          params[key] = this.searchForm[key];
        }
      }
      if (this.create_department === '') {
        this.create_department = null;
      }
      if (this.Daterange != null && this.Daterange.length != 0) {
        params.begin_time = this.Daterange[0];
        params.end_time = this.Daterange[1];
      } else {
        params.begin_time = null;
        params.end_time = null;
      }
      if (params.control_id) {
        params.control_id = params.control_id[1];
      }
      return params;
    },
    reset: function reset() {
      for (var i in this.searchForm) {
        this.searchForm[i] = null;
      }
      this.Daterange = [];
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.getList(val);
    },
    change: function change(val) {
      var data = this.$refs.departmentTree.getCheckedNodes(true);
      if (data && data.length > 0) {
        this.searchForm.create_department = data[0].data.name;
      } else {
        this.searchForm.create_department = null;
      }
    }
  }
});

/***/ }),

/***/ "ryYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-logo"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"title-wrap"},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.name_Int))])]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("（监管端）")])])]),_vm._v(" "),_c('div',{staticClass:"header-user"},[_c('el-dropdown',{attrs:{"placement":"bottom"},on:{"command":_vm.handleUserDropdownCommand}},[_c('span',{staticClass:"el-dropdown-link header-dropdown-link"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('i',{staticClass:"el-icon-user",staticStyle:{"font-size":"18px","margin-right":"5px"}}),_vm._v("\n          "+_vm._s(_vm.userInfo.username)+"\n          "),_c('i',{staticClass:"el-icon-caret-bottom",staticStyle:{"font-size":"12px","margin-left":"5px"}})])]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"OperationManual"}},[_vm._v("操作文档")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"AccountInfo"}},[_vm._v("账号信息")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"ChangePassword"}},[_vm._v("修改密码")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"Logout","divided":""}},[_vm._v("退出登录")])],1)],1)],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"nav-bar"},_vm._l((_vm.routesArr),function(item,index){return _c('div',{key:item.title,staticClass:"menu-item",class:_vm.currentIndex.indexOf(item.path) > -1 ? 'current-item' : '',on:{"click":function($event){return _vm.itemClick(index, item)}}},[(item.meta.icon)?_c('i',{class:item.meta.icon,staticStyle:{"font-size":"18px"}}):(item.meta.img)?_c('img',{staticStyle:{"height":"20px"},attrs:{"src":item.meta.img}}):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"white-space":"nowrap","font-size":"12px"}},[_vm._v(_vm._s(item.meta.title))])])}),0)]),_vm._v(" "),_c('PasswordForm',{ref:"passwordForm"}),_vm._v(" "),_c('InfoForm',{ref:"InfoForm"}),_vm._v(" "),_c('el-dialog',{attrs:{"append-to-body":"","title":"操作文档","visible":_vm.showEchartDialog,"width":"85%"},on:{"update:visible":function($event){_vm.showEchartDialog=$event}}},[_c('Echart',{ref:"Echart"})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrap"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("dLd/")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sPX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nCqF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1968bcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("3pfp");
function injectStyle (ssrContext) {
  __webpack_require__("KNaa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1968bcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1968bcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sSDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("fJrK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208f366d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("d6JS");
function injectStyle (ssrContext) {
  __webpack_require__("kSnM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-208f366d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_208f366d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "swh5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 13,
  path: '/analysis',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/analysis/analysisAll/companyCollection',
  name: 'Analysis',
  isHead: true,
  meta: {
    title: '统计分析',
    icon: 'el-icon-data-analysis'
  },
  children: [{
    path: 'analysisAll',
    component: function component() {
      return __webpack_require__.e/* import() */(189).then(__webpack_require__.bind(null, "NUY8"));
    },
    name: 'AnalysisAll',
    meta: { title: '统计分析', close: false },
    children: [{
      path: 'companyCollection',
      component: function component() {
        return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "pAz+"));
      },
      name: 'companyCollection',
      meta: { title: '企业信息采集率', next: '/analysis/analysisAll/informationCollection', close: false }
    }, {
      path: 'informationCollection',
      component: function component() {
        return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "zHjI"));
      },
      name: 'informationCollection',
      meta: { title: '企业信息采集率二', next: '/analysis/analysisAll/scaleStatistical', close: false }
    }, {
      path: 'scaleStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "pzWp"));
      },
      name: 'scaleStatistical',
      meta: { title: '企业规模统计', next: '/analysis/analysisAll/industryStatistical', close: false }
    }, {
      path: 'industryStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, "QRSe"));
      },
      name: 'industryStatistical',
      meta: { title: '行业类型统计', next: '/analysis/analysisAll/starStatistical', close: false }
    }, {
      path: 'starStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "MPSu"));
      },
      name: 'starStatistical',
      meta: { title: '丰泽区星级评定统计', next: '/analysis/analysisAll/userLoginStatistical', close: false }
    }, {
      path: 'userLoginStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "jU2C"));
      },
      name: 'userLoginStatistical',
      meta: { title: '企业端用户登录情况统计表', next: '/analysis/analysisAll/superviseLoginStatistical', close: false }
    }, {
      path: 'superviseLoginStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "uqFR"));
      },
      name: 'superviseLoginStatistical',
      meta: { title: '监管端用户登录情况统计表', next: '/analysis/analysisAll/threeList', close: false }
    }, {
      path: 'threeList',
      name: 'threeList',
      component: function component() {
        return __webpack_require__.e/* import() */(155).then(__webpack_require__.bind(null, "to0b"));
      },
      meta: { title: '企业三张清单进度表', next: '/analysis/analysisAll/dynamicMonitoring', close: true }
    }, {
      path: 'dynamicMonitoring',
      name: 'dynamicMonitoring',
      component: function component() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "lts+"));
      },
      meta: { title: '四色安全风险动态监督', next: '/analysis/analysisAll/hiddenStatistical', close: true }
    }, {
      path: 'promotion',
      name: 'promotion',
      component: function component() {
        return __webpack_require__.e/* import() */(158).then(__webpack_require__.bind(null, "Pvpv"));
      },
      meta: { title: '安全生产标准化提升', next: '/analysis/analysisAll/threeList', close: true }
    }, {
      path: 'hiddenStatistical',
      name: 'hiddenStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "ZECu"));
      },
      meta: { title: '隐患排查统计', next: '/analysis/analysisAll/performanceStatistical', close: true }
    }, {
      path: 'performanceStatistical',
      name: 'performanceStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "Q/zo"));
      },
      meta: { title: '重大隐患专项绩效统计', next: '/analysis/analysisAll/specialPerformanceStatistical', close: true }
    }, {
      path: 'specialPerformanceStatistical',
      name: 'specialPerformanceStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(157).then(__webpack_require__.bind(null, "tOPp"));
      },
      meta: { title: '重大隐患专项绩效统计二', next: '/analysis/analysisAll/safeStatistical', close: true }
    }, {
      path: 'safeStatistical',
      name: 'safeStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "Fc96"));
      },
      meta: { title: '安全风险管控统计', next: '/analysis/analysisAll/superviseStatistical', close: true }
    }, {
      path: 'superviseStatistical',
      name: 'superviseStatistical',
      component: function component() {
        return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "j4gL"));
      },
      meta: { title: '监督检查隐患统计', next: '/analysis/analysisAll/nineBaseInfoReport', close: true }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "tYbs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 11,
  path: '/mechanism',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/mechanism/mechanismAll/intermediary',
  name: 'mechanism',
  isHead: true,
  meta: {
    title: '服务机构管理',
    img: __webpack_require__("nqDt")
  },
  children: [{
    path: 'mechanismAll',
    name: 'mechanismAll',
    component: function component() {
      return __webpack_require__.e/* import() */(167).then(__webpack_require__.bind(null, "ghZp"));
    },
    meta: { title: '服务机构管理', close: false },
    children: [{
      path: 'intermediary',
      name: 'intermediary',
      component: function component() {
        return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "LIyo"));
      },
      meta: { title: '机构管理', close: false }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uNeA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Util_getUid_js__ = __webpack_require__("5qJ+");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: null,
      passwordType: 'password',
      port: null,
      ruleForm: {
        userName: '',
        password: '',
        ca_key: '',
        ca_code: ''
      },
      rules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        ca_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loginError: null
    };
  },

  computed: {
    bgImage: function bgImage() {
      return __webpack_require__("Yfqv");
      // let hostname = window.location.hostname
      // let port = window.location.port
      // this.port = port
      // if(hostname == 'localhost' || hostname == '222.77.0.146'){
      //   if(port == 9010){
      //     return require('@/assets/img/login/bgfz.jpg')
      //   }else if(port == 9014) {
      //     return require('@/assets/img/login/bgnanan.jpg')
      //   }else{
      //     return require('@/assets/img/login/bg.jpg')
      //   }
      // }else{
      //   return require('@/assets/img/login/bg_lq.jpg')
      // }
    }
  },
  mounted: function mounted() {
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__vuex_types__["GETSYSSETTINGS"]);
    this.getId();
  },

  methods: {
    showPwd: function showPwd() {
      var _this = this;

      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    getId: function getId() {
      this.ruleForm.ca_key = Object(__WEBPACK_IMPORTED_MODULE_7__Util_getUid_js__["a" /* default */])();
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$store.commit('setUserInfo', null);
      this.loginError = null;
      var self = this;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_6__vuex_types__["SESSION_ID"], null);
      self.$refs[formName].validate(function (valid) {
        if (!valid) return;
        _this2.$http.post('/apps/admin/loginByPassword', { 'username': _this2.ruleForm.userName, 'password': __WEBPACK_IMPORTED_MODULE_5_blueimp_md5___default()(_this2.ruleForm.password), 'ca_key': _this2.ruleForm.ca_key, 'ca_code': _this2.ruleForm.ca_code }).then(function (response) {
          if (response.data.code === 0) {
            var permission = ['/home', '/enterpriseManagement', '/standardization', '/riskManagement', '/hiddenCheck', '/riskWork', '/educationalTraining', '/emergencyManagement', '/analysis', '/examine', '/dataV', '/setting', '/insurance', '/nineSmallPlace'];
            var per = null;
            if (response.data.data.auth_list) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(permission), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var item = _step.value;

                  if (response.data.data.auth_list.indexOf(item) > -1) {
                    per = item;
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
            if (!per) {
              _this2.$message({
                type: 'error',
                message: '请联系管理员分配权限'
              });
              return;
            }
            var sessionId = response.data.data.token;
            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_6__vuex_types__["SESSION_ID"], sessionId);
            // this.$message({
            //   message: '登录成功',
            //   type: 'success'
            // })
            _this2.getAllDictionary(response.data.data, per);
            _this2.$store.dispatch('getBaseDepartmentTypeList');
          } else {
            // this.loginError = response.data.msg
            _this2.$message.error(response.data.msg);
            _this2.getId();
          }
        });
      });
    },
    register: function register() {
      this.$refs['registerForm'].showForm();
    },
    getAllDictionary: function getAllDictionary(userInfo, per) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, data, baseIndustryCode, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$http.post(__WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* api */].dictionary);

              case 2:
                res = _context.sent;

                if (res.data.code === 0) {
                  data = res.data.data;
                  baseIndustryCode = data.baseIndustryCode;

                  localStorage.setItem('baseIndustryCode', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(baseIndustryCode));
                  localStorage.setItem('baseArea', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.baseArea));
                  url = per;

                  _this3.$router.push(url);
                }

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    operationManual: function operationManual() {
      window.open('https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_control_fuzhou/doc/%E5%AE%89%E5%85%A8%E9%A3%8E%E9%99%A9%E7%AE%A1%E6%8E%A7%E5%B9%B3%E5%8F%B0%28%E4%BC%81%E4%B8%9A%E7%AB%AF%29%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8Cv1.0.pdf');
    },
    uploadGoogle: function uploadGoogle() {
      // window.location.href = 'https://dl.google.com/tag/s/appguid%3D%7B8A69D345-D564-463C-AFF1-A69D9E530F96%7D%26iid%3D%7B6DDC8673-CB76-1680-219A-434B968C6B54%7D%26lang%3Dzh-CN%26browser%3D4%26usagestats%3D1%26appname%3DGoogle%2520Chrome%26needsadmin%3Dprefers%26ap%3Dx64-stable-statsdef_1%26installdataindex%3Dempty/update2/installers/ChromeSetup.exe'
      window.open('https://www.google.cn/chrome/');
    },
    changePort: function changePort() {
      window.location.href = this.$store.getters.sysUrl.COMPANY_PLATFORM_URL;
    },
    gotoMechanism: function gotoMechanism() {
      window.location.href = 'http://222.77.0.146:9015/login';
    }
  }
});

/***/ }),

/***/ "uezh":
/***/ (function(module, exports) {

module.exports = T;

/***/ }),

/***/ "vOrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__ = __webpack_require__("bRx8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47645b7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__ = __webpack_require__("M4wK");
function injectStyle (ssrContext) {
  __webpack_require__("c9nE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47645b7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47645b7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vazN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 9,
  path: '/emergencyManagement',
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: '/emergencyManagement/emergencyList/energencyMaterials',
  name: 'emergencyManagement',
  isHead: true,
  meta: {
    title: '应急管理',
    img: __webpack_require__("Y2B9")
  },
  children: [{
    path: 'emergencyList',
    component: function component() {
      return __webpack_require__.e/* import() */(183).then(__webpack_require__.bind(null, "s2eS"));
    },
    name: 'emergencyManagement',
    meta: { title: '应急管理', close: false },
    children: [{
      path: 'energencyMaterials',
      component: function component() {
        return __webpack_require__.e/* import() */(152).then(__webpack_require__.bind(null, "7h8i"));
      },
      name: 'energencyMaterials',
      meta: { title: '企业应急预案管理', next: '/emergencyManagement/emergencyList/energencyDrill', close: false }
    }, {
      path: 'energencyDrill',
      component: function component() {
        return __webpack_require__.e/* import() */(153).then(__webpack_require__.bind(null, "WzLa"));
      },
      name: 'energencyDrill',
      meta: { title: '企业应急物资管理', next: '/emergencyManagement/emergencyList/energencyPreplan', close: false }
    }, {
      path: 'energencyPreplan',
      component: function component() {
        return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "nL5z"));
      },
      name: 'Preplan',
      meta: { title: '企业应急演练管理', next: '/emergencyManagement/emergencyList/energencyMaterials', close: false }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "w2XR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectArea_vue__ = __webpack_require__("4pOT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8df44ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectArea_vue__ = __webpack_require__("FHe3");
function injectStyle (ssrContext) {
  __webpack_require__("zIX5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f8df44ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8df44ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wQab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: String,
    download: String,
    look: String,
    type: {
      type: String,
      default: 'doc'
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    showVideo: function showVideo() {
      this.$emit('click', this.download, this.title);
    }
  }
});

/***/ }),

/***/ "xGIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__ = __webpack_require__("QZ7T");


var home = {
  isShow: true,
  index: 12,
  path: "/nineSmallPlace",
  component: __WEBPACK_IMPORTED_MODULE_0__components_frame_Home__["a" /* default */],
  redirect: "/nineSmallPlace/nineSmallPlace/nineHomePage",
  name: "nineSmallPlace",
  isHead: true,
  meta: {
    title: "九小场所",
    icon: "el-icon-s-cooperation"
  },
  children: [{
    path: "nineSmallPlace",
    component: function component() {
      return __webpack_require__.e/* import() */(166).then(__webpack_require__.bind(null, "ivCI"));
    },
    name: "nineSmallPlace",
    meta: { title: "九小场所", close: false },
    children: [{
      path: "nineHomePage",
      name: "nineHomePage",
      component: function component() {
        return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, "JlS9"));
      },
      meta: {
        title: "首页",
        next: "/nineSmallPlace/nineSmallPlace/baseInfo",
        close: false
      }
    }, {
      path: "baseInfo",
      name: "baseInfo",
      component: function component() {
        return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, "MqIy"));
      },
      meta: {
        title: "场所基本信息",
        next: "/nineSmallPlace/nineSmallPlace/dailyCheckList",
        close: false
      }
    }, {
      path: "inspectionRecords",
      name: "inspectionRecords",
      component: function component() {
        return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, "ljIt"));
      },
      meta: { title: "场所自查-巡查记录", close: false }
    }, {
      path: "hiddenDanger",
      name: "hiddenDanger",
      component: function component() {
        return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, "6WjU"));
      },
      meta: { title: "场所自查-隐患清单", close: false }
    }, {
      path: "inspection",
      name: "inspection",
      component: function component() {
        return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, "LXXT"));
      },
      meta: { title: "监督检查-巡查记录", close: false }
    }, {
      path: "hiddenDangerList",
      name: "hiddenDangerList",
      component: function component() {
        return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, "kzmU"));
      },
      meta: { title: "监督检查-隐患清单", close: false }
    }, {
      path: "inspectors",
      name: "inspectors",
      component: function component() {
        return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "O4R2"));
      },
      meta: {
        title: "检查人员账号管理",
        close: false
      }
    }, {
      path: "safeProduction",
      name: "safeProduction",
      component: function component() {
        return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, "hA/x"));
      },
      meta: {
        title: "安全生产检查清单",
        close: false
      }
    }, {
      path: "standardGuide",
      name: "standardGuide",
      component: function component() {
        return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, "o4Q9"));
      },
      meta: {
        title: "标准化运行提升指南",
        close: false
      }
    }, {
      path: "complianceDetails",
      name: "complianceDetails",
      component: function component() {
        return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, "P4nb"));
      },
      meta: {
        title: "标准化达标细则",
        close: false
      }
    }, {
      path: "gridOperator",
      name: "gridOperator",
      component: function component() {
        return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, "7TZK"));
      },
      meta: {
        title: "网格员检查原则",
        close: false
      }
    }, {
      path: "dailyCheckList",
      name: "dailyCheckList",
      component: function component() {
        return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, "/WGd"));
      },
      meta: {
        title: "检查清单维护",
        next: "/nineSmallPlace/nineSmallPlace/hiddenDangerBank",
        close: false
      }
    }, {
      path: "hiddenDangerBank",
      name: "hiddenDangerBank",
      component: function component() {
        return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, "LuKj"));
      },
      meta: {
        title: "场所隐患库",
        next: "/nineSmallPlace/nineSmallPlace/nineBaseInfoReport",
        close: false
      }
    }, {
      path: "nineBaseInfoReport",
      name: "nineBaseInfoReport",
      component: function component() {
        return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, "8+BK"));
      },
      meta: {
        title: "九小场所基本信息上报情况",
        next: "/nineSmallPlace/nineSmallPlace/nineTypeStatistics",
        close: true
      }
    }, {
      path: "nineTypeStatistics",
      name: "nineTypeStatistics",
      component: function component() {
        return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, "1S76"));
      },
      meta: {
        title: "九小场所类型统计表",
        next: "/nineSmallPlace/nineSmallPlace/nineSelfInspectionHidden",
        close: true
      }
    }, {
      path: "nineSelfInspectionHidden",
      name: "nineSelfInspectionHidden",
      component: function component() {
        return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, "QBSu"));
      },
      meta: { title: "九小场所自查隐患统计表", close: true }
    }, {
      path: "hazardStatisticsTable",
      name: "hazardStatisticsTable",
      component: function component() {
        return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, "D6ek"));
      },
      meta: { title: "九小场所监督检查隐患统计表", close: true }
    }]
  }]
};

/* harmony default export */ __webpack_exports__["default"] = (home);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xOqt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "xe4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"height":"28px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.showImportUserDlg}},[_vm._v(_vm._s(_vm.btntitle ? _vm.btntitle : '导入'))]),_vm._v(" "),_c('ImportUserFDlg',{ref:"importUserDlg",attrs:{"params":_vm.params,"title":_vm.title,"download":_vm.download,"href":_vm.href,"url":_vm.url,"prompt":_vm.prompt},on:{"refreshTable":_vm.search}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yd2P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"fl-wrap",staticStyle:{"padding":"10px"}},[_c('DataCard',{staticStyle:{"width":"250px","margin-right":"25px"},attrs:{"download":"https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/file/%E6%B3%89%E5%B7%9E%E5%B8%82%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E6%A0%87%E5%87%86%E5%8C%96%E6%99%BA%E6%85%A7%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C%EF%BC%88%E7%9B%91%E7%AE%A1%E7%AB%AF%EF%BC%89202304.pdf","title":"泉州市安全生产标准化智慧管理平台监管端操作说明书"}}),_vm._v(" "),_c('DataCard',{staticStyle:{"width":"250px","margin-right":"25px"},attrs:{"download":"https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/doc/20230828%E9%87%8D%E5%A4%A7%E9%9A%90%E6%82%A3%E9%9A%90%E6%82%A3%E6%8E%92%E6%9F%A5%E4%B8%8A%E6%8A%A5%E6%91%98%E7%89%8C%E9%94%80%E6%A1%88%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%E4%B9%A6(2).pdf","title":"泉州市安全生产标准化智慧管理平台重大隐患自查上报摘牌销案操作说明书"}}),_vm._v(" "),_c('DataCard',{staticStyle:{"width":"250px","margin-right":"25px"},attrs:{"type":"video","download":"https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/doc/20231010%E5%8A%A0%E5%BC%BA%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E6%A0%87%E5%87%86%E5%8C%96%E5%BB%BA%E8%AE%BE%E6%8E%A8%E8%BF%9B%E4%BC%81%E4%B8%9A%E4%B8%BB%E4%BD%93%E8%B4%A3%E4%BB%BB%E8%90%BD%E5%88%B0%E5%AE%9E%E5%A4%84.mp4","title":"20230707加强安全生产标准化建设推进企业主体责任落到实处"}}),_vm._v(" "),_c('DataCard',{staticStyle:{"width":"250px","margin-right":"25px"},attrs:{"download":"https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/doc/20240305%E4%BC%81%E4%B8%9A%E5%9F%BA%E6%9C%AC%E4%BF%A1%E6%81%AF%E5%A4%8D%E6%A0%B8%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf","title":"20240305企业基本信息复核操作说明书"}}),_vm._v(" "),_c('DataCard',{staticStyle:{"width":"250px","margin-right":"25px"},attrs:{"download":"https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_qz/docx/%E4%B9%9D%E5%B0%8F%E5%9C%BA%E6%89%80%E5%AE%89%E5%85%A8%E7%94%9F%E4%BA%A7%E6%A0%87%E5%87%86%E5%8C%96%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%E4%B9%A620240909.rar","title":"20240909九小场所安全生产标准化管理平台操作说明书"}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"input_video",attrs:{"title":_vm.title,"close-on-click-modal":false,"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-lg mg-bt-md"},[_c('span',[_vm._v("操作帮助")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z2xV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "zIX5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTUO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1]);


// WEBPACK FOOTER //
// static/js/app.99a0c5f5e565634493c1.js